import { Quiz } from '@/types/quiz';

export const quizAll: Quiz[] = [
  {
    quizId: '1',
    question: '1巻で荒木飛呂彦は作品のテーマを何だとコメントしている？',
    options: [
      { optionId: '0', text: '生きること' },
      { optionId: '1', text: '生命賛歌' },
      { optionId: '2', text: '人間賛歌' },
      { optionId: '3', text: 'ホラー・アドベンチャー' },
      { optionId: '4', text: '友情と信念' },
    ],
  },
  {
    quizId: '2',
    question: '擬音で有名なジョジョの奇妙な冒険。\n最初に登場した擬音は？',
    options: [
      { optionId: '0', text: 'ドッギャァーン' },
      { optionId: '1', text: 'ドッガァ！' },
      { optionId: '2', text: 'ドドドドド' },
      { optionId: '3', text: 'ゴォォ' },
      { optionId: '4', text: 'グォーン' },
    ],
  },
  {
    quizId: '3',
    question:
      '第1部より問題です。\nディオ・ブランドーが初登場時に読んでいた本のタイトルは？',
    options: [
      { optionId: '0', text: 'GoRGEOUS IRENE' },
      { optionId: '1', text: 'MaShonen Beauty' },
      { optionId: '2', text: 'busou poker' },
      { optionId: '3', text: 'Raiho-sha BAOH' },
      { optionId: '4', text: 'Jump' },
    ],
  },
  {
    quizId: '4',
    question:
      '第1部より問題です。\n事故でジョナサン・ジョースターの母親が亡くなったのは何年のこと？',
    options: [
      { optionId: '0', text: '1868年' },
      { optionId: '1', text: '1858年' },
      { optionId: '2', text: '1862年' },
      { optionId: '3', text: '1865年' },
      { optionId: '4', text: '1870年' },
    ],
  },
  {
    quizId: '5',
    question: 'ディオ・ブランドーの父親、ダリオ・ブランドーは何年の生まれ？',
    options: [
      { optionId: '0', text: '1827年' },
      { optionId: '1', text: '1815年' },
      { optionId: '2', text: '1819年' },
      { optionId: '3', text: '1824年' },
      { optionId: '4', text: '1831年' },
    ],
  },
  {
    quizId: '6',
    question: '第1部より問題です。\n主人公、ジョナサン・ジョースターの綴りは？',
    options: [
      { optionId: '0', text: 'Jonathan Joester' },
      { optionId: '1', text: 'Jonasan Joester' },
      { optionId: '2', text: 'Jonasun Joester' },
      { optionId: '3', text: 'Jonatham Joester' },
      { optionId: '4', text: 'Jonasam Joester' },
    ],
  },
  {
    quizId: '7',
    question:
      '第1部、有名な誤植より問題です。\n「なっ！ 何をするだァ―――――ッ ゆるさんッ！」\nどのような場面での台詞？',
    options: [
      { optionId: '0', text: '愛犬ダニーをディオに蹴られたとき' },
      { optionId: '1', text: '親指を目の中につっこまれたとき' },
      { optionId: '2', text: '時計を勝手に持ち出されたとき' },
      { optionId: '3', text: 'エレナにキスをしたことを知ったとき' },
      { optionId: '4', text: 'ダニーが焼け死んだとき' },
    ],
  },
  {
    quizId: '8',
    question: '第1部より問題です。\nディオが犬嫌いな理由は？',
    options: [
      { optionId: '0', text: '人間にへーこらする態度に虫唾が走るから' },
      { optionId: '1', text: '怖いから' },
      { optionId: '2', text: '汚らしいから' },
      { optionId: '3', text: '自然を忘れて飼いならされているから' },
      { optionId: '4', text: 'ダリオが犬好きだったから' },
    ],
  },
  {
    quizId: '9',
    question:
      '第1部より問題です。\n作法がなっていないからと食事を抜かれたジョナサン、部屋のテーブルに置いてあった食べ物は？',
    options: [
      { optionId: '0', text: '食べ残しのチョコ' },
      { optionId: '1', text: '食べ残しのクッキー' },
      { optionId: '2', text: '食べ残しのビスケット' },
      { optionId: '3', text: '食べ残しのパン' },
      { optionId: '4', text: 'ダニーのエサ' },
    ],
  },
  {
    quizId: '10',
    question:
      '第1部より問題です。\n草っ原で行われていたボクシング、ディオが来る前のチャンピオンは誰？',
    options: [
      { optionId: '0', text: 'マーク・ワトキン' },
      { optionId: '1', text: 'ジョナサン・ジョースター' },
      { optionId: '2', text: 'カール・パーソン' },
      { optionId: '3', text: 'ジェイミー・マーレイ' },
      { optionId: '4', text: 'ロバート・ライス' },
    ],
  },
  {
    quizId: '11',
    question: '第1部より問題です。\nディオがエリナにキスをした時の擬音は？',
    options: [
      { optionId: '0', text: 'ズキュウウウン' },
      { optionId: '1', text: 'ズキュ―――ン' },
      { optionId: '2', text: 'ズッキュ――ン' },
      { optionId: '3', text: 'バキュ――ン' },
      { optionId: '4', text: 'ズッキュウウウン' },
    ],
  },
  {
    quizId: '12',
    question:
      '第1部より問題です。\nダニーがジョースター家に連れてこられたのは、ジョナサンが何歳の時？',
    options: [
      { optionId: '0', text: '5歳' },
      { optionId: '1', text: '4歳' },
      { optionId: '2', text: '6歳' },
      { optionId: '3', text: '7歳' },
      { optionId: '4', text: '8歳' },
    ],
  },
  {
    quizId: '13',
    question: '第1部より問題です。\nダニーが焼却炉で焼かれた際の鳴き声は？',
    options: [
      { optionId: '0', text: 'KYYYAA―N' },
      { optionId: '1', text: 'Whooo―N' },
      { optionId: '2', text: 'CUUOOOONN' },
      { optionId: '3', text: 'BAOHHHHHH' },
      { optionId: '4', text: 'WAWWWW' },
    ],
  },
  {
    quizId: '14',
    question: '第1部より問題です。\nジョナサンとディオの通っていた大学はどこ？',
    options: [
      { optionId: '0', text: 'ヒュー・ハドソン' },
      { optionId: '1', text: 'アンソニー・ハーヴェイ' },
      { optionId: '2', text: 'ノエル・カワード' },
      { optionId: '3', text: 'オックスフォード' },
      { optionId: '4', text: 'ロイヤル・ラッセル' },
    ],
  },
  {
    quizId: '15',
    question:
      '第1部、ワンチェンの台詞より問題です。\nディオと同じく耳に3つのほくろを持った、ワンチェンの祖国の人間、彼は何歳まで生きた？',
    options: [
      { optionId: '0', text: '183歳' },
      { optionId: '1', text: '14歳' },
      { optionId: '2', text: '57歳' },
      { optionId: '3', text: '100歳' },
      { optionId: '4', text: '145歳' },
    ],
  },
  {
    quizId: '16',
    question:
      '第1部より問題です。\n石仮面を持ち出すためにディオがジョナサンの部屋に侵入した時刻は？',
    options: [
      { optionId: '0', text: '1時' },
      { optionId: '1', text: '0.104166666666667' },
      { optionId: '2', text: '0.145833333333333' },
      { optionId: '3', text: '4時' },
      { optionId: '4', text: '6時' },
    ],
  },
  {
    quizId: '17',
    question:
      '第1部より問題です。\nジョナサンが東洋の毒薬の証拠と解毒剤を手に入れるために訪れた「オウガーストリート」の漢字表記は？',
    options: [
      { optionId: '0', text: '食屍鬼街' },
      { optionId: '1', text: '食人鬼街' },
      { optionId: '2', text: '煙魔鬼街' },
      { optionId: '3', text: '死累鬼街' },
      { optionId: '4', text: '死人鬼街' },
    ],
  },
  {
    quizId: '18',
    question:
      '第1部より問題です。\nジョージ・ジョースターは亡き妻の指輪を何指にはめていた？',
    options: [
      { optionId: '0', text: '小指' },
      { optionId: '1', text: '親指' },
      { optionId: '2', text: '人差し指' },
      { optionId: '3', text: '中指' },
      { optionId: '4', text: '薬指' },
    ],
  },
  {
    quizId: '19',
    question:
      '第1部より問題です。\nダリオ・ブランドーが盗難の罪状で捕らえられていたのはどこ？',
    options: [
      { optionId: '0', text: 'スコットランドヤード' },
      { optionId: '1', text: 'ウッドストリート' },
      { optionId: '2', text: 'ダンファームリン' },
      { optionId: '3', text: 'プレストウィック' },
      { optionId: '4', text: 'グレトナ・グリーン' },
    ],
  },
  {
    quizId: '20',
    question:
      '第1部、ディオの台詞\n「策を弄すれば弄するほど、人間には限界があるのだよ」\nに対するジョナサンの台詞\n「『策』ではないッ！ 『○○』だ!!」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '勇気' },
      { optionId: '1', text: '知恵' },
      { optionId: '2', text: '努力' },
      { optionId: '3', text: '正義' },
      { optionId: '4', text: '力' },
    ],
  },
  {
    quizId: '21',
    question:
      '第1部より問題です。\n燃え上がっている屋敷でディオの体を貫いた、ジョースター家の守護神は？',
    options: [
      { optionId: '0', text: '慈愛の女神像' },
      { optionId: '1', text: '幸運の女神像' },
      { optionId: '2', text: '青銅の騎士像' },
      { optionId: '3', text: '正義の騎士像' },
      { optionId: '4', text: '母愛の女神像' },
    ],
  },
  {
    quizId: '22',
    question:
      '第1部より問題です。\nエリナ・ペンドルトンが父の仕事の関係で越していた国は？',
    options: [
      { optionId: '0', text: 'インド' },
      { optionId: '1', text: 'ドイツ' },
      { optionId: '2', text: '中国' },
      { optionId: '3', text: 'アメリカ' },
      { optionId: '4', text: 'ニュージーランド' },
    ],
  },
  {
    quizId: '23',
    question: '第1部より問題です。\nウィル・A・ツェペリのクシャミの音は？',
    options: [
      { optionId: '0', text: 'ハブショ' },
      { optionId: '1', text: 'ハクショッ' },
      { optionId: '2', text: 'ブアックション' },
      { optionId: '3', text: 'ヘクチッ' },
      { optionId: '4', text: 'グシャン' },
    ],
  },
  {
    quizId: '24',
    question: '第1部より問題です。\n呼吸が起こす波紋の力、東洋人は何と呼ぶ？',
    options: [
      { optionId: '0', text: '仙道' },
      { optionId: '1', text: '気' },
      { optionId: '2', text: '流波' },
      { optionId: '3', text: '奇跡の息吹' },
      { optionId: '4', text: '波紋' },
    ],
  },
  {
    quizId: '25',
    question:
      '有名な擬音の一つ『メメタァ』\n一部では波紋エネルギーで何を叩く際に使われた？',
    options: [
      { optionId: '0', text: 'カエル越しの岩' },
      { optionId: '1', text: 'ネズミ越しの岩' },
      { optionId: '2', text: 'ジョナサン越しの岩' },
      { optionId: '3', text: '魚越しの岩' },
      { optionId: '4', text: 'モグラ越しの岩' },
    ],
  },
  {
    quizId: '26',
    question:
      '第1部より問題です。\nロンドンから馬で南へまる1日行った先にある「風の騎士たちの町(ウィンドナイツ・ロット)」の人口はディオが訪れる前の段階では囚人を含めて何人？',
    options: [
      { optionId: '0', text: '517人' },
      { optionId: '1', text: '87人' },
      { optionId: '2', text: '122人' },
      { optionId: '3', text: '853人' },
      { optionId: '4', text: '910人' },
    ],
  },
  {
    quizId: '27',
    question:
      '第1部より問題です。\nロンドンから馬で南へまる1日、馬車街道にある長さ約300mのトンネルに錆びた剣は何故刺さっている？',
    options: [
      { optionId: '0', text: '秘密の通路へのスイッチとして' },
      { optionId: '1', text: '分からない' },
      { optionId: '2', text: '中世の修練場の一つだったため、その名残' },
      { optionId: '3', text: 'トンネルの中間地点の印' },
      { optionId: '4', text: 'ジャック・ザ・リパーが目印に刺した' },
    ],
  },
  {
    quizId: '28',
    question:
      '第1部、ウィル・A・ツェペリの台詞\n「人間賛歌は『○○』の賛歌ッ!!」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '勇気' },
      { optionId: '1', text: '生命' },
      { optionId: '2', text: '感情' },
      { optionId: '3', text: '絆' },
      { optionId: '4', text: '波紋' },
    ],
  },
  {
    quizId: '29',
    question:
      '第1部より問題です。\n次の内ツェペリがジャック・ザ・リッパーに対し放った攻撃は？',
    options: [
      { optionId: '0', text: '仙道波蹴(せんどうウェーブキック)' },
      { optionId: '1', text: '仙道波紋疾走(せんどうはもんオーバードライブ)' },
      {
        optionId: '2',
        text: '山吹色の波紋疾走(サンライトイエローオーバードライブ)',
      },
      { optionId: '3', text: 'ズームパンチ' },
      { optionId: '4', text: '緋色の波紋疾走(スカーレッドオーバードライブ)' },
    ],
  },
  {
    quizId: '30',
    question: '「波紋探知機」とは何のこと？',
    options: [
      { optionId: '0', text: 'ワイン' },
      { optionId: '1', text: 'エイジャの赤石' },
      { optionId: '2', text: 'アメリカンクラッカー' },
      { optionId: '3', text: '波紋使いの肉体' },
      { optionId: '4', text: '石仮面' },
    ],
  },
  {
    quizId: '31',
    question:
      '第1部より問題です。\n全財産が入ったカバンを盗んだポコ、彼を捕まえるため岩山に波紋疾走を流したジョナサンの落下予想地点に比べツェペリの予想は？',
    options: [
      { optionId: '0', text: '左へ2m' },
      { optionId: '1', text: '前へ4m' },
      { optionId: '2', text: '右へ1m' },
      { optionId: '3', text: '後ろへ3m' },
      { optionId: '4', text: '右へ5m' },
    ],
  },
  {
    quizId: '32',
    question:
      '第1部より問題です。\nスピードワゴンが世界中を旅して得た知識。\n凍傷にかかった時にアザラシの肉の体内に入って治していた民族は？',
    options: [
      { optionId: '0', text: 'エスキモー' },
      { optionId: '1', text: 'チュクチ' },
      { optionId: '2', text: 'コリャーク' },
      { optionId: '3', text: 'ニヴフ' },
      { optionId: '4', text: 'ヴェプス' },
    ],
  },
  {
    quizId: '33',
    question:
      '作者である荒木飛呂彦が火事の時一つだけ持ち出せるとしたらそれは何とコメントしている？',
    options: [
      { optionId: '0', text: '日記帳' },
      { optionId: '1', text: '貴重品' },
      { optionId: '2', text: 'こせき先生のサイン' },
      { optionId: '3', text: '執筆道具' },
      { optionId: '4', text: '特に何もない' },
    ],
  },
  {
    quizId: '34',
    question:
      '第1部より問題です。\nブラフォードの長い髪を第3の手として振り回す技「死髪舞剣」の読みは？',
    options: [
      { optionId: '0', text: 'ダンス・マカブヘアー' },
      { optionId: '1', text: 'ダンス・ソードヘアー' },
      { optionId: '2', text: 'ダンス・カットドロップヘアー' },
      { optionId: '3', text: 'ダンス・マリオネット' },
      { optionId: '4', text: 'ダンス・マニップ・ヘアー' },
    ],
  },
  {
    quizId: '35',
    question:
      '第1部より問題です。\n中世に行われた訓練「77の輝輪」、その成功者として間違っているのは？',
    options: [
      { optionId: '0', text: 'ミカミニック' },
      { optionId: '1', text: 'ブラフォード' },
      { optionId: '2', text: 'カイネギス' },
      { optionId: '3', text: 'アイクマン' },
      { optionId: '4', text: 'ウィンザレオ' },
    ],
  },
  {
    quizId: '36',
    question:
      '第1部より問題です。\n『ブ厚い鉄の扉に流れ弾丸のあたったような音』\n一体何の音？',
    options: [
      { optionId: '0', text: '波紋の流れる音' },
      { optionId: '1', text: 'タルカスが壁に突っ込んだ音' },
      { optionId: '2', text: '刃が骨に達した音' },
      { optionId: '3', text: 'ダニーが焼却炉の中からブツかる音' },
      { optionId: '4', text: 'ワンチェンがスクリューシャフトをつかんでいる音' },
    ],
  },
  {
    quizId: '37',
    question:
      '第1部より問題です。\n中世騎士殺人修練場の一つで、チェーン首輪デスマッチが行われていた部屋は？',
    options: [
      { optionId: '0', text: '双首竜の間' },
      { optionId: '1', text: '絞斬首の間' },
      { optionId: '2', text: '二人一体の間' },
      { optionId: '3', text: '鋼鎖連の間' },
      { optionId: '4', text: '連蛇輪の間' },
    ],
  },
  {
    quizId: '38',
    question:
      '第1部、ポコの台詞より問題です。\n「ねーちゃん！ あしたって○○さッ！」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'いま' },
      { optionId: '1', text: 'きょう' },
      { optionId: '2', text: 'いつ' },
      { optionId: '3', text: 'あした' },
      { optionId: '4', text: 'きのう' },
    ],
  },
  {
    quizId: '39',
    question:
      '第1部より問題です。\nトンペティに死の運命を詳しく読んでもらった際、ツェペリが行おうとしていた高度な波紋修行は？',
    options: [
      { optionId: '0', text: '周天の法門' },
      { optionId: '1', text: '最環の法門' },
      { optionId: '2', text: '鬼天の間' },
      { optionId: '3', text: '勇王の法門' },
      { optionId: '4', text: '空海の法門' },
    ],
  },
  {
    quizId: '40',
    question:
      '第1部より問題です。\nタルカスのチェーン首輪デスマッチの特性を活かした、鎖と自身で上下からの同時攻撃をする必殺技は？',
    options: [
      { optionId: '0', text: '天地来蛇殺(ヘルヘブンスネーキル)' },
      { optionId: '1', text: '獄楽竜殺(ヘルヘブンドライキル)' },
      { optionId: '2', text: '歓楽十地殺(スパイキルリング)' },
      { optionId: '3', text: '地空連引同(トルクザイカハル)' },
      { optionId: '4', text: '剛力大鎌衝(シクルキルリング)' },
    ],
  },
  {
    quizId: '41',
    question:
      '第1部より問題です。\nタルカスを倒したジョナサンたちが最初に会った、屍生人となっていた町民は？',
    options: [
      { optionId: '0', text: 'アダムス' },
      { optionId: '1', text: 'ジェフバック' },
      { optionId: '2', text: 'ダン・ハマー' },
      { optionId: '3', text: 'アダムス' },
      { optionId: '4', text: 'スティクス' },
    ],
  },
  {
    quizId: '42',
    question:
      '第1部より問題です。\nダイアーの必殺技「サンダークロススプリットアタック」の漢字表記は？',
    options: [
      { optionId: '0', text: '稲妻十字空烈刃' },
      { optionId: '1', text: '雷撃十字空烈刃' },
      { optionId: '2', text: '電撃十字空烈刃' },
      { optionId: '3', text: '落雷十字空烈刃' },
      { optionId: '4', text: '放電十字空烈刃' },
    ],
  },
  {
    quizId: '43',
    question:
      '第1部より問題です。\n体内にコブラなどの蛇を飼っている屍生人の名前は？',
    options: [
      { optionId: '0', text: 'ドゥービー' },
      { optionId: '1', text: 'ジェフバック' },
      { optionId: '2', text: 'ダン・ハマー' },
      { optionId: '3', text: 'アダムス' },
      { optionId: '4', text: 'スティクス' },
    ],
  },
  {
    quizId: '44',
    question:
      '「おとなはウソつきではないのです。 まちがいをするだけなのです……。」\n誰の言葉？',
    options: [
      { optionId: '0', text: '荒木飛呂彦' },
      { optionId: '1', text: 'ジョージ・ジョースター一世' },
      { optionId: '2', text: 'ウィル・A・ツェペリ' },
      { optionId: '3', text: '吉良吉影' },
      { optionId: '4', text: '岸部露伴' },
    ],
  },
  {
    quizId: '45',
    question:
      '第1部より問題です。\nディオにとって波紋は何の小便よりも下衆なもの？',
    options: [
      { optionId: '0', text: 'カエル' },
      { optionId: '1', text: '犬' },
      { optionId: '2', text: '青臭いガキ' },
      { optionId: '3', text: '虫' },
      { optionId: '4', text: 'どんな生物' },
    ],
  },
  {
    quizId: '46',
    question:
      '第1部より問題です。\nストレイツォに対し血管針攻撃をしてきた屍生人でないのは？',
    options: [
      { optionId: '0', text: 'レイス' },
      { optionId: '1', text: 'ペイジ' },
      { optionId: '2', text: 'ジョーンズ' },
      { optionId: '3', text: 'プラント' },
      { optionId: '4', text: 'ボーンナム' },
    ],
  },
  {
    quizId: '47',
    question:
      '第1部より問題です。\nジョナサンに顔を真っ二つに斬られたディオ、彼が顔のずれを直すために頭を叩いた際の擬音は？',
    options: [
      { optionId: '0', text: '音はしていない' },
      { optionId: '1', text: 'コン' },
      { optionId: '2', text: 'トン' },
      { optionId: '3', text: 'ドン' },
      { optionId: '4', text: 'グガン' },
    ],
  },
  {
    quizId: '48',
    question:
      '第1部、「ロンドン・プレス紙小さな記事抜粋…」より\nウィンドナイツ・ロットで73人が忽然と消えた晩、4人のよそ者が東の崖に立つ無人の館で男性の服を拾い集め焼き捨てているのを目撃した農夫は？',
    options: [
      { optionId: '0', text: 'ジェフバック' },
      { optionId: '1', text: 'ダン・ハマー' },
      { optionId: '2', text: 'アダムス' },
      { optionId: '3', text: 'ドゥービー' },
      { optionId: '4', text: 'スティクス' },
    ],
  },
  {
    quizId: '49',
    question:
      '第1部、「警察の盗難とどけ」より\nウィンドナイツ・ロットで73人が忽然と消えた夜、東洋人に船を盗まれた漁師は？',
    options: [
      { optionId: '0', text: 'ダン・ハマー' },
      { optionId: '1', text: 'ジェフバック' },
      { optionId: '2', text: 'アダムス' },
      { optionId: '3', text: 'ドゥービー' },
      { optionId: '4', text: 'スティクス' },
    ],
  },
  {
    quizId: '50',
    question:
      '第1部より問題です。\nジョナサン・ジョースターとエリナ・ペンドルトンの結婚した日は？',
    options: [
      { optionId: '0', text: '1889年2月2日' },
      { optionId: '1', text: '1889年3月2日' },
      { optionId: '2', text: '1889年2月3日' },
      { optionId: '3', text: '1890年2月2日' },
      { optionId: '4', text: '1890年3月2日' },
    ],
  },
  {
    quizId: '51',
    question:
      '第1部より問題です。\n新婚旅行中にディオに襲われたエリナ、無事に脱出した彼女が救助された場所は？',
    options: [
      { optionId: '0', text: 'カナリア諸島沖' },
      { optionId: '1', text: 'バミューダ諸島沖' },
      { optionId: '2', text: 'ヴァージン諸島沖' },
      { optionId: '3', text: 'ピトケアン諸島沖' },
      { optionId: '4', text: 'ケイマン諸島沖' },
    ],
  },
  {
    quizId: '52',
    question:
      '第2部より問題です。\nジョセフが13歳の時、スピードワゴンが誘拐された際の犯人の目的は、一つはスピードワゴンが死んで会社がメタクソになること、もう一つ要求金額は？',
    options: [
      { optionId: '0', text: '100万ドル' },
      { optionId: '1', text: '30万ドル' },
      { optionId: '2', text: '300万ドル' },
      { optionId: '3', text: '500万ドル' },
      { optionId: '4', text: '1000万ドル' },
    ],
  },
  {
    quizId: '53',
    question:
      '第2部より問題です。\nジョセフが13歳の時、スピードワゴンが誘拐された際に犯人がパイロットに命じた行き先は？',
    options: [
      { optionId: '0', text: 'リバプール' },
      { optionId: '1', text: 'ウォリントン' },
      { optionId: '2', text: 'チェスター' },
      { optionId: '3', text: 'エレスメアポート' },
      { optionId: '4', text: 'サウスポート' },
    ],
  },
  {
    quizId: '54',
    question:
      '第2部より問題です。\n作中でジョセフが最初にした相手の台詞の先読みは？',
    options: [
      { optionId: '0', text: 'なんでメリケンのことわかったんだこの野郎！' },
      { optionId: '1', text: 'ライターなら胸のポケットにはいっているぜ' },
      { optionId: '2', text: 'お前には関係ねぇだろこのボケが！' },
      { optionId: '3', text: '赤子を殺すより楽な作業よ' },
      { optionId: '4', text: 'そんなバカな' },
    ],
  },
  {
    quizId: '55',
    question:
      'ジョジョへのお便り紹介のコーナーで、単行本でストレイツォが死ぬ前に\n「あーん！ スト様が死んだ！」\nというお便りが掲載された葉書にはP.Sで何と書かれている？',
    options: [
      { optionId: '0', text: '88 1・2号は 娘さんとくっつきすぎだ!!' },
      { optionId: '1', text: '今年も面白い作品をお描きになって下さい' },
      {
        optionId: '2',
        text: 'シュトロハイムや柱の男なんかどうでもいい！\nスト様を復活させて!!',
      },
      { optionId: '3', text: '体に気を付けて頑張ってください……いちおう' },
      {
        optionId: '4',
        text: 'スト様を復活させてくれなければ、この私容赦せん！',
      },
    ],
  },
  {
    quizId: '56',
    question:
      '第2部より問題です。\nジョセフがスモーキーに見せた雑誌の内容、AAカップがCカップになるパッドの値段はペアでいくら？',
    options: [
      { optionId: '0', text: '1ドル25セント' },
      { optionId: '1', text: '5ドル50セント' },
      { optionId: '2', text: '10ドル30セント' },
      { optionId: '3', text: '18ドル' },
      { optionId: '4', text: '25ドル' },
    ],
  },
  {
    quizId: '57',
    question:
      '第2部より問題です。\nジョセフがストレイツォにに向けて街中でぶっ放した銃は？',
    options: [
      { optionId: '0', text: 'トンプソン機関銃' },
      { optionId: '1', text: 'ブローニング自動小銃' },
      { optionId: '2', text: 'キャリコM100' },
      { optionId: '3', text: 'ジョンソン軽機関銃' },
      { optionId: '4', text: 'レイジング機関銃' },
    ],
  },
  {
    quizId: '58',
    question:
      'ストレイツォも使っていた、高圧で体液を目から発射する技「空裂眼刺驚」はなんと読む？',
    options: [
      { optionId: '0', text: 'スペースリパー・スティンギーアイズ' },
      { optionId: '1', text: 'スカイティアー・プリックアイズ' },
      { optionId: '2', text: 'フリードワンダー・ステイヴアイズ' },
      { optionId: '3', text: 'フライレット・ミッディアイズ' },
      { optionId: '4', text: 'ヘアード・ダブルセシムアイズ' },
    ],
  },
  {
    quizId: '59',
    question:
      '第2部より問題です。\n店内で声が響くことを利用し、ジョセフが鏡でストレイツォの攻撃を躱したときの時刻はおよそ何時何分？',
    options: [
      { optionId: '0', text: '7時50分頃' },
      { optionId: '1', text: '8時50分頃' },
      { optionId: '2', text: '4時10分頃' },
      { optionId: '3', text: '3時10分頃' },
      { optionId: '4', text: '6時30分頃' },
    ],
  },
  {
    quizId: '60',
    question:
      '第2部より問題です。\nジョセフがストレイツォに初めて波紋で攻撃した際の台詞\n「くらえ！ ブッ壊すほど………」\nに続く台詞は？',
    options: [
      { optionId: '0', text: 'シュートッ！' },
      { optionId: '1', text: 'ショット！' },
      { optionId: '2', text: 'ヒートッ！' },
      { optionId: '3', text: 'バッド！' },
      { optionId: '4', text: 'ヒット！' },
    ],
  },
  {
    quizId: '61',
    question:
      '第2部より問題です。\nストレイツォとリサリサのマフラーは東南アジアに生息する昆虫から作ったものですが、その昆虫は？',
    options: [
      { optionId: '0', text: 'サティポロジァビートル' },
      { optionId: '1', text: 'ディアリムスパイダー' },
      { optionId: '2', text: 'シャムクスコアント' },
      { optionId: '3', text: 'ミスティックレイディー' },
      { optionId: '4', text: 'キュリドアフライ' },
    ],
  },
  {
    quizId: '62',
    question:
      '第2部より問題です。\nストレイツォが手榴弾の爆発に巻き込まれる際の台詞は？',
    options: [
      { optionId: '0', text: 'MMMMMMOOOHHHH!！' },
      { optionId: '1', text: 'NUGAAABAHHHH' },
      { optionId: '2', text: 'AHYYY AHYYY' },
      { optionId: '3', text: 'WHOOOOOOO' },
      { optionId: '4', text: 'UREEYYY' },
    ],
  },
  {
    quizId: '63',
    question:
      '第2部より問題です。\n街中でストレイツォと戦っていたジョセフを爆弾魔と思い込み、捕まえて新聞でヒーローになろうとしたのは誰？',
    options: [
      { optionId: '0', text: 'ブルート' },
      { optionId: '1', text: 'ブルーノ' },
      { optionId: '2', text: 'ブルタス' },
      { optionId: '3', text: 'ブルックス' },
      { optionId: '4', text: 'ブルドー' },
    ],
  },
  {
    quizId: '64',
    question:
      '第2部より問題です。\n吸血鬼になったストレイツォの指圧力破壊度数は？',
    options: [
      { optionId: '0', text: '235kg/㎠' },
      { optionId: '1', text: '85kg/㎠' },
      { optionId: '2', text: '115kg/㎠' },
      { optionId: '3', text: '165kg/㎠' },
      { optionId: '4', text: '195kg/㎠' },
    ],
  },
  {
    quizId: '65',
    question: '第2部より問題です。\n吸血鬼になったストレイツォの跳躍力は？',
    options: [
      { optionId: '0', text: '4m22cm' },
      { optionId: '1', text: '2m22cm' },
      { optionId: '2', text: '6m22cm' },
      { optionId: '3', text: '8m22cm' },
      { optionId: '4', text: '10m22cm' },
    ],
  },
  {
    quizId: '66',
    question: '第2部より問題です。\nスモーキーの吸っているタバコは？',
    options: [
      { optionId: '0', text: 'マルボロ' },
      { optionId: '1', text: 'ラッキーストライク' },
      { optionId: '2', text: 'オールド・ゴールド' },
      { optionId: '3', text: 'キャメル' },
      { optionId: '4', text: 'チェスターフィールド' },
    ],
  },
  {
    quizId: '67',
    question:
      '第2部より問題です。\nストレイツォから逃げたジョセフは、橋でどのような音を耳にして追い付いてきたストレイツォに気付いた？',
    options: [
      { optionId: '0', text: 'ズリッ' },
      { optionId: '1', text: 'ズッ' },
      { optionId: '2', text: 'ザッ' },
      { optionId: '3', text: 'ゴン' },
      { optionId: '4', text: 'ニュッ' },
    ],
  },
  {
    quizId: '68',
    question:
      '第2部より問題です。\nストレイツォにより重傷を負ったスピードワゴンはどこでナチス軍に発見された？',
    options: [
      { optionId: '0', text: 'リオダダ川' },
      { optionId: '1', text: 'グランデ川' },
      { optionId: '2', text: 'ハルバル川' },
      { optionId: '3', text: 'サリナス川' },
      { optionId: '4', text: 'グリハルバ川' },
    ],
  },
  {
    quizId: '69',
    question:
      '第2部より問題です。\nナチスに拘束されたスピードワゴン、なぜ拘束衣を着させられた？',
    options: [
      { optionId: '0', text: '自殺をはかったから' },
      { optionId: '1', text: '逃亡しようとしたから' },
      { optionId: '2', text: '危害を加えてこようとしたから' },
      { optionId: '3', text: '計測機器を破壊しようとしたから' },
      { optionId: '4', text: '暴れるから' },
    ],
  },
  {
    quizId: '70',
    question:
      '第2部より問題です。\n「ノックしてもしもお～～し」\nジョセフが初対面の人間にした不躾な要求とは？',
    options: [
      { optionId: '0', text: '食い物とガソリンを持ってこい' },
      { optionId: '1', text: '宿の確保をしろ' },
      { optionId: '2', text: '地図を持ってこい' },
      { optionId: '3', text: '道案内をしろ' },
      { optionId: '4', text: '何でもいいから知っていることを教えろ' },
    ],
  },
  {
    quizId: '71',
    question:
      '第2部より問題です。\nナチスの実験室でサンタナを隔離、監視していた部屋の内壁の厚さは？',
    options: [
      { optionId: '0', text: '50cm' },
      { optionId: '1', text: '30cm' },
      { optionId: '2', text: '75cm' },
      { optionId: '3', text: '100cm' },
      { optionId: '4', text: '150cm' },
    ],
  },
  {
    quizId: '72',
    question:
      '第2部より問題です。\nシュトロハイムが名付けた柱の男「サンタナ」はどういう意味？',
    options: [
      { optionId: '0', text: 'メキシコに吹く熱風' },
      { optionId: '1', text: 'メキシコに吹く旋風' },
      { optionId: '2', text: 'メキシコに吹く烈風' },
      { optionId: '3', text: 'メキシコに吹く乾風' },
      { optionId: '4', text: 'メキシコに吹く疾風' },
    ],
  },
  {
    quizId: '73',
    question: '第2部より問題です。\nナチスの実験室は地下何mのところにある？',
    options: [
      { optionId: '0', text: '地下20m' },
      { optionId: '1', text: '地下100m' },
      { optionId: '2', text: '地下50m' },
      { optionId: '3', text: '地下12m' },
      { optionId: '4', text: '地下5m' },
    ],
  },
  {
    quizId: '74',
    question:
      '第2部より問題です。\nドノヴァンをサボテンに縛り付けた際、一緒に残したメモには書いた文字は？',
    options: [
      { optionId: '0', text: 'HELLO ADOLPH！' },
      { optionId: '1', text: 'HELP！' },
      { optionId: '2', text: 'Please do not feed' },
      { optionId: '3', text: 'Please Ignore' },
      { optionId: '4', text: 'CACTUS MAN' },
    ],
  },
  {
    quizId: '75',
    question:
      '第2部より問題です。\nナチスの実験室に潜入する際、女装したジョセフが持っていたものは？',
    options: [
      { optionId: '0', text: 'テキーラ酒' },
      { optionId: '1', text: 'プルケ酒' },
      { optionId: '2', text: 'バーボン酒' },
      { optionId: '3', text: 'コニャック' },
      { optionId: '4', text: 'コーラ' },
    ],
  },
  {
    quizId: '76',
    question:
      '第2部より問題です。\nナチスの実験室のある屋敷の入館チェックをしているナチス軍人、ジョセフに蹴られた際の悲鳴は？',
    options: [
      { optionId: '0', text: 'タコス' },
      { optionId: '1', text: 'ブルわぁ' },
      { optionId: '2', text: 'ギャァァ' },
      { optionId: '3', text: 'ムック' },
      { optionId: '4', text: 'ゥバッ' },
    ],
  },
  {
    quizId: '77',
    question:
      '第2部より問題です。\n人呼んで、波紋「ヘア・アタック」\n誰の髪の毛を使った？',
    options: [
      { optionId: '0', text: 'シュトロハイム' },
      { optionId: '1', text: 'ナチス軍研究員' },
      { optionId: '2', text: 'ジョセフ' },
      { optionId: '3', text: 'スピードワゴン' },
      { optionId: '4', text: 'サンタナ' },
    ],
  },
  {
    quizId: '78',
    question:
      '第2部より問題です。\nサンタナの「別名：露骨な肋骨」\n正式名称は？',
    options: [
      { optionId: '0', text: 'リブス・ブレード' },
      { optionId: '1', text: 'リブス・エッジ' },
      { optionId: '2', text: 'リブス・ソード' },
      { optionId: '3', text: 'リブス・カットリー' },
      { optionId: '4', text: 'リブス・シャープ' },
    ],
  },
  {
    quizId: '79',
    question: '第2部より問題です。\nサンタナの「別名：憎き肉片」\n正式名称は？',
    options: [
      { optionId: '0', text: 'ミート・インベイド' },
      { optionId: '1', text: 'ミート・ヘイトフル' },
      { optionId: '2', text: 'ミート・バライク' },
      { optionId: '3', text: 'ミート・インジャスティス' },
      { optionId: '4', text: 'ミート・アブホレント' },
    ],
  },
  {
    quizId: '80',
    question:
      '第2部より問題です。\nシュトロハイムが脚を切断し扉を開けた際の時刻はおよそ何時何分？',
    options: [
      { optionId: '0', text: '0.502083333333333' },
      { optionId: '1', text: '0.493055555555556' },
      { optionId: '2', text: '0.497916666666667' },
      { optionId: '3', text: '0.508333333333333' },
      { optionId: '4', text: '2時' },
    ],
  },
  {
    quizId: '81',
    question:
      '第2部より問題です。\n柱の男たちの復活は、古代メキシコでの何年と壁画に刻まれている？',
    options: [
      { optionId: '0', text: '2852年' },
      { optionId: '1', text: '2835年' },
      { optionId: '2', text: '2869年' },
      { optionId: '3', text: '2891年' },
      { optionId: '4', text: '2904年' },
    ],
  },
  {
    quizId: '82',
    question:
      '第2部より問題です。\nスピードワゴンの紹介で、ジョセフとシーザーが会い、戦った場所は？',
    options: [
      { optionId: '0', text: 'トリトーネの泉' },
      { optionId: '1', text: 'ルルドの泉' },
      { optionId: '2', text: 'トレビの泉' },
      { optionId: '3', text: 'カルロス３世の泉' },
      { optionId: '4', text: 'フュースルの泉' },
    ],
  },
  {
    quizId: '83',
    question: '第2部より問題です。\nワムウが復活して初めて喋った言葉は何語？',
    options: [
      { optionId: '0', text: 'ラテン語' },
      { optionId: '1', text: 'スペイン語' },
      { optionId: '2', text: '英語' },
      { optionId: '3', text: 'ギリシア語' },
      { optionId: '4', text: 'エジプト語' },
    ],
  },
  {
    quizId: '84',
    question:
      '第2部より問題です。\nワムウたち柱の男が眠っている場所へジョセフたちを案内したナチス軍人は？',
    options: [
      { optionId: '0', text: 'マルク' },
      { optionId: '1', text: 'ミルク' },
      { optionId: '2', text: 'ムルク' },
      { optionId: '3', text: 'メルク' },
      { optionId: '4', text: 'モルク' },
    ],
  },
  {
    quizId: '85',
    question:
      '第2部より問題です。\nジョセフ必殺技「波紋クラッカーヴォレイ」\n使用しているアメリカンクラッカーに書いてある文字は？',
    options: [
      { optionId: '0', text: 'J' },
      { optionId: '1', text: 'A' },
      { optionId: '2', text: 'K' },
      { optionId: '3', text: 'S' },
      { optionId: '4', text: 'V' },
    ],
  },
  {
    quizId: '86',
    question:
      '第2部より問題です。\nワムウの「神砂嵐」\nふたつの拳の間に生じる真空状態の圧倒的破壊空間はまさに歯車的砂嵐の○○!!\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '小宇宙' },
      { optionId: '1', text: 'ブラックホール' },
      { optionId: '2', text: '龍' },
      { optionId: '3', text: '神話' },
      { optionId: '4', text: '地球' },
    ],
  },
  {
    quizId: '87',
    question:
      '第2部より問題です。\nエシディシがダイナマイトを飲み込み、体内で爆発させた時の音は？',
    options: [
      { optionId: '0', text: 'ドモン' },
      { optionId: '1', text: 'デュルン' },
      { optionId: '2', text: 'バクン' },
      { optionId: '3', text: 'グムッ' },
      { optionId: '4', text: 'ブテゥム' },
    ],
  },
  {
    quizId: '88',
    question:
      '第2部より問題です。\nワムウとエシディシがジョセフに付けた「死の結婚指輪」\n助かるためには何日以内に解毒剤を飲まなければならない？',
    options: [
      { optionId: '0', text: '33日' },
      { optionId: '1', text: '30日' },
      { optionId: '2', text: '31日' },
      { optionId: '3', text: '32日' },
      { optionId: '4', text: '34日' },
    ],
  },
  {
    quizId: '89',
    question:
      '第2部より問題です。\nジョセフの嫌いな言葉、一番は「努力」、では二番は？',
    options: [
      { optionId: '0', text: 'ガンバル' },
      { optionId: '1', text: '練習' },
      { optionId: '2', text: '我慢' },
      { optionId: '3', text: '勉強' },
      { optionId: '4', text: 'ヤル気' },
    ],
  },
  {
    quizId: '90',
    question:
      '第2部より問題です。\nヴェネツィアから北東へ船で30分の位置にある、リサリサの館が全体を占めている島は？',
    options: [
      { optionId: '0', text: 'エア・サプレーナ島' },
      { optionId: '1', text: 'エア・リューシカ島' },
      { optionId: '2', text: 'エア・ロザキソウ島' },
      { optionId: '3', text: 'エア・ベルイー島' },
      { optionId: '4', text: 'エア・ターハンタ島' },
    ],
  },
  {
    quizId: '91',
    question:
      '第2部より問題です。\nジョセフとシーザーが共にリサリサの下で修業した際の試練のプロローグ「ヘルクライム・ピラー」\n漢字表記は？',
    options: [
      { optionId: '0', text: '地獄昇柱' },
      { optionId: '1', text: '地獄立塔' },
      { optionId: '2', text: '地獄登柱' },
      { optionId: '3', text: '地獄上柱' },
      { optionId: '4', text: '地獄油塔' },
    ],
  },
  {
    quizId: '92',
    question: '第2部より問題です。\nジョセフ・ジョースターの嫌いな動物は？',
    options: [
      { optionId: '0', text: 'ウシ' },
      { optionId: '1', text: 'イヌ' },
      { optionId: '2', text: 'ネコ' },
      { optionId: '3', text: 'トカゲ' },
      { optionId: '4', text: 'ネズミ' },
    ],
  },
  {
    quizId: '93',
    question: '第2部より問題です。\nジョセフ・ジョースターの好きな動物は？',
    options: [
      { optionId: '0', text: 'イヌ' },
      { optionId: '1', text: 'ウシ' },
      { optionId: '2', text: 'ネコ' },
      { optionId: '3', text: 'トカゲ' },
      { optionId: '4', text: 'ネズミ' },
    ],
  },
  {
    quizId: '94',
    question: '第2部より問題です。\nジョセフ・ジョースターの好きな色は？',
    options: [
      { optionId: '0', text: 'マリンブルー' },
      { optionId: '1', text: 'オレンジ' },
      { optionId: '2', text: 'アトモスグリーン' },
      { optionId: '3', text: 'ペールサロー' },
      { optionId: '4', text: 'コバルトブルー' },
    ],
  },
  {
    quizId: '95',
    question:
      '第2部、ジョセフ・ジョースターのプロフィールより問題です。\nジョセフ・ジョースターはケンカによる投獄を何度経験している？',
    options: [
      { optionId: '0', text: '7回' },
      { optionId: '1', text: '0回' },
      { optionId: '2', text: '1回' },
      { optionId: '3', text: '3回' },
      { optionId: '4', text: '5回' },
    ],
  },
  {
    quizId: '96',
    question:
      '第2部、ジョセフ・ジョースターのプロフィールより問題です。\nジョセフ・ジョースターの好きな食べ物はフライドチキンともう一つは？',
    options: [
      { optionId: '0', text: 'チューインガム' },
      { optionId: '1', text: 'ハンバーガー' },
      { optionId: '2', text: 'イカ墨のパスタ' },
      { optionId: '3', text: 'ビーフ・ストロガノフ' },
      { optionId: '4', text: 'ボルシチ' },
    ],
  },
  {
    quizId: '97',
    question: 'ジョセフ・ジョースターの血液型は？',
    options: [
      { optionId: '0', text: 'B型' },
      { optionId: '1', text: 'A型' },
      { optionId: '2', text: 'O型' },
      { optionId: '3', text: 'AB型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '98',
    question: 'ジョセフ・ジョースターの誕生日は？',
    options: [
      { optionId: '0', text: '44831' },
      { optionId: '1', text: '44777' },
      { optionId: '2', text: '44694' },
      { optionId: '3', text: '44718' },
      { optionId: '4', text: '44764' },
    ],
  },
  {
    quizId: '99',
    question:
      '第2部より問題です。\nジョセフとシーザーが共にリサリサの下で修業した際の試練のプロローグ「ヘルクライム・ピラー」\n円柱の最大円周は？」',
    options: [
      { optionId: '0', text: '7m20cm' },
      { optionId: '1', text: '5m50cm' },
      { optionId: '2', text: '9m40cm' },
      { optionId: '3', text: '11m80cm' },
      { optionId: '4', text: '15m' },
    ],
  },
  {
    quizId: '100',
    question:
      '第2部より問題です。\nジョセフとシーザーが共にリサリサの下で修業した際の試練のプロローグ「ヘルクライム・ピラー」\n開始28時間時点でのシーザーの到達標高は？',
    options: [
      { optionId: '0', text: '15m地点' },
      { optionId: '1', text: '8m50cm地点' },
      { optionId: '2', text: '10m地点' },
      { optionId: '3', text: '12m70cm地点' },
      { optionId: '4', text: '18m地点' },
    ],
  },
  {
    quizId: '101',
    question: '第2部より問題です。\nシーザー・アントニオ・ツェペリの誕生日は？',
    options: [
      { optionId: '0', text: '44694' },
      { optionId: '1', text: '44777' },
      { optionId: '2', text: '44831' },
      { optionId: '3', text: '44718' },
      { optionId: '4', text: '44764' },
    ],
  },
  {
    quizId: '102',
    question: '第2部より問題です。\nシーザー・アントニオ・ツェペリの血液型は？',
    options: [
      { optionId: '0', text: 'A型' },
      { optionId: '1', text: 'B型' },
      { optionId: '2', text: 'O型' },
      { optionId: '3', text: 'AB型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '103',
    question:
      '第2部より問題です。\nシーザー・アントニオ・ツェペリに虫歯は何本ある？',
    options: [
      { optionId: '0', text: '1本' },
      { optionId: '1', text: '0本' },
      { optionId: '2', text: '2本' },
      { optionId: '3', text: '3本' },
      { optionId: '4', text: '4本' },
    ],
  },
  {
    quizId: '104',
    question:
      '第2部より問題です。\nシーザー・アントニオ・ツェペリのの好きな食べ物は？',
    options: [
      { optionId: '0', text: 'ビーフ・ストロガノフ' },
      { optionId: '1', text: 'ハンバーガー' },
      { optionId: '2', text: 'イカ墨のパスタ' },
      { optionId: '3', text: 'ボルシチ' },
      { optionId: '4', text: 'チューインガム' },
    ],
  },
  {
    quizId: '105',
    question:
      '第2部より問題です。\nシーザー・アントニオ・ツェペリのの好きな色は？',
    options: [
      { optionId: '0', text: 'オレンジ' },
      { optionId: '1', text: 'マリンブルー' },
      { optionId: '2', text: 'アトモスグリーン' },
      { optionId: '3', text: 'ペールサロー' },
      { optionId: '4', text: 'コバルトブルー' },
    ],
  },
  {
    quizId: '106',
    question: '第2部より問題です。\nシーザー・アントニオ・ツェペリの特技は？',
    options: [
      { optionId: '0', text: 'ダーツゲーム' },
      { optionId: '1', text: 'ビリヤード' },
      { optionId: '2', text: 'ポーカー' },
      { optionId: '3', text: 'テニス' },
      { optionId: '4', text: 'チェス' },
    ],
  },
  {
    quizId: '107',
    question: '第2部より問題です。\nシーザー・アントニオ・ツェペリの前科は？',
    options: [
      { optionId: '0', text: '前科なし' },
      { optionId: '1', text: '前科3犯' },
      { optionId: '2', text: '前科5犯' },
      { optionId: '3', text: '前科6犯' },
      { optionId: '4', text: '前科10犯' },
    ],
  },
  {
    quizId: '108',
    question: '第2部より問題です。\nシーザー・アントニオ・ツェペリの趣味は？',
    options: [
      { optionId: '0', text: 'ライター集め' },
      { optionId: '1', text: 'シャボン玉' },
      { optionId: '2', text: 'ダーツ' },
      { optionId: '3', text: 'トランプ' },
      { optionId: '4', text: '音楽鑑賞' },
    ],
  },
  {
    quizId: '109',
    question:
      '第2部より問題です。\nシーザー・アントニオ・ツェペリの嫌いなものとして間違っているのは？',
    options: [
      { optionId: '0', text: 'トマト' },
      { optionId: '1', text: 'ダサイやつ' },
      { optionId: '2', text: 'いいかげんなヤツ' },
      { optionId: '3', text: 'リンゴの皮をむく音' },
      { optionId: '4', text: '虫' },
    ],
  },
  {
    quizId: '110',
    question:
      '第2部より問題です。\nジョセフとシーザーが共にリサリサの下で修業した際の試練のプロローグ「ヘルクライム・ピラー」\nジョセフはシーザーに「はなすなよ」を何回言った？',
    options: [
      { optionId: '0', text: '13回' },
      { optionId: '1', text: '5回' },
      { optionId: '2', text: '8回' },
      { optionId: '3', text: '10回' },
      { optionId: '4', text: '15回' },
    ],
  },
  {
    quizId: '111',
    question:
      '第2部より問題です。\nジョセフとシーザーが共にリサリサの下で修業した際の試練のプロローグ「ヘルクライム・ピラー」\nジョセフの登頂成功時間はシーザーに遅れること何分？',
    options: [
      { optionId: '0', text: '9分' },
      { optionId: '1', text: '3分' },
      { optionId: '2', text: '6分' },
      { optionId: '3', text: '12分' },
      { optionId: '4', text: '15分' },
    ],
  },
  {
    quizId: '112',
    question:
      '第2部より問題です。\nサンマルコ広場でリサリサからエイジャの赤石を掏ろうとしたチンピラに扮したナチス軍が、ジョセフにかけられたものは？',
    options: [
      { optionId: '0', text: 'カラシ' },
      { optionId: '1', text: 'ケチャップ' },
      { optionId: '2', text: 'マスタード' },
      { optionId: '3', text: 'マヨネーズ' },
      { optionId: '4', text: '粉チーズ' },
    ],
  },
  {
    quizId: '113',
    question:
      '第2部より問題です。\nエシディシが自ら針を刺し、その傷穴から血管針を伸ばす流法は？',
    options: [
      { optionId: '0', text: '怪焔王大車獄の流法' },
      { optionId: '1', text: '怪焔王大炎帝の流法' },
      { optionId: '2', text: '怪焔王授回獄の流法' },
      { optionId: '3', text: '怪焔王大車輪の流法' },
      { optionId: '4', text: '怪焔王大蛇帝の流法' },
    ],
  },
  {
    quizId: '114',
    question:
      '第2部より問題です。\nスージーQを助け、憑りついたエシディシだけを倒すために力を合わせたジョセフとシーザー、ジョセフが体全体に「正の」波紋を流したのに対し、シーザーは「負の」波紋をどこに集中して送った？',
    options: [
      { optionId: '0', text: '心臓' },
      { optionId: '1', text: '脳' },
      { optionId: '2', text: 'エシディシ' },
      { optionId: '3', text: '肺' },
      { optionId: '4', text: '血管' },
    ],
  },
  {
    quizId: '115',
    question:
      '第2部より問題です。\nエシディシがスージーQに憑りついて郵送した赤石、送り先はどこ？',
    options: [
      { optionId: '0', text: 'スイスのサンモリッツ' },
      { optionId: '1', text: 'イタリアのティラノ' },
      { optionId: '2', text: 'イタリアのグロージオ' },
      { optionId: '3', text: 'スイスのベルン' },
      { optionId: '4', text: 'スイスのダボス' },
    ],
  },
  {
    quizId: '116',
    question:
      '第2部より問題です。\nエシディシがスージーQに憑りついて郵送した赤石が積み込まれた列車にジョセフたちが追いついた時刻は？',
    options: [
      { optionId: '0', text: '5:00PM' },
      { optionId: '1', text: '11:00AM' },
      { optionId: '2', text: '1:00PM' },
      { optionId: '3', text: '3:00PM' },
      { optionId: '4', text: '7:00PM' },
    ],
  },
  {
    quizId: '117',
    question:
      '第2部より問題です。\nカーズが赤石を奪いにナチス軍を襲う際、温度差で読み取った室内には照明器具がいくつあった？',
    options: [
      { optionId: '0', text: '9つ' },
      { optionId: '1', text: '4つ' },
      { optionId: '2', text: '6つ' },
      { optionId: '3', text: '7つ' },
      { optionId: '4', text: '13つ' },
    ],
  },
  {
    quizId: '118',
    question:
      '第2部より問題です。\nカーズが赤石を奪いにナチス軍を襲う際、室内の暖炉付近にいた人の身長は？',
    options: [
      { optionId: '0', text: '183cm' },
      { optionId: '1', text: '178cm' },
      { optionId: '2', text: '174cm' },
      { optionId: '3', text: '181cm' },
      { optionId: '4', text: '172cm' },
    ],
  },
  {
    quizId: '119',
    question:
      '第2部より問題です。\nナチスの科学力で機械の体として復活したシュトロハイム、力を誇示するために右手で握りつぶしたものは？',
    options: [
      { optionId: '0', text: 'ゴルフボール' },
      { optionId: '1', text: 'リンゴ' },
      { optionId: '2', text: '銃弾' },
      { optionId: '3', text: '双眼鏡' },
      { optionId: '4', text: 'ダイヤモンド' },
    ],
  },
  {
    quizId: '120',
    question:
      '第2部より問題です。\nナチスの科学力で機械の体として復活したシュトロハイム、指の力は？',
    options: [
      { optionId: '0', text: '1950kg/㎠' },
      { optionId: '1', text: '1250kg/㎠' },
      { optionId: '2', text: '1600kg/㎠' },
      { optionId: '3', text: '2125kg/㎠' },
      { optionId: '4', text: '2550kg/㎠' },
    ],
  },
  {
    quizId: '121',
    question:
      '第2部より問題です。\nナチスの科学力で機械の体として復活したシュトロハイム、胴体に仕込まれている重機関砲は1分間に何発の鉄甲弾が発射可能？',
    options: [
      { optionId: '0', text: '600発' },
      { optionId: '1', text: '100発' },
      { optionId: '2', text: '200発' },
      { optionId: '3', text: '350発' },
      { optionId: '4', text: '500発' },
    ],
  },
  {
    quizId: '122',
    question:
      '第2部より問題です。\n赤石のためカーズと共に崖から落ちていくジョセフ、ロープ代わりにした氷柱の数はジョセフからシーザー迄に何本？',
    options: [
      { optionId: '0', text: '6本' },
      { optionId: '1', text: '4本' },
      { optionId: '2', text: '8本' },
      { optionId: '3', text: '10本' },
      { optionId: '4', text: '12本' },
    ],
  },
  {
    quizId: '123',
    question:
      'サ第2部より問題です。\nンモリッツの上品な猫、エビのシッポでは見向きもしなかったが、ジョセフの食べていた何には釣られた？',
    options: [
      { optionId: '0', text: 'サーモンのくんせい' },
      { optionId: '1', text: 'ピッツア' },
      { optionId: '2', text: 'カルパッチョ' },
      { optionId: '3', text: '鯛のムニエル' },
      { optionId: '4', text: 'サラミ' },
    ],
  },
  {
    quizId: '124',
    question: 'シーザーの父親、マリオの職業は？',
    options: [
      { optionId: '0', text: '家具職人' },
      { optionId: '1', text: '建築士' },
      { optionId: '2', text: '時計修理屋' },
      { optionId: '3', text: '料理人' },
      { optionId: '4', text: '土建屋' },
    ],
  },
  {
    quizId: '125',
    question:
      '施設を脱走し、命知らずのワルとなっていたシーザー、彼がやっていない犯罪は？',
    options: [
      { optionId: '0', text: '殺人' },
      { optionId: '1', text: '盗み' },
      { optionId: '2', text: '強盗' },
      { optionId: '3', text: 'ケンカ' },
      { optionId: '4', text: '放火' },
    ],
  },
  {
    quizId: '126',
    question:
      '第2部より問題です。\n施設を脱走し、命知らずのワルとなっていたシーザー、当時の彼はゴロツキとケンかする時、大抵は何で相手をめった打ちにする？',
    options: [
      { optionId: '0', text: '工具(ペンチ)' },
      { optionId: '1', text: '工具(レンチ)' },
      { optionId: '2', text: '工具(スパナ)' },
      { optionId: '3', text: '工具(ドライバー)' },
      { optionId: '4', text: '工具(プライヤ)' },
    ],
  },
  {
    quizId: '127',
    question:
      '第2部より問題です。\nシーザーがマリオの後を付けていき、柱の男を見たとき、ダイヤモンドを持っていたのは？',
    options: [
      { optionId: '0', text: 'カーズ' },
      { optionId: '1', text: 'ワムウ' },
      { optionId: '2', text: 'エシディシ' },
      { optionId: '3', text: 'サンタナ' },
      { optionId: '4', text: '誰も持っていなかった' },
    ],
  },
  {
    quizId: '128',
    question:
      '第2部より問題です。\nホテルの外でワムウに襲われたシーザーとメッシーナ、メッシーナはどの部位を切り落とされた？',
    options: [
      { optionId: '0', text: '左腕' },
      { optionId: '1', text: '右腕' },
      { optionId: '2', text: '左脚' },
      { optionId: '3', text: '右脚' },
      { optionId: '4', text: '右手首' },
    ],
  },
  {
    quizId: '129',
    question:
      '第2部より問題です。\nホテルの外でワムウに襲われたシーザー、彼が骨折した部位は？',
    options: [
      { optionId: '0', text: '左腕' },
      { optionId: '1', text: '肋骨2本' },
      { optionId: '2', text: '右腕' },
      { optionId: '3', text: '右脚' },
      { optionId: '4', text: '左脚' },
    ],
  },
  {
    quizId: '130',
    question:
      '第2部、シーザーの台詞より問題です。\n「おれが最期にみせるのは代代受け継いだ未来にたくすツェペリ魂だ！」\nに続くのは？',
    options: [
      { optionId: '0', text: '人間の魂だ！' },
      { optionId: '1', text: '誇り高き一族の魂だ！' },
      { optionId: '2', text: '我我波紋使いの魂だ！' },
      { optionId: '3', text: '化け物にはない誇りだ！' },
      { optionId: '4', text: '誰にも負けない魂だ！' },
    ],
  },
  {
    quizId: '131',
    question:
      '第2部より問題です。\nカーズ達が太陽から身を守る宿としていたホテルは、もともと誰が建てた別荘兼要塞？',
    options: [
      { optionId: '0', text: '悪代官ゲスラー' },
      { optionId: '1', text: '悪代官クズール' },
      { optionId: '2', text: '悪代官アキュラ' },
      { optionId: '3', text: '悪代官ヒディン' },
      { optionId: '4', text: '悪代官ワルピューレ' },
    ],
  },
  {
    quizId: '132',
    question:
      '第2部より問題です。\nカーズ達が隠れ住んでいたホテルにいた、体毛を剛針線へ変化させる吸血鬼は？',
    options: [
      { optionId: '0', text: '鋼線(ワイアード)のベック' },
      { optionId: '1', text: '鋼線(ワイアード)のバック' },
      { optionId: '2', text: '鋼線(ワイアード)のビック' },
      { optionId: '3', text: '鋼線(ワイアード)のブック' },
      { optionId: '4', text: '鋼線(ワイアード)のボック' },
    ],
  },
  {
    quizId: '133',
    question:
      '第2部より問題です。\nカーズ達とジョセフ達が戦った、ピッツベルリナ山山麓の古代環状列石の場は何と呼ばれている？',
    options: [
      { optionId: '0', text: '骸骨の踵石' },
      { optionId: '1', text: '典環の墓標' },
      { optionId: '2', text: '円屍の墓石' },
      { optionId: '3', text: '悪魔の肋骨' },
      { optionId: '4', text: '輪廻の時計' },
    ],
  },
  {
    quizId: '134',
    question:
      '第2部より問題です。\nカーズが隠れ住んでいたホテルから赤石を取りに戻っているジョセフの台詞\n「きのうまでは自分の事だけ考えて生きてきた…… でも\n今メラメラと…… わきのぼってくるこの気持ちは…」\nこの気持ちは何というもの？',
    options: [
      { optionId: '0', text: '仁' },
      { optionId: '1', text: '人' },
      { optionId: '2', text: '尽' },
      { optionId: '3', text: '刃' },
      { optionId: '4', text: '陣' },
    ],
  },
  {
    quizId: '135',
    question:
      '第2部より問題です。\nリサリサの持っている、スピードワゴン、エリナ、ストレイツォ、リサリサが写っている写真に記されている日付は？',
    options: [
      { optionId: '0', text: '1889年5月22日' },
      { optionId: '1', text: '1889年3月22日' },
      { optionId: '2', text: '1889年4月22日' },
      { optionId: '3', text: '1889年6月22日' },
      { optionId: '4', text: '1889年7月22日' },
    ],
  },
  {
    quizId: '136',
    question: '第2部より問題です。\nリサリサの血液型は？',
    options: [
      { optionId: '0', text: 'A型' },
      { optionId: '1', text: 'B型' },
      { optionId: '2', text: 'AB型' },
      { optionId: '3', text: 'O型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '137',
    question: '第2部より問題です。\nリサリサの癖は？',
    options: [
      { optionId: '0', text: '髪をかきあげる' },
      { optionId: '1', text: '指でテーブルをリズミカルに叩く' },
      { optionId: '2', text: '指の関節を鳴らす' },
      { optionId: '3', text: 'マフラーを巻きなおす' },
      { optionId: '4', text: 'カップを持つときに小指を立てる' },
    ],
  },
  {
    quizId: '138',
    question: '第2部より問題です。\nリサリサの趣味は？',
    options: [
      { optionId: '0', text: 'ファッションと入浴' },
      { optionId: '1', text: 'ファッションとメイク' },
      { optionId: '2', text: 'ショッピングとメイク' },
      { optionId: '3', text: 'ショッピングと入浴' },
      { optionId: '4', text: 'メイクと入浴' },
    ],
  },
  {
    quizId: '139',
    question:
      '第2部より問題です。\nリサリサの好きな食べ物は、スージーQの情報によると何？',
    options: [
      { optionId: '0', text: 'にんじん' },
      { optionId: '1', text: 'ピッツァ' },
      { optionId: '2', text: 'チーズ' },
      { optionId: '3', text: 'スコーン' },
      { optionId: '4', text: 'オムライス' },
    ],
  },
  {
    quizId: '140',
    question:
      '第2部より問題です。\nワムウvsジョセフの戦車デスマッチに使われた吸血馬の馬力は？',
    options: [
      { optionId: '0', text: '150馬力' },
      { optionId: '1', text: '10馬力' },
      { optionId: '2', text: '100馬力' },
      { optionId: '3', text: '350馬力' },
      { optionId: '4', text: '129.3馬力' },
    ],
  },
  {
    quizId: '141',
    question:
      '第2部より問題です。\nワムウvsジョセフの戦車デスマッチ、トラック1周の長さは？',
    options: [
      { optionId: '0', text: '960m' },
      { optionId: '1', text: '400m' },
      { optionId: '2', text: '500m' },
      { optionId: '3', text: '1240m' },
      { optionId: '4', text: '1500m' },
    ],
  },
  {
    quizId: '142',
    question:
      '第2部より問題です。\nシーザーとの約束となったワムウのピアスをジョセフは何指に付けていた？',
    options: [
      { optionId: '0', text: '小指' },
      { optionId: '1', text: '親指' },
      { optionId: '2', text: '中指' },
      { optionId: '3', text: '人差し指' },
      { optionId: '4', text: '薬指' },
    ],
  },
  {
    quizId: '143',
    question: '第2部より問題です。\nワムウの身長は？',
    options: [
      { optionId: '0', text: '197cm' },
      { optionId: '1', text: '192cm' },
      { optionId: '2', text: '195cm' },
      { optionId: '3', text: '200cm' },
      { optionId: '4', text: '203cm' },
    ],
  },
  {
    quizId: '144',
    question: '第2部より問題です。\nワムウの体重は？',
    options: [
      { optionId: '0', text: '115kg' },
      { optionId: '1', text: '89kg' },
      { optionId: '2', text: '108kg' },
      { optionId: '3', text: '127kg' },
      { optionId: '4', text: '140kg' },
    ],
  },
  {
    quizId: '145',
    question: '第2部より問題です。\nワムウの好きな色は？',
    options: [
      { optionId: '0', text: 'コバルトブルー' },
      { optionId: '1', text: 'オレンジ' },
      { optionId: '2', text: 'マリンブルー' },
      { optionId: '3', text: 'アトモスグリーン' },
      { optionId: '4', text: 'ペールサロー' },
    ],
  },
  {
    quizId: '146',
    question:
      '第2部より問題です。\n戦車デスマッチ2週目の武器、鋼鉄球のボーガンの球の直径は？',
    options: [
      { optionId: '0', text: '5.8cm' },
      { optionId: '1', text: '7.8cm' },
      { optionId: '2', text: '9.8cm' },
      { optionId: '3', text: '12.8cm' },
      { optionId: '4', text: '15.8cm' },
    ],
  },
  {
    quizId: '147',
    question:
      '第2部より問題です。\nジョセフの使用した肘から波紋を流す技、「リーバッフオーバードライブ」の漢字表記は？',
    options: [
      { optionId: '0', text: '波紋肘支疾走' },
      { optionId: '1', text: '肘打波紋疾走' },
      { optionId: '2', text: '肘当波紋疾走' },
      { optionId: '3', text: '肘返波紋疾走' },
      { optionId: '4', text: '肘振波紋疾走' },
    ],
  },
  {
    quizId: '148',
    question:
      '第2部より問題です。\nワムウの膨大な量の風を肺の中で超圧縮し、カミソリのような極限に狭いすき間から超高圧で吹き出す風の最終流法は？',
    options: [
      { optionId: '0', text: '渾楔颯' },
      { optionId: '1', text: '神砂嵐' },
      { optionId: '2', text: '龍楓断' },
      { optionId: '3', text: '風王臣' },
      { optionId: '4', text: '無怒凪' },
    ],
  },
  {
    quizId: '149',
    question:
      '第2部より問題です。\nワムウの風の最終流法に対するジョセフの作戦は？',
    options: [
      { optionId: '0', text: '波紋オイル作戦' },
      { optionId: '1', text: '火焔ビン作戦' },
      { optionId: '2', text: '灼熱波紋作戦' },
      { optionId: '3', text: '緋色波紋疾走作戦' },
      { optionId: '4', text: 'ダメで元元作戦' },
    ],
  },
  {
    quizId: '150',
    question:
      '第2部、ナレーション文より問題です。\n『ワムウは風になった――\nJOJOが無意識のうちにとっていたのは『○○』の姿であった――――――――――\n涙は流さなかったが　無言の男の詩があった――\n奇妙な友情があった――』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '敬礼' },
      { optionId: '1', text: 'お辞儀' },
      { optionId: '2', text: '合掌' },
      { optionId: '3', text: '感謝' },
      { optionId: '4', text: '脱力' },
    ],
  },
  {
    quizId: '151',
    question: 'リサリサの本名は？',
    options: [
      { optionId: '0', text: 'エリザベス・ジョースター' },
      { optionId: '1', text: 'キャサリン・ジョースター' },
      { optionId: '2', text: 'ジェシカ・ジョースター' },
      { optionId: '3', text: 'リリアン・ジョースター' },
      { optionId: '4', text: 'リサリサ・ジョースター' },
    ],
  },
  {
    quizId: '152',
    question:
      '第2部より問題です。\nジョセフの父親、ジョージ・ジョースターⅡ世を殺した吸血鬼はどんな職に就いていた？',
    options: [
      { optionId: '0', text: 'イギリス空軍司令官' },
      { optionId: '1', text: 'ロンドン警視庁警視総監' },
      { optionId: '2', text: 'イギリス首相' },
      { optionId: '3', text: 'イギリス空軍元帥' },
      { optionId: '4', text: 'イギリス空軍参謀総長' },
    ],
  },
  {
    quizId: '153',
    question:
      '第2部、シュトロハイムの台詞より問題です。\n「う… うろたえるんじゃあないッ！\n○○はうろたえないッ！」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'ドイツ軍人' },
      { optionId: '1', text: '我々' },
      { optionId: '2', text: '大人' },
      { optionId: '3', text: 'このシュトロハイム' },
      { optionId: '4', text: '強い者' },
    ],
  },
  {
    quizId: '154',
    question:
      '第2部より問題です。\n究極の生命体カーズは飲まず食わずでもどれだけの期間は活動が可能？',
    options: [
      { optionId: '0', text: '1年' },
      { optionId: '1', text: '3ヶ月' },
      { optionId: '2', text: '3年' },
      { optionId: '3', text: '10年' },
      { optionId: '4', text: '永遠' },
    ],
  },
  {
    quizId: '155',
    question: '第2部より問題です。\n究極の生命体カーズのJUMP力は？',
    options: [
      { optionId: '0', text: '18m' },
      { optionId: '1', text: '38m' },
      { optionId: '2', text: '65m' },
      { optionId: '3', text: '83m' },
      { optionId: '4', text: '100m以上' },
    ],
  },
  {
    quizId: '156',
    question: '第2部より問題です。\n究極の生命体カーズの握力は？',
    options: [
      { optionId: '0', text: '900kg/㎠' },
      { optionId: '1', text: '150kg/㎠' },
      { optionId: '2', text: '580kg/㎠' },
      { optionId: '3', text: '1500kg/㎠' },
      { optionId: '4', text: '2100kg/㎠' },
    ],
  },
  {
    quizId: '157',
    question: '第2部より問題です。\n究極の生命体カーズの視力は？',
    options: [
      { optionId: '0', text: '天体望遠鏡並' },
      { optionId: '1', text: '6' },
      { optionId: '2', text: '10' },
      { optionId: '3', text: '20' },
      { optionId: '4', text: '2' },
    ],
  },
  {
    quizId: '158',
    question: '第2部より問題です。\n究極の生命体カーズの知能指数は？',
    options: [
      { optionId: '0', text: 'IQ400' },
      { optionId: '1', text: 'IQ300' },
      { optionId: '2', text: 'IQ800' },
      { optionId: '3', text: 'IQ3000' },
      { optionId: '4', text: '計り知れない' },
    ],
  },
  {
    quizId: '159',
    question: '「波紋増幅器」とは何のこと？',
    options: [
      { optionId: '0', text: 'エイジャの赤石' },
      { optionId: '1', text: 'ワイン' },
      { optionId: '2', text: 'アメリカンクラッカー' },
      { optionId: '3', text: '波紋使いの肉体' },
      { optionId: '4', text: '石仮面' },
    ],
  },
  {
    quizId: '160',
    question:
      '第2部より問題です。\n噴火によって究極の生命体カーズを大気圏外へ飛ばした火山は？',
    options: [
      { optionId: '0', text: 'トルバチク火山' },
      { optionId: '1', text: 'セントヘレンズ火山' },
      { optionId: '2', text: 'エルブルス火山' },
      { optionId: '3', text: 'クリュチェフスカヤ火山' },
      { optionId: '4', text: 'ベズイミアニ火山' },
    ],
  },
  {
    quizId: '161',
    question:
      '第2部より問題です。\nカーズ戦で死んだと思われていたジョセフ・ジョースター、墓に刻まれていた名前は？',
    options: [
      { optionId: '0', text: 'JOSEF JOESTAR' },
      { optionId: '1', text: 'JOSEPH JOESTAR' },
      { optionId: '2', text: 'JOSEPF JOESTAR' },
      { optionId: '3', text: 'JOCEPH JOSTAR' },
      { optionId: '4', text: 'JOCEF JOESTAR' },
    ],
  },
  {
    quizId: '162',
    question: 'エリナ・ジョースターが老年も続けていた職業は？',
    options: [
      { optionId: '0', text: '小学校の英語教師' },
      { optionId: '1', text: '中学校の数学教師' },
      { optionId: '2', text: '小学校の数学教師' },
      { optionId: '3', text: '中学校の英語教師' },
      { optionId: '4', text: '看護婦' },
    ],
  },
  {
    quizId: '163',
    question: 'エリナ・ジョースターは享年何歳？',
    options: [
      { optionId: '0', text: '81歳' },
      { optionId: '1', text: '75歳' },
      { optionId: '2', text: '85歳' },
      { optionId: '3', text: '94歳' },
      { optionId: '4', text: '89歳' },
    ],
  },
  {
    quizId: '164',
    question: 'ロバート・E・O・スピードワゴンの死因は？',
    options: [
      { optionId: '0', text: '心臓発作' },
      { optionId: '1', text: '脳梗塞' },
      { optionId: '2', text: '肺ガン' },
      { optionId: '3', text: '交通事故' },
      { optionId: '4', text: '寿命' },
    ],
  },
  {
    quizId: '165',
    question: 'ロバート・E・O・スピードワゴンは享年何歳？',
    options: [
      { optionId: '0', text: '89歳' },
      { optionId: '1', text: '81歳' },
      { optionId: '2', text: '75歳' },
      { optionId: '3', text: '85歳' },
      { optionId: '4', text: '94歳' },
    ],
  },
  {
    quizId: '166',
    question: 'シュトロハイムのフルネームは？',
    options: [
      { optionId: '0', text: 'ルドル・フォン・シュトロハイム' },
      { optionId: '1', text: 'ルドルフ・ファン・シュトロハイム' },
      { optionId: '2', text: 'バルド・フォンス・シュトロハイム' },
      { optionId: '3', text: 'フランツ・フェン・シュトロハイム' },
      { optionId: '4', text: 'ティロ・ルファン・シュトロハイム' },
    ],
  },
  {
    quizId: '167',
    question: 'シュトロハイムは何の戦線で名誉の戦死を遂げ、生涯を終えた？',
    options: [
      { optionId: '0', text: 'スターリングラード戦線' },
      { optionId: '1', text: 'ドン戦線' },
      { optionId: '2', text: 'レニングラード戦線' },
      { optionId: '3', text: 'ザバイカル戦線' },
      { optionId: '4', text: 'カリーニン戦線' },
    ],
  },
  {
    quizId: '168',
    question:
      '2部の最後でジョセフがケネディ空港から乗ったと思われる、東京行き15：08発のアナウンスがかかっていた便は？',
    options: [
      { optionId: '0', text: 'アリタリア285便' },
      { optionId: '1', text: 'コードシェア285便' },
      { optionId: '2', text: '全日空285便' },
      { optionId: '3', text: 'デルタ航空285便' },
      { optionId: '4', text: 'アメリカン航空285便' },
    ],
  },
  {
    quizId: '169',
    question:
      '第2部の最後、ジョセフがケネディ空港でウォークマンを使い聴いていたのは誰の曲？',
    options: [
      { optionId: '0', text: 'THE BEATLES' },
      { optionId: '1', text: 'STING' },
      { optionId: '2', text: 'The Rolling Stones' },
      { optionId: '3', text: 'CARPENTERS' },
      { optionId: '4', text: 'Led Zeppelin' },
    ],
  },
  {
    quizId: '170',
    question: '第2部より問題です。\nシーザーが使っていない技は？',
    options: [
      { optionId: '0', text: 'シャボンバリア' },
      { optionId: '1', text: 'シャボン・カッター' },
      { optionId: '2', text: 'シャボンカッターグライディン' },
      { optionId: '3', text: 'シャボン・レンズ' },
      { optionId: '4', text: 'シャボンランチャー' },
    ],
  },
  {
    quizId: '171',
    question: '空条貞夫の職業は？',
    options: [
      { optionId: '0', text: 'ジャズミュージシャン' },
      { optionId: '1', text: '翻訳家' },
      { optionId: '2', text: '考古学者' },
      { optionId: '3', text: 'ロックミュージシャン' },
      { optionId: '4', text: '物理学者' },
    ],
  },
  {
    quizId: '172',
    question:
      '第3部より問題です。\n海底に沈んでいたディオを引き上げたのは何人組？',
    options: [
      { optionId: '0', text: '3人' },
      { optionId: '1', text: '2人' },
      { optionId: '2', text: '4人' },
      { optionId: '3', text: '5人' },
      { optionId: '4', text: '6人' },
    ],
  },
  {
    quizId: '173',
    question:
      '第3部より問題です。\n承太郎が刑務所に持ち込んだ本として間違っているのは？',
    options: [
      { optionId: '0', text: '魔導書' },
      { optionId: '1', text: '死者の書' },
      { optionId: '2', text: '神秘と魔法' },
      { optionId: '3', text: 'オカルト' },
      { optionId: '4', text: 'ESP' },
    ],
  },
  {
    quizId: '174',
    question:
      '第3部より問題です。\n承太郎が刑務所に持ち込んだ物として間違っているのは？',
    options: [
      { optionId: '0', text: 'テレビ' },
      { optionId: '1', text: 'ギター' },
      { optionId: '2', text: 'ダンベル' },
      { optionId: '3', text: 'エアロバイク' },
      { optionId: '4', text: 'ジャケット' },
    ],
  },
  {
    quizId: '175',
    question:
      '第3部より問題です。\n承太郎は刑務所に訪れたジョセフの指を抜きとりましたが、それは何指？',
    options: [
      { optionId: '0', text: '小指' },
      { optionId: '1', text: '親指' },
      { optionId: '2', text: '人差し指' },
      { optionId: '3', text: '中指' },
      { optionId: '4', text: '薬指' },
    ],
  },
  {
    quizId: '176',
    question:
      '第3部より問題です。\n承太郎を牢屋から出すために魔術師の赤を使ったアヴドゥル、その結果刑務所内の温度はどのくらいまで上がった？',
    options: [
      { optionId: '0', text: '45℃' },
      { optionId: '1', text: '40℃' },
      { optionId: '2', text: '50℃' },
      { optionId: '3', text: '55℃' },
      { optionId: '4', text: '60℃' },
    ],
  },
  {
    quizId: '177',
    question:
      '第3部より問題です。\n承太郎を牢屋から出すためにアヴドゥルが使用した技は？',
    options: [
      { optionId: '0', text: '赤い荒縄(レッド・バインド)' },
      { optionId: '1', text: '縛る炎(マジシャンズ・ロック)' },
      { optionId: '2', text: '拘束する劫火(レッド・クランプ)' },
      { optionId: '3', text: 'クロスファイヤーハリケーン' },
      { optionId: '4', text: 'レックアロー' },
    ],
  },
  {
    quizId: '178',
    question: '空条承太郎の、曾祖母にあたるのは？',
    options: [
      { optionId: '0', text: 'リサリサ' },
      { optionId: '1', text: 'メアリー' },
      { optionId: '2', text: 'エリナ' },
      { optionId: '3', text: 'スージーQ' },
      { optionId: '4', text: 'ホリィ' },
    ],
  },
  {
    quizId: '179',
    question:
      '第3部より問題です。\n日本でジョセフが念写に使ったカメラの型番は？',
    options: [
      { optionId: '0', text: 'Sun670' },
      { optionId: '1', text: 'F300EXR' },
      { optionId: '2', text: 'VS-FUN IR' },
      { optionId: '3', text: 'ＳＬＲ６８０' },
      { optionId: '4', text: 'SX-70' },
    ],
  },
  {
    quizId: '180',
    question:
      '第3部より問題です。\n花京院が法皇の緑(ハイエロファント・エメラルド)で保健室の先生を操ったとき、先生が体温計といって振っていたものは？',
    options: [
      { optionId: '0', text: '万年筆' },
      { optionId: '1', text: 'ボールペン' },
      { optionId: '2', text: 'ペーパーナイフ' },
      { optionId: '3', text: 'フォーク' },
      { optionId: '4', text: 'ハサミ' },
    ],
  },
  {
    quizId: '181',
    question:
      '「料金以下のマズイめしを食わせるレストランには代金を払わねーなんてのはしょっちゅうよ」\n誰の台詞？',
    options: [
      { optionId: '0', text: '空条承太郎' },
      { optionId: '1', text: 'ジョセフ・ジョースター' },
      { optionId: '2', text: '東方仗助' },
      { optionId: '3', text: '虹村億泰' },
      { optionId: '4', text: 'レオーネ・アバッキオ' },
    ],
  },
  {
    quizId: '182',
    question: '第3部より問題です。\n承太郎の実家、表札にはなんと書いてある？',
    options: [
      { optionId: '0', text: '空條' },
      { optionId: '1', text: '空条' },
      { optionId: '2', text: 'ジョースター' },
      { optionId: '3', text: '空城' },
      { optionId: '4', text: '空粂' },
    ],
  },
  {
    quizId: '183',
    question:
      '第3部より問題です。\nアヴドゥルがエジプトのカイロで占い師として店を出している市場(スーク)は？',
    options: [
      { optionId: '0', text: 'ハンハーリ' },
      { optionId: '1', text: 'キャメルマーケット' },
      { optionId: '2', text: 'スパイスバザール' },
      { optionId: '3', text: 'ゴールドスーク' },
      { optionId: '4', text: 'イエメンスーク' },
    ],
  },
  {
    quizId: '184',
    question: '第3部より問題です。\nホリィは日本の友人になんと呼ばれている？',
    options: [
      { optionId: '0', text: '聖子さん' },
      { optionId: '1', text: '奥様' },
      { optionId: '2', text: 'ホリィさん' },
      { optionId: '3', text: '空条さん' },
      { optionId: '4', text: 'ジョジョ' },
    ],
  },
  {
    quizId: '185',
    question:
      '第3部より問題です。\nジョセフの念写したDIOの写真で、DIOの背後にいたハエは？',
    options: [
      { optionId: '0', text: 'アスワン・ウェウェ・バエ' },
      { optionId: '1', text: 'アスワン・テェテェ・バエ' },
      { optionId: '2', text: 'アスワン・トゥトゥ・バエ' },
      { optionId: '3', text: 'アスワン・チェシャ・バエ' },
      { optionId: '4', text: 'アスワン・クゥフィ・バエ' },
    ],
  },
  {
    quizId: '186',
    question:
      '第3部より問題です。\n承太郎達が日本を発つとき、DIOが念写した写真には誰が写っていた？',
    options: [
      { optionId: '0', text: 'ジョセフと承太郎' },
      { optionId: '1', text: '承太郎のみ' },
      { optionId: '2', text: 'ジョセフのみ' },
      { optionId: '3', text: 'ジョセフと承太郎とアヴドゥル' },
      { optionId: '4', text: 'ジョセフと承太郎とアヴドゥルと花京院' },
    ],
  },
  {
    quizId: '187',
    question:
      '第3部より問題です。\n成田を20:30に発った承太郎達、当初の予定では飛行機で何時にカイロに着く予定だった？',
    options: [
      { optionId: '0', text: '0.541666666666667' },
      { optionId: '1', text: '0.375' },
      { optionId: '2', text: '0.458333333333333' },
      { optionId: '3', text: '0.625' },
      { optionId: '4', text: '0.708333333333333' },
    ],
  },
  {
    quizId: '188',
    question:
      '第3部より問題です。\n灰の塔(タワーオブグレー)が飛行機内に血で書いた文字は？',
    options: [
      { optionId: '0', text: 'massacre！' },
      { optionId: '1', text: 'Tower of Gray' },
      { optionId: '2', text: "LET'S KILLING" },
      { optionId: '3', text: '16' },
      { optionId: '4', text: 'mass murder' },
    ],
  },
  {
    quizId: '189',
    question:
      '第3部より問題です。\n灰の塔(タワーオブグレー)によってパイロットが殺された飛行機、ジョセフが不時着した場所は？',
    options: [
      { optionId: '0', text: '香港沖35km' },
      { optionId: '1', text: '台湾沖35km' },
      { optionId: '2', text: '上海沖35km' },
      { optionId: '3', text: 'ヒマラヤ山脈' },
      { optionId: '4', text: '天津市街' },
    ],
  },
  {
    quizId: '190',
    question:
      '第3部より問題です。\n承太郎達がポルナレフと初めて会った香港の料理店は？',
    options: [
      { optionId: '0', text: '翠園' },
      { optionId: '1', text: '華宴' },
      { optionId: '2', text: '陳家私菜' },
      { optionId: '3', text: '南海飯店' },
      { optionId: '4', text: '芳香園' },
    ],
  },
  {
    quizId: '191',
    question:
      '第3部より問題です。\n承太郎達とポルナレフが初めて会った料理店で、ジョセフがエビとアヒルとフカのヒレとキノコの料理を注文しようとして頼んだ料理でないものは？',
    options: [
      { optionId: '0', text: '蟹黄魚翅' },
      { optionId: '1', text: '煮帯子' },
      { optionId: '2', text: '梅子明炉鳥魚' },
      { optionId: '3', text: 'テイエンチー' },
      { optionId: '4', text: '皮蛋牛肉粥' },
    ],
  },
  {
    quizId: '192',
    question:
      '第3部より問題です。\n料理店を出て行われたポルナレフvsアヴドゥル戦、場所は香港のどこ？',
    options: [
      { optionId: '0', text: 'タイガーバームガーデン' },
      { optionId: '1', text: 'コーズウェイベイ' },
      { optionId: '2', text: 'ビクトリアピーク' },
      { optionId: '3', text: 'レパルスベイ' },
      { optionId: '4', text: 'シーサイドプロムナード' },
    ],
  },
  {
    quizId: '193',
    question:
      '第3部より問題です。\nポルナレフvsアヴドゥル戦で、防御甲冑を外した銀の戦車(シルバーチャリオッツ)は残像で何体に増えた？',
    options: [
      { optionId: '0', text: '7体' },
      { optionId: '1', text: '4体' },
      { optionId: '2', text: '5体' },
      { optionId: '3', text: '6体' },
      { optionId: '4', text: '8体' },
    ],
  },
  {
    quizId: '194',
    question: '第3部より問題です。\n香港で乗った船、本当の船長の名前は？',
    options: [
      { optionId: '0', text: 'テニール' },
      { optionId: '1', text: 'ダン' },
      { optionId: '2', text: 'デーボ' },
      { optionId: '3', text: 'ミドラー' },
      { optionId: '4', text: 'マライヤ' },
    ],
  },
  {
    quizId: '195',
    question: 'スタンド使いはタバコの煙を少しでも吸うとどうなる？',
    options: [
      { optionId: '0', text: '何もならない' },
      { optionId: '1', text: '鼻の頭に血管が浮き出る' },
      { optionId: '2', text: 'スタンドが勝手に出てくる' },
      { optionId: '3', text: '脳が活性化する' },
      { optionId: '4', text: '髪の毛が逆立つ' },
    ],
  },
  {
    quizId: '196',
    question: '第3部より問題です。\n空条承太郎の好きなスポーツ選手は？',
    options: [
      { optionId: '0', text: '千代の富士' },
      { optionId: '1', text: '旭富士' },
      { optionId: '2', text: '小錦' },
      { optionId: '3', text: '北勝海' },
      { optionId: '4', text: '落合博満' },
    ],
  },
  {
    quizId: '197',
    question: '第3部より問題です。\n空条承太郎の好きなミュージシャンは？',
    options: [
      { optionId: '0', text: '久保田利伸' },
      { optionId: '1', text: 'スティング' },
      { optionId: '2', text: '米米CLUB' },
      { optionId: '3', text: 'ビートルズ' },
      { optionId: '4', text: 'ザ・ブルーハーツ' },
    ],
  },
  {
    quizId: '198',
    question: '第3部より問題です。\n空条承太郎の好きな映画は？',
    options: [
      { optionId: '0', text: 'ネバー・クライ・ウルフ' },
      { optionId: '1', text: 'ゴーストバスターズ' },
      { optionId: '2', text: 'がんばれ ベアーズ' },
      { optionId: '3', text: 'ロッキー' },
      { optionId: '4', text: 'ミッド・ナイトラン' },
    ],
  },
  {
    quizId: '199',
    question: '第3部より問題です。\n空条承太郎の血液型は？',
    options: [
      { optionId: '0', text: 'B型' },
      { optionId: '1', text: 'A型' },
      { optionId: '2', text: 'AB型' },
      { optionId: '3', text: 'O型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '200',
    question:
      '第3部より問題です。\n暗青の月(ダークブルームーン)のスタンド使いの潜水自己ベストは？',
    options: [
      { optionId: '0', text: '6分12秒' },
      { optionId: '1', text: '4分42秒' },
      { optionId: '2', text: '5分38秒' },
      { optionId: '3', text: '7分8秒' },
      { optionId: '4', text: '8分26秒' },
    ],
  },
  {
    quizId: '201',
    question:
      '第3部より問題です。\n暗青の月(ダークブルームーン)を倒した白金の星の技「スターフィンガー」漢字表記は？',
    options: [
      { optionId: '0', text: '流星指刺' },
      { optionId: '1', text: '一星指突' },
      { optionId: '2', text: '光星一突' },
      { optionId: '3', text: '白金突実' },
      { optionId: '4', text: '金星隆針' },
    ],
  },
  {
    quizId: '202',
    question:
      '第3部より問題です。\n力(ストレングス)のスタンドを操っていたのは？',
    options: [
      { optionId: '0', text: 'オランウータン' },
      { optionId: '1', text: 'ゴリラ' },
      { optionId: '2', text: 'マンドリル' },
      { optionId: '3', text: 'ナマケモノ' },
      { optionId: '4', text: 'ビッグフット' },
    ],
  },
  {
    quizId: '203',
    question:
      '第3部より問題です。\n力(ストレングス)のスタンド使いが見ていた本のタイトルは？',
    options: [
      { optionId: '0', text: 'PLAY BOP' },
      { optionId: '1', text: 'MONKEY' },
      { optionId: '2', text: 'GIRL LADY' },
      { optionId: '3', text: 'G-S H' },
      { optionId: '4', text: 'found see' },
    ],
  },
  {
    quizId: '204',
    question:
      '第3部より問題です。\n力(ストレングス)の船でシャワーを使用した際の擬音は？',
    options: [
      { optionId: '0', text: 'シャワー' },
      { optionId: '1', text: 'ブワアァ' },
      { optionId: '2', text: 'ジョァー' },
      { optionId: '3', text: 'シュゥー' },
      { optionId: '4', text: 'タタタタタ' },
    ],
  },
  {
    quizId: '205',
    question: '第3部より問題です。\n花京院典明の血液型は？',
    options: [
      { optionId: '0', text: 'A型' },
      { optionId: '1', text: 'B型' },
      { optionId: '2', text: 'O型' },
      { optionId: '3', text: 'AB型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '206',
    question: '第3部より問題です。\n花京院典明の好きなミュージシャンは？',
    options: [
      { optionId: '0', text: 'スティング' },
      { optionId: '1', text: 'ビートルズ' },
      { optionId: '2', text: 'ザ・ブルーハーツ' },
      { optionId: '3', text: '久保田利伸' },
      { optionId: '4', text: '米米CLUB' },
    ],
  },
  {
    quizId: '207',
    question: '第3部より問題です。\n花京院典明の好きなプロ野球チームは？',
    options: [
      { optionId: '0', text: '巨人' },
      { optionId: '1', text: 'ホエールズ' },
      { optionId: '2', text: 'カープ' },
      { optionId: '3', text: 'バファローズ' },
      { optionId: '4', text: 'ライオンズ' },
    ],
  },
  {
    quizId: '208',
    question: '第3部より問題です。\n花京院典明の好きな俳優は？',
    options: [
      { optionId: '0', text: '田村正和' },
      { optionId: '1', text: '宇津井健' },
      { optionId: '2', text: '緒形拳' },
      { optionId: '3', text: '里見浩太朗' },
      { optionId: '4', text: '武田鉄矢' },
    ],
  },
  {
    quizId: '209',
    question: '第3部より問題です。\n花京院典明の身長は？',
    options: [
      { optionId: '0', text: '178cm' },
      { optionId: '1', text: '173cm' },
      { optionId: '2', text: '184cm' },
      { optionId: '3', text: '188cm' },
      { optionId: '4', text: '191cm' },
    ],
  },
  {
    quizId: '210',
    question: '第3部より問題です。\nシンガポールでゴミを捨てた際の罰金は？',
    options: [
      { optionId: '0', text: '500Sドル' },
      { optionId: '1', text: '300Sドル' },
      { optionId: '2', text: '800Sドル' },
      { optionId: '3', text: '1000Sドル' },
      { optionId: '4', text: '1500Sドル' },
    ],
  },
  {
    quizId: '211',
    question: '第3部より問題です。\n悪魔(エボニーデビル)のスタンド使いは誰？',
    options: [
      { optionId: '0', text: 'デーボ' },
      { optionId: '1', text: 'ダン' },
      { optionId: '2', text: 'テニール' },
      { optionId: '3', text: 'ミドラー' },
      { optionId: '4', text: 'マライヤ' },
    ],
  },
  {
    quizId: '212',
    question:
      '第3部より問題です。\n悪魔(エボニーデビル)に襲われたシンガポールのホテル、悪魔(エボニーデビル)のスタンドへの対策のため集合した部屋は？',
    options: [
      { optionId: '0', text: '1212号室' },
      { optionId: '1', text: '912号室' },
      { optionId: '2', text: '213号室' },
      { optionId: '3', text: '3245号室' },
      { optionId: '4', text: '324号室' },
    ],
  },
  {
    quizId: '213',
    question:
      '第3部より問題です。\n悪魔(エボニーデビル)に襲われたシンガポールのホテル、ポルナレフの部屋番号は？',
    options: [
      { optionId: '0', text: '912号室' },
      { optionId: '1', text: '1212号室' },
      { optionId: '2', text: '213号室' },
      { optionId: '3', text: '3245号室' },
      { optionId: '4', text: '324号室' },
    ],
  },
  {
    quizId: '214',
    question:
      '第3部より問題です。\nシンガポールで売られていたヤシの実の果汁、一つあたりの値段は？',
    options: [
      { optionId: '0', text: '4Sドル' },
      { optionId: '1', text: '1Sドル' },
      { optionId: '2', text: '2Sドル' },
      { optionId: '3', text: '3Sドル' },
      { optionId: '4', text: '5Sドル' },
    ],
  },
  {
    quizId: '215',
    question:
      '第3部より問題です。\n黄の節制(イエローテンパランス)のスタンド使いと承太郎がはじめに乗ったケーブルカーの番号は？',
    options: [
      { optionId: '0', text: '23' },
      { optionId: '1', text: '11' },
      { optionId: '2', text: '14' },
      { optionId: '3', text: '17' },
      { optionId: '4', text: '20' },
    ],
  },
  {
    quizId: '216',
    question:
      '第3部より問題です。\n黄の節制(イエローテンパランス)のスタンド使いと承太郎が飛び移ったケーブルカーの番号は？',
    options: [
      { optionId: '0', text: '14' },
      { optionId: '1', text: '11' },
      { optionId: '2', text: '17' },
      { optionId: '3', text: '20' },
      { optionId: '4', text: '23' },
    ],
  },
  {
    quizId: '217',
    question:
      '第3部より問題です。\nケーブルカーで黄の節制(イエローテンパランス)に取り込まれた犬の名前は？',
    options: [
      { optionId: '0', text: 'ポッキー' },
      { optionId: '1', text: 'ダニー' },
      { optionId: '2', text: 'コメット' },
      { optionId: '3', text: 'フランツ' },
      { optionId: '4', text: 'ポリス' },
    ],
  },
  {
    quizId: '218',
    question:
      '第3部より問題です。\n承太郎が黄の節制(イエローテンパランス)のスタンド使いにこれから襲ってくる「スタンド使い」の情報を問うたときに、得た情報に含まれないのは？',
    options: [
      { optionId: '0', text: '正義' },
      { optionId: '1', text: '死神' },
      { optionId: '2', text: '女帝' },
      { optionId: '3', text: '吊られた男' },
      { optionId: '4', text: '皇帝' },
    ],
  },
  {
    quizId: '219',
    question:
      '第3部より問題です。\n紅茶と砂糖としょうがを牛乳で煮込んだ、インドの庶民的飲物は？',
    options: [
      { optionId: '0', text: 'チャーイ' },
      { optionId: '1', text: 'スペート' },
      { optionId: '2', text: 'ミョイム' },
      { optionId: '3', text: 'ケティル' },
      { optionId: '4', text: 'クテル' },
    ],
  },
  {
    quizId: '220',
    question:
      '第3部より問題です。\n吊られた男(ハングドマン)と皇帝(エンペラー)から逃げるため、花京院とポルナレフが乗った車はどこのメーカーのもの？',
    options: [
      { optionId: '0', text: 'LANCIA' },
      { optionId: '1', text: 'Marcos' },
      { optionId: '2', text: 'RUF' },
      { optionId: '3', text: 'SUZUKI' },
      { optionId: '4', text: 'TOYOTA' },
    ],
  },
  {
    quizId: '221',
    question:
      '次のプロフィールは誰のもの？\n射手座生まれ\n血液型 : AB型\n趣味 : スポーツならなんでも。\n好きな色 : 黄金色(ゴールド)',
    options: [
      { optionId: '0', text: 'ジャン・ピエール・ポリナレフ' },
      { optionId: '1', text: 'ジョルノ・ジョバーナ' },
      { optionId: '2', text: '東方仗助' },
      { optionId: '3', text: '音石明' },
      { optionId: '4', text: 'トリッシュ・ウナ' },
    ],
  },
  {
    quizId: '222',
    question:
      '第3部、ポルナレフの台詞より問題です。\nJ・P・ポルナレフの身長は？\n(髪は含めず)',
    options: [
      { optionId: '0', text: '185cm' },
      { optionId: '1', text: '169cm' },
      { optionId: '2', text: '174cm' },
      { optionId: '3', text: '180cm' },
      { optionId: '4', text: '193cm' },
    ],
  },
  {
    quizId: '223',
    question:
      '第3部、ポルナレフの台詞より問題です。\nJ・P・ポルナレフの身長は？\n(髪を含む)',
    options: [
      { optionId: '0', text: '193cm' },
      { optionId: '1', text: '169cm' },
      { optionId: '2', text: '174cm' },
      { optionId: '3', text: '180cm' },
      { optionId: '4', text: '185cm' },
    ],
  },
  {
    quizId: '224',
    question:
      '第3部、ポルナレフの台詞より問題です。\nJ・P・ポルナレフの好きな映画は？',
    options: [
      { optionId: '0', text: 'がんばれ ベアーズ' },
      { optionId: '1', text: 'ネバー・クライ・ウルフ' },
      { optionId: '2', text: 'ゴーストバスターズ' },
      { optionId: '3', text: 'ロッキー' },
      { optionId: '4', text: 'ミッド・ナイトラン' },
    ],
  },
  {
    quizId: '225',
    question:
      '第3部、ポルナレフの台詞より問題です。\n「『我が名はJ・P・ポルナレフ』\n『我が妹の魂の名誉のために！』\n『我が友アヴドゥルの心の安らぎのために』………\n『この俺が貴様を○○へブチ込んでやる』 J・ガイル………」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '絶望の淵' },
      { optionId: '1', text: '地獄' },
      { optionId: '2', text: '牢屋' },
      { optionId: '3', text: '閻魔大王のところ' },
      { optionId: '4', text: '奈落' },
    ],
  },
  {
    quizId: '226',
    question:
      '第3部より問題です。\n作画によりポルナレフ自身が両右手になっているシーンがありますが、それはいつ？',
    options: [
      { optionId: '0', text: '吊られた男(ハングドマン)戦' },
      { optionId: '1', text: '魔術師の赤(マジシャンズレッド)戦' },
      { optionId: '2', text: '暗青の月(ダークブルームーン)戦' },
      { optionId: '3', text: '力(ストレングス)戦' },
      { optionId: '4', text: '悪魔(エボニーデビル)戦' },
    ],
  },
  {
    quizId: '227',
    question: '第3部より問題です。\nネーナのスタンドは？',
    options: [
      { optionId: '0', text: '女帝(エンプレス)' },
      { optionId: '1', text: '恋人(ラバーズ)' },
      { optionId: '2', text: 'バステト女神' },
      { optionId: '3', text: '死神(デス・サーティーン）' },
      { optionId: '4', text: 'スタンド使いではない' },
    ],
  },
  {
    quizId: '228',
    question:
      '第3部より問題です。\n聖地ベナレスで承太郎達が泊まっていた(チェックインしていた)ホテルは？',
    options: [
      { optionId: '0', text: 'ホテル・クラークス' },
      { optionId: '1', text: 'ホテル・ベナレス' },
      { optionId: '2', text: 'ホテル・ヴィンス' },
      { optionId: '3', text: 'ホテル・フローフト' },
      { optionId: '4', text: 'ホテル・プラムクリーク' },
    ],
  },
  {
    quizId: '229',
    question: '第3部で、ジョセフがした相手の言葉の先読みは？',
    options: [
      { optionId: '0', text: '「やめてそれだけは」' },
      { optionId: '1', text: '「次はお前の番だ」' },
      { optionId: '2', text: '「それがどうした」' },
      { optionId: '3', text: '「そんなのしたことがないんだぜ」' },
      { optionId: '4', text: '「何か企んでいるな」' },
    ],
  },
  {
    quizId: '230',
    question:
      '第3部より問題です。\n運命の車輪(ホウイール・オブ・フォーチュン)に襲われた際に承太郎たちが乗っていたランクルのナンバーは？',
    options: [
      { optionId: '0', text: 'V972' },
      { optionId: '1', text: '0TF8F' },
      { optionId: '2', text: 'O8413' },
      { optionId: '3', text: 'K58-93' },
      { optionId: '4', text: '46-75' },
    ],
  },
  {
    quizId: '231',
    question:
      '第3部より問題です。\n運命の車輪(ホウイール・オブ・フォーチュン)の車のナンバーは？',
    options: [
      { optionId: '0', text: '0TF8F' },
      { optionId: '1', text: 'V972' },
      { optionId: '2', text: 'O8413' },
      { optionId: '3', text: 'K58-93' },
      { optionId: '4', text: '46-75' },
    ],
  },
  {
    quizId: '232',
    question:
      '第3部、承太郎の台詞より問題です。\n「やかましいッ！  うっおとしいぜッ!!  おまえらッ！」\nおまえらに含まれないのは？',
    options: [
      { optionId: '0', text: 'モハメド・アヴドゥル' },
      { optionId: '1', text: 'ジョセフ・ジョースター' },
      { optionId: '2', text: '花京院典明' },
      { optionId: '3', text: 'ジャン・P・ポルナレフ' },
      { optionId: '4', text: '家出少女' },
    ],
  },
  {
    quizId: '233',
    question:
      '第3部より問題です。\nパキスタンで仕立ててもらった承太郎のガクラン、素材は何？',
    options: [
      { optionId: '0', text: 'ウール100％' },
      { optionId: '1', text: 'ウール80％、ポリエステル20％' },
      { optionId: '2', text: 'ウール50％、ポリエステル50％' },
      { optionId: '3', text: 'ウール20％、ポリエステル80％' },
      { optionId: '4', text: 'ポリエステル100％' },
    ],
  },
  {
    quizId: '234',
    question:
      '第3部より問題です。\n正義(ジャスティス)に操られたポルナレフ、何によって舌を傷つけられた？',
    options: [
      { optionId: '0', text: '舌' },
      { optionId: '1', text: 'はさみ' },
      { optionId: '2', text: '皇帝(エンペラー)' },
      { optionId: '3', text: 'カミソリ' },
      { optionId: '4', text: 'ペン' },
    ],
  },
  {
    quizId: '235',
    question:
      '第3部より問題です。\nエンヤ婆の宿で、花京院は宿帳になんと書いている？',
    options: [
      { optionId: '0', text: 'Tenmei Kakyoin' },
      { optionId: '1', text: 'Noriaki Kakyoin' },
      { optionId: '2', text: 'Noriaki KaQin' },
      { optionId: '3', text: 'Noriaki・Q・Kakyoin' },
      { optionId: '4', text: 'Noriaki Kayoin' },
    ],
  },
  {
    quizId: '236',
    question:
      '第3部より問題です。\nパキスタンの首都カラチで、ジョセフはドネル・ケバブを何円で購入した？',
    options: [
      { optionId: '0', text: '425円' },
      { optionId: '1', text: '150円' },
      { optionId: '2', text: '300円' },
      { optionId: '3', text: '650円' },
      { optionId: '4', text: '1000円' },
    ],
  },
  {
    quizId: '237',
    question: '第3部より問題です。\n承太郎がしている腕時計は？',
    options: [
      { optionId: '0', text: 'タグホイヤー' },
      { optionId: '1', text: 'フランク・ミュラー' },
      { optionId: '2', text: 'ダニエル・ロート' },
      { optionId: '3', text: 'オブレイ' },
      { optionId: '4', text: 'ボーム＆メルシェ' },
    ],
  },
  {
    quizId: '238',
    question:
      '第3部より問題です。\nジョセフの体内に入り込んだ恋人(ラバーズ)、体内のどこに潜んでいた？',
    options: [
      { optionId: '0', text: '脳幹' },
      { optionId: '1', text: '小脳' },
      { optionId: '2', text: '大脳' },
      { optionId: '3', text: '頭頂葉' },
      { optionId: '4', text: '心臓' },
    ],
  },
  {
    quizId: '239',
    question:
      '第3部より問題です。\n恋人(ラバーズ)のスタンド使いへ対し、承太郎がメモしていたツケの内容として間違っているものは？',
    options: [
      { optionId: '0', text: '万引きをさせられ、それをチクられた' },
      { optionId: '1', text: '背中をかかされた' },
      { optionId: '2', text: 'クツみがきをさせられ蹴りを入れられた' },
      { optionId: '3', text: '石で殴られた' },
      { optionId: '4', text: 'ドブ川の橋にされ、さんざ足で踏まれた' },
    ],
  },
  {
    quizId: '240',
    question:
      '第3部より問題です。\n花京院がポルナレフのピアスをつけているシーンがありますが、それはいつ？',
    options: [
      { optionId: '0', text: '恋人(ラバーズ)戦' },
      { optionId: '1', text: '暗青の海(ダークブルームーン)戦' },
      { optionId: '2', text: '死神(デス・サーティーン）戦' },
      { optionId: '3', text: 'ゲブ神戦' },
      { optionId: '4', text: 'オシリス神戦' },
    ],
  },
  {
    quizId: '241',
    question:
      '第3部より問題です。\nジョセフはラクダの乗り方を、何という映画を観て知った？',
    options: [
      { optionId: '0', text: 'アラビアのロレンス' },
      { optionId: '1', text: 'シェルタリング・スカイ' },
      { optionId: '2', text: '少年とラクダ' },
      { optionId: '3', text: '黒い砂漠' },
      { optionId: '4', text: 'ホワイト・サンズ' },
    ],
  },
  {
    quizId: '242',
    question:
      '第3部より問題です。\n承太郎達が太陽(サン)のスタンドに攻撃されていることに気付いたのはいつ？',
    options: [
      { optionId: '0', text: '8時10分頃' },
      { optionId: '1', text: '6時頃' },
      { optionId: '2', text: '7時30頃' },
      { optionId: '3', text: '9時20分頃' },
      { optionId: '4', text: '10時40分頃' },
    ],
  },
  {
    quizId: '243',
    question:
      '第3部より問題です。\n死神13(デスサーティーン)の能力で花京院が初めて夢の世界に行ったときに乗っていた乗り物は？',
    options: [
      { optionId: '0', text: '観覧車' },
      { optionId: '1', text: 'ジェットコースター' },
      { optionId: '2', text: '電車' },
      { optionId: '3', text: 'ゴーカート' },
      { optionId: '4', text: 'コーヒーカップ' },
    ],
  },
  {
    quizId: '244',
    question:
      '第3部より問題です。\n死神13(デスサーティーン)のスタンド使いの赤ん坊を乗せたセスナ、機体に書かれていた番号は？',
    options: [
      { optionId: '0', text: 'MJ1264' },
      { optionId: '1', text: 'JG1456' },
      { optionId: '2', text: 'TD1686' },
      { optionId: '3', text: 'ES6532' },
      { optionId: '4', text: 'SK2063' },
    ],
  },
  {
    quizId: '245',
    question:
      '死神13(デスサーティーン)の能力でポルナレフと花京院が夢の世界に行ったとき、最初に犬の死体から出てきたのは？',
    options: [
      { optionId: '0', text: '拡声器' },
      { optionId: '1', text: 'スピーカー' },
      { optionId: '2', text: '銀の戦車(シルバーチャリオッツ)' },
      { optionId: '3', text: 'トランプ' },
      { optionId: '4', text: '死神' },
    ],
  },
  {
    quizId: '246',
    question:
      '第3部より問題です。\n死神13(デスサーティーン)のスタンド使いである赤ん坊は何歳？',
    options: [
      { optionId: '0', text: '生後11ヶ月' },
      { optionId: '1', text: '生後半年' },
      { optionId: '2', text: '生後8ヶ月' },
      { optionId: '3', text: '1歳' },
      { optionId: '4', text: '1歳と2ヶ月' },
    ],
  },
  {
    quizId: '247',
    question: '第3部より問題です。\n死神13(デスサーティーン)の多用する言葉は？',
    options: [
      { optionId: '0', text: 'ラリホー' },
      { optionId: '1', text: 'ザメハ' },
      { optionId: '2', text: 'スリプル' },
      { optionId: '3', text: 'ドリーム' },
      { optionId: '4', text: 'ドゥーユーアンダスタン' },
    ],
  },
  {
    quizId: '248',
    question:
      '第3部より問題です。\n紅海を渡っているときに寄った無人島でアヴドゥルが餌をあげていたニワトリは？',
    options: [
      { optionId: '0', text: 'ライオネル' },
      { optionId: '1', text: 'ジェシカ' },
      { optionId: '2', text: 'プリンセス' },
      { optionId: '3', text: 'ガジル' },
      { optionId: '4', text: 'ロック' },
    ],
  },
  {
    quizId: '249',
    question: '第3部より問題です。\n審判(ジャッジメント)の多用する言葉は？',
    options: [
      { optionId: '0', text: 'Hail 2 U！' },
      { optionId: '1', text: 'Hail to You！' },
      { optionId: '2', text: 'Hell to You！' },
      { optionId: '3', text: 'Hell 2 U！' },
      { optionId: '4', text: 'Hay 2 U' },
    ],
  },
  {
    quizId: '250',
    question:
      '第3部より問題です。\n審判(ジャッジメント)に4つにしてもらったアヴドゥルの願い、第1の願いは？',
    options: [
      { optionId: '0', text: '「痛みの叫び」を出させること' },
      { optionId: '1', text: '「苦しみの絶叫」をあげさせること' },
      { optionId: '2', text: '「恐怖の悲鳴」をあげさせること' },
      { optionId: '3', text: '「後悔の泣き声」を出させること' },
      { optionId: '4', text: '「心からの謝罪」を言わせること' },
    ],
  },
  {
    quizId: '251',
    question:
      '第3部より問題です。\n審判(ジャッジメント)のスタンド使いが地中から息をするために出していた筒にポルナレフが入れていったものとして間違っているのは？',
    options: [
      { optionId: '0', text: '小石' },
      { optionId: '1', text: '泥' },
      { optionId: '2', text: 'くも' },
      { optionId: '3', text: '蟻' },
      { optionId: '4', text: 'マッチ' },
    ],
  },
  {
    quizId: '252',
    question:
      '第3部より問題です。\n女教皇(ハイプリエステス)に最初に攻撃されたのは誰？',
    options: [
      { optionId: '0', text: 'ジョセフ・ジョースター' },
      { optionId: '1', text: '空条承太郎' },
      { optionId: '2', text: '花京院典明' },
      { optionId: '3', text: 'モハメド・アヴドゥル' },
      { optionId: '4', text: 'ジャン・ピエール・ポルナレフ' },
    ],
  },
  {
    quizId: '253',
    question:
      '第3部より問題です。\n女教皇(ハイプリエステス)が化けたものとして間違っているのは？',
    options: [
      { optionId: '0', text: '時計' },
      { optionId: '1', text: 'レギュレーター' },
      { optionId: '2', text: 'ドアの取っ手' },
      { optionId: '3', text: 'カミソリ' },
      { optionId: '4', text: 'コーヒーカップ' },
    ],
  },
  {
    quizId: '254',
    question:
      '第3部より問題です。\n女教皇(ハイプリエステス)のスタンド使い、ミドラーの声を、花京院は誰の声と似てませんか、と言っていた？',
    options: [
      { optionId: '0', text: 'オードリー・ヘプバーン' },
      { optionId: '1', text: 'エリザベス・テイラー' },
      { optionId: '2', text: 'ジェーン・フォンダ' },
      { optionId: '3', text: 'ソフィア・ローレン' },
      { optionId: '4', text: 'ヴァネッサ・レッドグレイヴ' },
    ],
  },
  {
    quizId: '255',
    question: '第3部より問題です。\nモハメド・アヴドゥルの血液型は？',
    options: [
      { optionId: '0', text: 'AB型' },
      { optionId: '1', text: 'A型' },
      { optionId: '2', text: 'B型' },
      { optionId: '3', text: 'O型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '256',
    question: '第3部より問題です。\nモハメド・アヴドゥルの身長は？',
    options: [
      { optionId: '0', text: '188ｃｍ' },
      { optionId: '1', text: '172cm' },
      { optionId: '2', text: '178cm' },
      { optionId: '3', text: '182cm' },
      { optionId: '4', text: '195cm' },
    ],
  },
  {
    quizId: '257',
    question: '第3部より問題です。\nモハメド・アヴドゥルの好きな色は？',
    options: [
      { optionId: '0', text: 'オレンジ' },
      { optionId: '1', text: 'マリンブルー' },
      { optionId: '2', text: 'アトモスグリーン' },
      { optionId: '3', text: 'ペールサロー' },
      { optionId: '4', text: 'コバルトブルー' },
    ],
  },
  {
    quizId: '258',
    question: '第3部より問題です。\nモハメド・アヴドゥルの好きな食べ物は？',
    options: [
      { optionId: '0', text: 'すし' },
      { optionId: '1', text: 'てんぷら' },
      { optionId: '2', text: '麻婆豆腐' },
      { optionId: '3', text: 'ビーフ・ストロガノフ' },
      { optionId: '4', text: 'ボルシチ' },
    ],
  },
  {
    quizId: '259',
    question: '第3部より問題です。\nモハメド・アヴドゥルの趣味は？',
    options: [
      { optionId: '0', text: '古書集め' },
      { optionId: '1', text: '占星術' },
      { optionId: '2', text: 'ライター集め' },
      { optionId: '3', text: 'ビリヤード' },
      { optionId: '4', text: 'ポーカー' },
    ],
  },
  {
    quizId: '260',
    question:
      '第3部より問題です。\n愚者(ザ・フール)のスタンド使いのイギー、何味のチューインガムが好物？',
    options: [
      { optionId: '0', text: 'コーヒー味' },
      { optionId: '1', text: 'オレンジ味' },
      { optionId: '2', text: 'グレープ味' },
      { optionId: '3', text: 'ミント味' },
      { optionId: '4', text: '抹茶味' },
    ],
  },
  {
    quizId: '261',
    question:
      '第3部より問題です。\nゲブ神との戦闘中、スピードワゴン財団の人間のアラームは何時に鳴った？',
    options: [
      { optionId: '0', text: '0.583333333333333' },
      { optionId: '1', text: '0.416666666666667' },
      { optionId: '2', text: '0.5' },
      { optionId: '3', text: '0.666666666666667' },
      { optionId: '4', text: '0.75' },
    ],
  },
  {
    quizId: '262',
    question:
      '第3部より問題です。\n空中に砂を巻き上げ、反射音で承太郎たちの位置を特定した際のンドゥールの台詞\n「聞こえるぞ反射音が…… 承太郎…… 位置も高さもわかった！ ○○！」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '狙撃(シュートヒム)' },
      { optionId: '1', text: '狙撃(ショットガイ)' },
      { optionId: '2', text: '狙撃(ファイアメン)' },
      { optionId: '3', text: '狙撃(バーストゼイ)' },
      { optionId: '4', text: '狙撃(チャージーズ)' },
    ],
  },
  {
    quizId: '263',
    question: '第3部より問題です。\nンドゥールのスタンドは？',
    options: [
      { optionId: '0', text: 'ゲブ神' },
      { optionId: '1', text: 'オシリス神' },
      { optionId: '2', text: 'アトゥム神' },
      { optionId: '3', text: 'クヌム神' },
      { optionId: '4', text: 'ホルス神' },
    ],
  },
  {
    quizId: '264',
    question: '第3部より問題です。\nゲブ神は何の神？',
    options: [
      { optionId: '0', text: '大地の神' },
      { optionId: '1', text: '冥界の神' },
      { optionId: '2', text: '嵐と暴力の神' },
      { optionId: '3', text: '創造の神' },
      { optionId: '4', text: '天空の神' },
    ],
  },
  {
    quizId: '265',
    question:
      '第3部より問題です。\n本を売ってくれと頼んだ、親切な旅人がボインゴにあげたお菓子は？',
    options: [
      { optionId: '0', text: 'タベッコドーナツ' },
      { optionId: '1', text: 'ヘンシンビスケット' },
      { optionId: '2', text: 'ダイスキクッキー' },
      { optionId: '3', text: 'エリンギの里' },
      { optionId: '4', text: 'オムスビセンベイ' },
    ],
  },
  {
    quizId: '266',
    question:
      '第3部より問題です。\nボインゴのスタンド、トト神の本のタイトルは？',
    options: [
      { optionId: '0', text: 'オインゴとボインゴ兄弟 大冒険' },
      { optionId: '1', text: 'オインゴとボインゴ兄弟 運命日記' },
      { optionId: '2', text: 'オインゴとボインゴ兄弟の奇妙な冒険' },
      { optionId: '3', text: 'オインゴとボインゴ兄弟 旅行記' },
      { optionId: '4', text: 'オインゴとボインゴ兄弟の不思議な話' },
    ],
  },
  {
    quizId: '267',
    question: '第3部より問題です。\n承太郎たちが毒入りの紅茶を口にした店は？',
    options: [
      { optionId: '0', text: 'MAXIM' },
      { optionId: '1', text: 'CAFFEE' },
      { optionId: '2', text: 'GREEN' },
      { optionId: '3', text: 'LILIC' },
      { optionId: '4', text: 'KOFOOK' },
    ],
  },
  {
    quizId: '268',
    question: '第3部より問題です。\n空条承太郎の意外な特技は？',
    options: [
      {
        optionId: '0',
        text: '手を使わず火のついたタバコを口の中に5本入れ、火を消さずにコーラを飲む',
      },
      { optionId: '1', text: '花京院のものまね' },
      { optionId: '2', text: 'ポルナレフのものまね' },
      { optionId: '3', text: '円周率の500桁暗記' },
      { optionId: '4', text: 'タバコの煙を自由な形で口から出せる' },
    ],
  },
  {
    quizId: '269',
    question:
      '第3部より問題です。\nアスワンでの花京院とアヴドゥルの治療費はいくら？',
    options: [
      { optionId: '0', text: '46,350エジプトポンド' },
      { optionId: '1', text: '29,500エジプトポンド' },
      { optionId: '2', text: '35,000エジプトポンド' },
      { optionId: '3', text: '41,700エジプトポンド' },
      { optionId: '4', text: '50,250エジプトポンド' },
    ],
  },
  {
    quizId: '270',
    question:
      '第3部より問題です。\nアヌビス神がコム・オンボでポルナレフと戦ったときに操っていたのは誰？',
    options: [
      { optionId: '0', text: 'チャカ' },
      { optionId: '1', text: 'サイイド' },
      { optionId: '2', text: 'ハサン' },
      { optionId: '3', text: 'ラオ' },
      { optionId: '4', text: 'トール' },
    ],
  },
  {
    quizId: '271',
    question:
      '第3部より問題です。\nエジプト、コム・オンボで旅の記念にとポルナレフに売ろうとしていた、紙の起源は？',
    options: [
      { optionId: '0', text: 'パピルス' },
      { optionId: '1', text: 'プリニウス' },
      { optionId: '2', text: 'フェルト' },
      { optionId: '3', text: 'パーチメント' },
      { optionId: '4', text: 'ヴェラム' },
    ],
  },
  {
    quizId: '272',
    question:
      '第3部より問題です。\nフツーのエジプト人でブタを食べない人の衣裳は？',
    options: [
      { optionId: '0', text: 'カラベーヤ' },
      { optionId: '1', text: 'チャドル' },
      { optionId: '2', text: 'ミラーヤ' },
      { optionId: '3', text: 'ガラビア' },
      { optionId: '4', text: 'ロインクロス' },
    ],
  },
  {
    quizId: '273',
    question: '第3部より問題です。\n作中でアヌビス神が操った人間の数は何人？',
    options: [
      { optionId: '0', text: '4人' },
      { optionId: '1', text: '2人' },
      { optionId: '2', text: '3人' },
      { optionId: '3', text: '5人' },
      { optionId: '4', text: '6人' },
    ],
  },
  {
    quizId: '274',
    question:
      '第3部より問題です。\nアヌビス神がイギーに邪魔され落ちてしまったのはどこ？',
    options: [
      { optionId: '0', text: 'ナイル川' },
      { optionId: '1', text: '紅海' },
      { optionId: '2', text: 'ナセル湖' },
      { optionId: '3', text: 'ペルシウム川' },
      { optionId: '4', text: '地中海' },
    ],
  },
  {
    quizId: '275',
    question:
      '第3部より問題です。\nルクソールでのホテル、ジョセフが泊まった部屋番号は？',
    options: [
      { optionId: '0', text: '213号室' },
      { optionId: '1', text: '912号室' },
      { optionId: '2', text: '1212号室' },
      { optionId: '3', text: '3245号室' },
      { optionId: '4', text: '324号室' },
    ],
  },
  {
    quizId: '276',
    question:
      '第3部より問題です。\nマライヤのスタンド、バステト女神によって磁石になったジョセフにくっついてきたものとして間違っているのは？',
    options: [
      { optionId: '0', text: '自動車' },
      { optionId: '1', text: '自転車' },
      { optionId: '2', text: 'タイヤ' },
      { optionId: '3', text: '砂鉄' },
      { optionId: '4', text: 'ナイフ' },
    ],
  },
  {
    quizId: '277',
    question:
      '第3部より問題です。\nアレッシーのスボンを泥で汚し、殴られた少年は何歳？',
    options: [
      { optionId: '0', text: '4歳' },
      { optionId: '1', text: '3歳' },
      { optionId: '2', text: '5歳' },
      { optionId: '3', text: '6歳' },
      { optionId: '4', text: '7歳' },
    ],
  },
  {
    quizId: '278',
    question: '第3部より問題です。\nセト神は何の神？',
    options: [
      { optionId: '0', text: '嵐と暴力の神' },
      { optionId: '1', text: '冥界の神' },
      { optionId: '2', text: '大地の神' },
      { optionId: '3', text: '創造の神' },
      { optionId: '4', text: '天空の神' },
    ],
  },
  {
    quizId: '279',
    question:
      '第3部より問題です。\nアレッシーの持っていた斧に書かれていた文字は？',
    options: [
      { optionId: '0', text: 'AX' },
      { optionId: '1', text: 'AR' },
      { optionId: '2', text: 'GOD' },
      { optionId: '3', text: 'DIO' },
      { optionId: '4', text: 'SETO' },
    ],
  },
  {
    quizId: '280',
    question:
      '第3部より問題です。\nアレッシーとの戦いの『最中に傷付き汚れたポルナレフが招かれた家で、金魚が飼育されている部屋に無かったものは？',
    options: [
      { optionId: '0', text: '椅子' },
      { optionId: '1', text: 'ぬいぐるみ' },
      { optionId: '2', text: '柱時計' },
      { optionId: '3', text: 'モップ' },
      { optionId: '4', text: 'バケツ' },
    ],
  },
  {
    quizId: '281',
    question: '第3部より問題です。\nアレッシーの年齢は？',
    options: [
      { optionId: '0', text: '38歳' },
      { optionId: '1', text: '19歳' },
      { optionId: '2', text: '25歳' },
      { optionId: '3', text: '31歳' },
      { optionId: '4', text: '44歳' },
    ],
  },
  {
    quizId: '282',
    question:
      '第3部より問題です。\n承太郎たちの用いたルクソールからカイロへ移動手段は？',
    options: [
      { optionId: '0', text: '列車' },
      { optionId: '1', text: '車' },
      { optionId: '2', text: 'ラクダ' },
      { optionId: '3', text: 'セスナ' },
      { optionId: '4', text: '徒歩' },
    ],
  },
  {
    quizId: '283',
    question:
      '作者コメントより\nはじめはタバコを吸っていたホル・ホース、彼が禁煙用パイプに変えた理由は？',
    options: [
      { optionId: '0', text: '最近タバコの煙が苦手だから' },
      { optionId: '1', text: '禁煙がブームだから' },
      { optionId: '2', text: 'タバコの煙が描きづらいから' },
      { optionId: '3', text: '良い子が見ているジャンプ作品だから' },
      { optionId: '4', text: '禁煙用パイプの方が画が映えるから' },
    ],
  },
  {
    quizId: '284',
    question:
      '第3部より問題です。\n念写したDIOの館を探して聞き込みをしていたジョセフ達\n「ここはカフェですぜ なんか注文して下さいよ」\nと言われ、注文したものは？',
    options: [
      { optionId: '0', text: 'アイスティー' },
      { optionId: '1', text: 'レモンティー' },
      { optionId: '2', text: 'コーラ' },
      { optionId: '3', text: '水' },
      { optionId: '4', text: 'ミルクティー' },
    ],
  },
  {
    quizId: '285',
    question:
      '第3部より問題です。\nオシリス神のスタンド使いダニエル・J・ダービー、上にダッシュがつくのはD.A.R.B.Yの内どれ？',
    options: [
      { optionId: '0', text: 'D' },
      { optionId: '1', text: 'A' },
      { optionId: '2', text: 'R' },
      { optionId: '3', text: 'B' },
      { optionId: '4', text: 'Y' },
    ],
  },
  {
    quizId: '286',
    question:
      '第3部より問題です。\n1984年9月22日夜11時15分にカリフォルニアでダニエル・J・ダービーに\n「きさまはこのまま無事で帰ることはできない」\nというような内容の台詞を言ったのは誰？',
    options: [
      { optionId: '0', text: 'スティーブン・ムーア' },
      { optionId: '1', text: 'ガリエ・ムーア' },
      { optionId: '2', text: '真山祥造' },
      { optionId: '3', text: '峰村宏和' },
      { optionId: '4', text: 'エリシュカ・ムーア' },
    ],
  },
  {
    quizId: '287',
    question:
      '第3部より問題です。\nジョセフとダニエル・J・ダービーが行った「グラスとコイン」、最終的に2人合わせて何枚のコインをグラスに入れた？',
    options: [
      { optionId: '0', text: '7枚' },
      { optionId: '1', text: '3枚' },
      { optionId: '2', text: '4枚' },
      { optionId: '3', text: '5枚' },
      { optionId: '4', text: '6枚' },
    ],
  },
  {
    quizId: '288',
    question:
      '第3部より問題です。\nダニエル・J・ダービーが承太郎とポーカーをする前にめくった本、めくったページは何ページだった？',
    options: [
      { optionId: '0', text: '556' },
      { optionId: '1', text: '222' },
      { optionId: '2', text: '348' },
      { optionId: '3', text: '460' },
      { optionId: '4', text: '616' },
    ],
  },
  {
    quizId: '289',
    question:
      '第3部より問題です。\n1986年5月17日にダニエル・J・ダービーと賭けをし、8つの不動産と魂を奪われたのは誰？',
    options: [
      { optionId: '0', text: '真山祥造' },
      { optionId: '1', text: 'スティーブン・ムーア' },
      { optionId: '2', text: 'ガリエ・ムーア' },
      { optionId: '3', text: '峰村宏和' },
      { optionId: '4', text: 'エリシュカ・ムーア' },
    ],
  },
  {
    quizId: '290',
    question:
      '第3部より問題です。\n承太郎とダニエル・J・ダービーのポーカー勝負、少年がディーラーとなって、最初に配られた5枚の状態での承太郎の手役は？',
    options: [
      { optionId: '0', text: '8のワンペア' },
      { optionId: '1', text: '4のワンペア' },
      { optionId: '2', text: '10のワンペア' },
      { optionId: '3', text: '5とJのツーペア' },
      { optionId: '4', text: 'ブタ' },
    ],
  },
  {
    quizId: '291',
    question:
      '第3部より問題です。\n承太郎とダニエル・J・ダービーのポーカー勝負、最後のダービーの手役は？',
    options: [
      { optionId: '0', text: 'Kの4カード' },
      { optionId: '1', text: 'ストレートフラッシュ' },
      { optionId: '2', text: 'Aの4カード' },
      { optionId: '3', text: 'Qの4カード' },
      { optionId: '4', text: 'Jの4カード' },
    ],
  },
  {
    quizId: '292',
    question:
      '第3部より問題です。\nホル・ホースがボインゴを攫って乗ったタクシー、行き先はギザの何というホテル？',
    options: [
      { optionId: '0', text: 'メナハウス' },
      { optionId: '1', text: 'ワイコロア' },
      { optionId: '2', text: 'サリシュ・ロッジ' },
      { optionId: '3', text: 'メリアバリ' },
      { optionId: '4', text: 'ジットカー' },
    ],
  },
  {
    quizId: '293',
    question:
      '第3部より問題です。\nボインゴのスタンド、トト神の予言に描かれていたホル・ホース、承太郎一行を発見してどう思った？',
    options: [
      { optionId: '0', text: 'ドロドロに思った' },
      { optionId: '1', text: 'ブリブリに思った' },
      { optionId: '2', text: 'バリバリに思った' },
      { optionId: '3', text: 'ガタガタに思った' },
      { optionId: '4', text: 'ベトベトに思った' },
    ],
  },
  {
    quizId: '294',
    question:
      '第3部より問題です。\nトト神の予言通り脳天をブチ抜いたホル・ホースの弾丸、何発がボインゴの本を貫いた？',
    options: [
      { optionId: '0', text: '3発' },
      { optionId: '1', text: '1発' },
      { optionId: '2', text: '2発' },
      { optionId: '3', text: '4発' },
      { optionId: '4', text: '5発' },
    ],
  },
  {
    quizId: '295',
    question:
      '第3部より問題です。\nハヤブサ(ホルス)は古代エジプトの王族の守護神として最高に崇められ、数km先の虫をも確認できるホルスの眼のエジプト名は？',
    options: [
      { optionId: '0', text: 'ウジャト' },
      { optionId: '1', text: 'イムセティ' },
      { optionId: '2', text: 'ケべフセヌエフ' },
      { optionId: '3', text: 'ドゥアムテフ' },
      { optionId: '4', text: 'ハピ' },
    ],
  },
  {
    quizId: '296',
    question:
      '第3部より問題です。\nホルス神のスタンド使いのペットショップに殺された犬の名前は？',
    options: [
      { optionId: '0', text: 'チビとブチ' },
      { optionId: '1', text: 'コロとムク' },
      { optionId: '2', text: 'チビとコロ' },
      { optionId: '3', text: 'ブチとムク' },
      { optionId: '4', text: 'コロとブチ' },
    ],
  },
  {
    quizId: '297',
    question: '第3部より問題です。\nイギーの品種は？',
    options: [
      { optionId: '0', text: 'ボストン・テリア' },
      { optionId: '1', text: 'フレンチ・ブルドッグ' },
      { optionId: '2', text: 'ブル・テリア' },
      { optionId: '3', text: 'パグ' },
      { optionId: '4', text: 'パピヨン' },
    ],
  },
  {
    quizId: '298',
    question: '第3部より問題です。\nイギーの職業は？',
    options: [
      { optionId: '0', text: 'ルンペン' },
      { optionId: '1', text: '犬' },
      { optionId: '2', text: 'ペット' },
      { optionId: '3', text: 'ランナウェイ' },
      { optionId: '4', text: '職業なし' },
    ],
  },
  {
    quizId: '299',
    question: '第3部より問題です。\nイギーの血液型は？',
    options: [
      { optionId: '0', text: '不明' },
      { optionId: '1', text: 'DEA1.2型' },
      { optionId: '2', text: 'DEA3型' },
      { optionId: '3', text: 'DEA1.1型' },
      { optionId: '4', text: 'DEA4型' },
    ],
  },
  {
    quizId: '300',
    question: '第3部より問題です。\nイギーの体高は？',
    options: [
      { optionId: '0', text: '33.3cm' },
      { optionId: '1', text: '25cm' },
      { optionId: '2', text: '29.8cm' },
      { optionId: '3', text: '37.2cm' },
      { optionId: '4', text: '40.4cm' },
    ],
  },
  {
    quizId: '301',
    question: '第3部、イギーのプロフィールより問題です。\nイギーの趣味は？',
    options: [
      { optionId: '0', text: 'くつ集め' },
      { optionId: '1', text: '昼寝' },
      { optionId: '2', text: '散歩' },
      { optionId: '3', text: '趣味はない' },
      { optionId: '4', text: '何もしないこと' },
    ],
  },
  {
    quizId: '302',
    question:
      '第3部より問題です。\nホルス神のスタンド使いであるペットショップの種類は？',
    options: [
      { optionId: '0', text: 'ハヤブサ' },
      { optionId: '1', text: 'タカ' },
      { optionId: '2', text: 'ワシ' },
      { optionId: '3', text: 'ムナグロ' },
      { optionId: '4', text: 'カッコウ' },
    ],
  },
  {
    quizId: '303',
    question:
      '第3部より問題です。\nペットショップとの戦いで水中に隠れたイギー、愚者(ザ・フール)の能力で作った空気の管はいくつ？',
    options: [
      { optionId: '0', text: '2本' },
      { optionId: '1', text: '0本' },
      { optionId: '2', text: '1本' },
      { optionId: '3', text: '3本' },
      { optionId: '4', text: '4本' },
    ],
  },
  {
    quizId: '304',
    question: '第3部より問題です。\nテレンス・T・ダービー編の各話タイトルは？',
    options: [
      { optionId: '0', text: 'ダービー・ザ・プレイヤー' },
      { optionId: '1', text: 'ダービー・ザ・ギャンブラー' },
      { optionId: '2', text: 'ダービー・ザ・ゲーマー' },
      { optionId: '3', text: 'ダービー・ザ・コレクター' },
      { optionId: '4', text: 'ダービー・ザ・ポーカー' },
    ],
  },
  {
    quizId: '305',
    question:
      '第3部より問題です。\nテレンス・T・ダービーがポルナレフに向けて投げたトランプは？',
    options: [
      { optionId: '0', text: 'ハートのQ' },
      { optionId: '1', text: 'クラブの8' },
      { optionId: '2', text: 'クラブのK' },
      { optionId: '3', text: 'ダイヤのA' },
      { optionId: '4', text: 'スペードの5' },
    ],
  },
  {
    quizId: '306',
    question: '第3部より問題です。\nテレンス・T・ダービーのスタンドは？',
    options: [
      { optionId: '0', text: 'アトゥム神' },
      { optionId: '1', text: 'オシリス神' },
      { optionId: '2', text: 'ゲブ神' },
      { optionId: '3', text: 'クヌム神' },
      { optionId: '4', text: 'ホルス神' },
    ],
  },
  {
    quizId: '307',
    question: '第3部より問題です。\nダービー兄弟の年齢の差は？',
    options: [
      { optionId: '0', text: '10歳' },
      { optionId: '1', text: '5歳' },
      { optionId: '2', text: '8歳' },
      { optionId: '3', text: '12歳' },
      { optionId: '4', text: '15歳' },
    ],
  },
  {
    quizId: '308',
    question: '第3部より問題です。\nテレンス・T・ダービーの年齢は？',
    options: [
      { optionId: '0', text: '21歳' },
      { optionId: '1', text: '17歳' },
      { optionId: '2', text: '19歳' },
      { optionId: '3', text: '23歳' },
      { optionId: '4', text: '25歳' },
    ],
  },
  {
    quizId: '309',
    question:
      '第3部より問題です。\n「Exactly(そのとおりでございます)」\n誰の台詞？',
    options: [
      { optionId: '0', text: 'テレンス・T・ダービー' },
      { optionId: '1', text: 'ダニエル・J・ダービー' },
      { optionId: '2', text: 'ンドゥール' },
      { optionId: '3', text: 'ホル・ホース' },
      { optionId: '4', text: 'ダン' },
    ],
  },
  {
    quizId: '310',
    question:
      '第3部より問題です。\nテレンス・T・ダービーに魂をとられた、華麗なる恋の体験談が楽しい女は？',
    options: [
      { optionId: '0', text: 'ソニア' },
      { optionId: '1', text: 'アリス' },
      { optionId: '2', text: 'ミシェル' },
      { optionId: '3', text: 'ヨーコ' },
      { optionId: '4', text: 'レーネ' },
    ],
  },
  {
    quizId: '311',
    question:
      '第3部より問題です。\nテレンス・T・ダービーに魂をとられた、8人を殺している殺人鬼は？',
    options: [
      { optionId: '0', text: 'エリオット医師' },
      { optionId: '1', text: 'マリオ医師' },
      { optionId: '2', text: 'テリア医師' },
      { optionId: '3', text: 'ウィルソン医師' },
      { optionId: '4', text: 'フィルート医師\n' },
    ],
  },
  {
    quizId: '312',
    question:
      '第3部より問題です。\nテレンス・T・ダービーに魂をとられた、IQ190の日本の少年は？',
    options: [
      { optionId: '0', text: 'タツヒコ' },
      { optionId: '1', text: 'リョウタ' },
      { optionId: '2', text: 'ダイスケ' },
      { optionId: '3', text: 'ユウイチ' },
      { optionId: '4', text: 'ケンジ' },
    ],
  },
  {
    quizId: '313',
    question:
      '第3部より問題です。\nテレンス・T・ダービーが用意していたゲームの中で、野球とレースゲーム意外にあったものは？',
    options: [
      { optionId: '0', text: 'ゴルフ' },
      { optionId: '1', text: 'サッカー' },
      { optionId: '2', text: 'テニス' },
      { optionId: '3', text: 'テトリス' },
      { optionId: '4', text: 'ガンシューティング' },
    ],
  },
  {
    quizId: '314',
    question:
      '第3部より問題です。\nテレンス・T・ダービーと花京院が勝負したレースゲームは？',
    options: [
      { optionId: '0', text: 'F-MEGA' },
      { optionId: '1', text: 'RF-1' },
      { optionId: '2', text: 'Circuit JPN' },
      { optionId: '3', text: 'Buggy Hopper' },
      { optionId: '4', text: 'Highway Race' },
    ],
  },
  {
    quizId: '315',
    question:
      '第3部より問題です。\nテレンス・T・ダービーと花京院がゲームで選んだマシンは？',
    options: [
      { optionId: '0', text: 'A車' },
      { optionId: '1', text: 'B車' },
      { optionId: '2', text: 'C車' },
      { optionId: '3', text: 'D車' },
      { optionId: '4', text: 'E車' },
    ],
  },
  {
    quizId: '316',
    question:
      '第3部より問題です。\nテレンス・T・ダービーとの勝負で花京院が選んだ番号は？',
    options: [
      { optionId: '0', text: '28' },
      { optionId: '1', text: '3' },
      { optionId: '2', text: '11' },
      { optionId: '3', text: '15' },
      { optionId: '4', text: '24' },
    ],
  },
  {
    quizId: '317',
    question: '第3部より問題です。\nテレンス・T・ダービーの誕生日は？',
    options: [
      { optionId: '0', text: '44566' },
      { optionId: '1', text: '44576' },
      { optionId: '2', text: '44870' },
      { optionId: '3', text: '44880' },
      { optionId: '4', text: '44696' },
    ],
  },
  {
    quizId: '318',
    question:
      '第3部より問題です。\n花京院とテレンス・T・ダービーが勝負したレースゲーム、使用したコースは？',
    options: [
      { optionId: '0', text: 'コースNo.1' },
      { optionId: '1', text: 'コースNo.2' },
      { optionId: '2', text: 'コースNo.A' },
      { optionId: '3', text: 'コースNo.B' },
      { optionId: '4', text: 'コースNo.C' },
    ],
  },
  {
    quizId: '319',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲームは？',
    options: [
      { optionId: '0', text: "OH！THAT'S A　BASEBALL" },
      { optionId: '1', text: 'BASEBALL THE STARS' },
      { optionId: '2', text: "PROSTA '86" },
      { optionId: '3', text: 'FIRE STADIUM' },
      { optionId: '4', text: 'BATTLE BASEBALL' },
    ],
  },
  {
    quizId: '320',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲーム、使用した球場は？',
    options: [
      { optionId: '0', text: 'ブルースカイスタジアム' },
      { optionId: '1', text: 'オーシャンスタジアム' },
      { optionId: '2', text: 'メイプルスタジアム' },
      { optionId: '3', text: 'ライジングサンスタジアム' },
      { optionId: '4', text: 'サブマリンスタジアム' },
    ],
  },
  {
    quizId: '321',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲームに無いチームは次の内どれ？',
    options: [
      { optionId: '0', text: 'BIG TIGERS' },
      { optionId: '1', text: 'FIRE FOXES' },
      { optionId: '2', text: 'RED DRAGONS' },
      { optionId: '3', text: 'JAGUARS' },
      { optionId: '4', text: 'GRAY CATS' },
    ],
  },
  {
    quizId: '322',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲーム、承太郎が使用したチームは？',
    options: [
      { optionId: '0', text: 'JAGUARS' },
      { optionId: '1', text: 'FIRE FOXES' },
      { optionId: '2', text: 'RED DRAGONS' },
      { optionId: '3', text: 'GRAY CATS' },
      { optionId: '4', text: 'BIG TIGERS' },
    ],
  },
  {
    quizId: '323',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲーム、承太郎が使用したピッチャーの背番号は？',
    options: [
      { optionId: '0', text: '41' },
      { optionId: '1', text: '22' },
      { optionId: '2', text: '3' },
      { optionId: '3', text: '18' },
      { optionId: '4', text: '35' },
    ],
  },
  {
    quizId: '324',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲーム、承太郎が使用したチームの3番バッターで、はじめにホームランを打った選手の背番号は？',
    options: [
      { optionId: '0', text: '22' },
      { optionId: '1', text: '41' },
      { optionId: '2', text: '3' },
      { optionId: '3', text: '18' },
      { optionId: '4', text: '35' },
    ],
  },
  {
    quizId: '325',
    question:
      '第3部より問題です。\n承太郎とテレンス・T・ダービーが勝負した野球ゲーム、最終的な得点は何対何で決着した？',
    options: [
      { optionId: '0', text: '5対3' },
      { optionId: '1', text: '5対2' },
      { optionId: '2', text: '4対2' },
      { optionId: '3', text: '6対3' },
      { optionId: '4', text: '6対4' },
    ],
  },
  {
    quizId: '326',
    question:
      '第3部より問題です。\n生物探知機としても使える魔術師の赤の炎は半径何m以内にいるものを探知できる？',
    options: [
      { optionId: '0', text: '15m以内' },
      { optionId: '1', text: '5m以内' },
      { optionId: '2', text: '25m以内' },
      { optionId: '3', text: '35m以内' },
      { optionId: '4', text: '45m以内' },
    ],
  },
  {
    quizId: '327',
    question:
      '第3部より問題です。\nDIOの館を巨大な迷路にしていた、幻覚のスタンド使いは？',
    options: [
      { optionId: '0', text: 'ケニーG' },
      { optionId: '1', text: 'ヌケサク' },
      { optionId: '2', text: 'ヴァニラ・アイス' },
      { optionId: '3', text: 'テレンス・T・ダービー' },
      { optionId: '4', text: 'フィルカル' },
    ],
  },
  {
    quizId: '328',
    question:
      '第3部より問題です。\nDIOの館でアヴドゥルが発見した落書きは何語で書かれていた？',
    options: [
      { optionId: '0', text: '日本語' },
      { optionId: '1', text: '英語' },
      { optionId: '2', text: 'エジプト語' },
      { optionId: '3', text: 'ヒエログリフ' },
      { optionId: '4', text: 'コプト語' },
    ],
  },
  {
    quizId: '329',
    question:
      '第3部より問題です。\nヴァニラ・アイスがスタンドで空間を刳り貫くときによく使われる、アヴドゥルを殺したときにも使われた擬音は？',
    options: [
      { optionId: '0', text: 'ガオン' },
      { optionId: '1', text: 'バクーム' },
      { optionId: '2', text: 'ビガン' },
      { optionId: '3', text: 'フォン' },
      { optionId: '4', text: 'スゥン' },
    ],
  },
  {
    quizId: '330',
    question: '第3部より問題です。\nDIOの館、見取図上無い部屋は？',
    options: [
      { optionId: '0', text: '書斎' },
      { optionId: '1', text: '朝食の間' },
      { optionId: '2', text: '植物園' },
      { optionId: '3', text: '学習室' },
      { optionId: '4', text: 'ビリヤードルーム' },
    ],
  },
  {
    quizId: '331',
    question:
      '第3部より問題です。\nイギーのスタンド、愚者(ザ・クール)、一体いつの話？',
    options: [
      { optionId: '0', text: 'ヴァニラ・アイス戦' },
      { optionId: '1', text: 'ンドゥール戦' },
      { optionId: '2', text: 'ボインゴ＆ホル・ホース戦' },
      { optionId: '3', text: 'アレッシー戦' },
      { optionId: '4', text: 'ペットショップ戦' },
    ],
  },
  {
    quizId: '332',
    question:
      '第3部より問題です。\nヴァニラ・アイスが円の軌跡でポルナレフに迫っているときのポルナレフの思考。\nこのえぐれた足でどうやってあの攻撃をかわすか？\n答え①は？',
    options: [
      {
        optionId: '0',
        text: 'ハンサムのポルナレフは突如反撃のアイデアをひらめく',
      },
      { optionId: '1', text: '仲間がきて助けてくれる' },
      { optionId: '2', text: 'かわせない。現実は非情である。' },
      { optionId: '3', text: '敵が諦めてくれる' },
      { optionId: '4', text: '実は敵がすでに死んでいる' },
    ],
  },
  {
    quizId: '333',
    question:
      '第3部より問題です。\nスージーQがホリィの見舞いに日本に来た際、車を運転していたのは誰？',
    options: [
      { optionId: '0', text: 'ローゼス' },
      { optionId: '1', text: 'ティエル' },
      { optionId: '2', text: 'ゼンデン' },
      { optionId: '3', text: 'ライオネル' },
      { optionId: '4', text: 'マイケル' },
    ],
  },
  {
    quizId: '334',
    question:
      '第3部より問題です。\nテレンス・T・ダービー、ケニーG、ヴァニラ・アイスが承太郎達に倒されて、ヌケサクの腹の底から出た笑いは？',
    options: [
      { optionId: '0', text: '「ザマミロ&スカッとサワヤカ」の笑い' },
      { optionId: '1', text: '「がっかり&すっきり」の笑い' },
      { optionId: '2', text: '「バーッド&ハッピー」の笑い' },
      { optionId: '3', text: '「敗者へのあわれみ」の笑い' },
      { optionId: '4', text: '「ドンマイ&ありがとう」の笑い' },
    ],
  },
  {
    quizId: '335',
    question:
      '第3部より問題です。\nDIOのスタンド、世界(ザ・ワールド)に出会ったのにどんな能力かカケラも見えない………\n「山を登るとき、ルートもわからん！ 頂上がどこにあるかもわからんでは遭難は確実なんじゃ！」\nどのくらい確実？',
    options: [
      { optionId: '0', text: 'コーラを飲んだらゲップが出るってくらい' },
      {
        optionId: '1',
        text: '風の強い時にションベンしたらズボンにかかるってことくらい',
      },
      { optionId: '2', text: '力をこめればHBの鉛筆がベキッ！ と折れるくらい' },
      { optionId: '3', text: '太陽が東から昇って西へ沈むってことくらい' },
      { optionId: '4', text: '昨日が月曜なら、今日が火曜というくらい' },
    ],
  },
  {
    quizId: '336',
    question:
      '第3部より問題です。\nＤＩＯに前歯を抜かれ、車の運転をさせられた上院議員は？',
    options: [
      { optionId: '0', text: 'ウィルソン・フィリップス' },
      { optionId: '1', text: 'ジョン・マケイン' },
      { optionId: '2', text: 'アル・ハヤート' },
      { optionId: '3', text: 'アフマド・ムスタファー' },
      { optionId: '4', text: 'アミーナ・ハイリー' },
    ],
  },
  {
    quizId: '337',
    question:
      '第3部より問題です。\n花京院の作った法皇(ハイエロファント)の結界は、ＤＩＯの周り半径何mに張り巡らされている？',
    options: [
      { optionId: '0', text: '20m' },
      { optionId: '1', text: '10m' },
      { optionId: '2', text: '15m' },
      { optionId: '3', text: '25m' },
      { optionId: '4', text: '30m' },
    ],
  },
  {
    quizId: '338',
    question:
      '第3部より問題です。\n花京院がDIOの能力を知らせるために、時計を壊した時刻は？',
    options: [
      { optionId: '0', text: '0.21875' },
      { optionId: '1', text: '0.201388888888889' },
      { optionId: '2', text: '0.239583333333333' },
      { optionId: '3', text: '6時' },
      { optionId: '4', text: '0.270833333333333' },
    ],
  },
  {
    quizId: '339',
    question:
      '第3部より問題です。\nジョセフの血を吸う前のDIOは時を何秒止められた？',
    options: [
      { optionId: '0', text: '5秒' },
      { optionId: '1', text: '2秒' },
      { optionId: '2', text: '3秒' },
      { optionId: '3', text: '4秒' },
      { optionId: '4', text: '6秒' },
    ],
  },
  {
    quizId: '340',
    question:
      '第3部より問題です。\nDIOに投げられたナイフ、承太郎が用心して入れていた雑誌で防げずに刺さったのは何本？',
    options: [
      { optionId: '0', text: '4本' },
      { optionId: '1', text: '1本' },
      { optionId: '2', text: '2本' },
      { optionId: '3', text: '3本' },
      { optionId: '4', text: '5本' },
    ],
  },
  {
    quizId: '341',
    question:
      '第3部より問題です。\n「このDIOを暗殺することはできん………\n『○○』はきさまにとどめを刺して全滅の最後というわけだな………」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'ジョースター・エジプト・ツアー御一行様' },
      { optionId: '1', text: 'ジョースターとの長い因縁' },
      { optionId: '2', text: 'ジョースター一味' },
      { optionId: '3', text: '絶対王者にはむかうバカども' },
      { optionId: '4', text: '私の脅威成りうるもの' },
    ],
  },
  {
    quizId: '342',
    question:
      '第3部より問題です。\n死んだふりからの反撃で、承太郎がDIOの頭を破壊した後にブッかけたものは？',
    options: [
      { optionId: '0', text: 'ガソリン' },
      { optionId: '1', text: '灯油' },
      { optionId: '2', text: '石油' },
      { optionId: '3', text: 'コールタール' },
      { optionId: '4', text: '熱湯' },
    ],
  },
  {
    quizId: '343',
    question:
      '第3部より問題です。\nジョセフの血で9秒の時を止めれるようになったDIOが承太郎に落としたものは？',
    options: [
      { optionId: '0', text: 'ロードローラー' },
      { optionId: '1', text: 'タンクローリー' },
      { optionId: '2', text: 'バス' },
      { optionId: '3', text: 'ダンプカー' },
      { optionId: '4', text: 'ブルドーザー' },
    ],
  },
  {
    quizId: '344',
    question:
      '第3部より問題です。\n承太郎のDIOに向けての台詞\n「てめーの敗因は… たったひとつだぜ……DIO…\nたったひとつの単純な答えだ……」\nその答えは？',
    options: [
      { optionId: '0', text: '『てめーはおれを怒らせた』' },
      { optionId: '1', text: '『てめーはじじいを侮辱した』' },
      { optionId: '2', text: '『てめーは俺たちを怒らせた』' },
      { optionId: '3', text: '『てめーは仲間を殺しすぎた』' },
      { optionId: '4', text: '『てめーは調子に乗りすぎた』' },
    ],
  },
  {
    quizId: '345',
    question: '第3部より問題です。\nジョセフの趣味は？',
    options: [
      { optionId: '0', text: 'コミック本集め' },
      { optionId: '1', text: '古書集め' },
      { optionId: '2', text: 'ライター集め' },
      { optionId: '3', text: 'くつ集め' },
      { optionId: '4', text: '時計集め' },
    ],
  },
  {
    quizId: '346',
    question: '1981年の映画「類人猿のターザン」の主演女優は？',
    options: [
      { optionId: '0', text: 'ボー・デルク' },
      { optionId: '1', text: 'シャーロット・ランプリング' },
      { optionId: '2', text: 'シャーリー・マクレーン' },
      { optionId: '3', text: 'ヴァレリー・ペリン' },
      { optionId: '4', text: 'リー・トンプソン' },
    ],
  },
  {
    quizId: '347',
    question:
      '「今夜はビート・イット」のパロディ「今夜はイート・イット」を歌ったのは？',
    options: [
      { optionId: '0', text: 'アル・ヤンコビック' },
      { optionId: '1', text: 'マイクル・ジャクソン' },
      { optionId: '2', text: 'ブルース・スプリングスティーン' },
      { optionId: '3', text: 'ロビー・ネビル' },
      { optionId: '4', text: 'ナガレダ・ユタカ' },
    ],
  },
  {
    quizId: '348',
    question:
      '第3部より問題です。\nDIOを倒し、空港でポルナレフと別れた後にジョセフが聴いていた曲は？',
    options: [
      { optionId: '0', text: 'Get Back' },
      { optionId: '1', text: 'Hey Jude' },
      { optionId: '2', text: 'Let It Be' },
      { optionId: '3', text: 'I Feel Fine' },
      { optionId: '4', text: 'Help!' },
    ],
  },
  {
    quizId: '349',
    question: '第4部より問題です。\n東方朋子の職業は？',
    options: [
      { optionId: '0', text: '教師' },
      { optionId: '1', text: '看護婦' },
      { optionId: '2', text: '翻訳家' },
      { optionId: '3', text: 'インテリアデザイナー' },
      { optionId: '4', text: '専業主婦' },
    ],
  },
  {
    quizId: '350',
    question: '第4部より問題です。\n東方家の住所は？',
    options: [
      { optionId: '0', text: '定禅寺1の6' },
      { optionId: '1', text: '定禅寺2の4' },
      { optionId: '2', text: '定禅寺4の1280' },
      { optionId: '3', text: '定禅寺3の16' },
      { optionId: '4', text: '定禅寺1の28' },
    ],
  },
  {
    quizId: '351',
    question: '第4部より問題です。\n承太郎の年齢は？',
    options: [
      { optionId: '0', text: '28歳' },
      { optionId: '1', text: '25歳' },
      { optionId: '2', text: '26歳' },
      { optionId: '3', text: '27歳' },
      { optionId: '4', text: '29歳' },
    ],
  },
  {
    quizId: '352',
    question: '第4部より問題です。\n承太郎の職業は？',
    options: [
      { optionId: '0', text: '海洋冒険家' },
      { optionId: '1', text: '生物学者' },
      { optionId: '2', text: '探検家' },
      { optionId: '3', text: '作詞家' },
      { optionId: '4', text: 'ルポライター' },
    ],
  },
  {
    quizId: '353',
    question: '第4部より問題です。\n仗助のクラスは？',
    options: [
      { optionId: '0', text: '1年B組' },
      { optionId: '1', text: '1年C組' },
      { optionId: '2', text: '1年D組' },
      { optionId: '3', text: '1年1組' },
      { optionId: '4', text: '1年2組' },
    ],
  },
  {
    quizId: '354',
    question:
      '第4部より問題です。\nカメを克服しようとしていた仗助の髪型を先輩は何と表現した？',
    options: [
      { optionId: '0', text: 'アトム' },
      { optionId: '1', text: 'サザエさん' },
      { optionId: '2', text: '花輪くん' },
      { optionId: '3', text: 'スネ夫' },
      { optionId: '4', text: 'クレしんの園長' },
    ],
  },
  {
    quizId: '355',
    question: '第4部より問題です。\n仗助は朋子が何歳の時に産んだ子供？',
    options: [
      { optionId: '0', text: '21歳' },
      { optionId: '1', text: '17歳' },
      { optionId: '2', text: '18歳' },
      { optionId: '3', text: '19歳' },
      { optionId: '4', text: '20歳' },
    ],
  },
  {
    quizId: '356',
    question:
      '第4部より問題です。\n仗助が原因不明の発熱により50日間生死の境をさまよったのは何歳の時？',
    options: [
      { optionId: '0', text: '4歳' },
      { optionId: '1', text: '2歳' },
      { optionId: '2', text: '3歳' },
      { optionId: '3', text: '5歳' },
      { optionId: '4', text: '6歳' },
    ],
  },
  {
    quizId: '357',
    question:
      '第4部より問題です。\nジョセフが東方朋子と浮気をしたのは何歳の時？',
    options: [
      { optionId: '0', text: '65歳' },
      { optionId: '1', text: '50歳' },
      { optionId: '2', text: '55歳' },
      { optionId: '3', text: '60歳' },
      { optionId: '4', text: '70歳' },
    ],
  },
  {
    quizId: '358',
    question:
      '第4部より問題です。\n承太郎は血縁上、仗助に対して何にあたると説明している？',
    options: [
      { optionId: '0', text: '叔父' },
      { optionId: '1', text: '甥' },
      { optionId: '2', text: '伯父' },
      { optionId: '3', text: '兄' },
      { optionId: '4', text: '従甥' },
    ],
  },
  {
    quizId: '359',
    question: '第4部より問題です。\nアンジェロの本名は？',
    options: [
      { optionId: '0', text: '片桐安十郎' },
      { optionId: '1', text: '片桐杏十郎' },
      { optionId: '2', text: '片桐庵十郎' },
      { optionId: '3', text: '片桐案十郎' },
      { optionId: '4', text: '片桐闇十郎' },
    ],
  },
  {
    quizId: '360',
    question: '第4部より問題です。\nアンジェロの知能指数は？',
    options: [
      { optionId: '0', text: 'IQ160' },
      { optionId: '1', text: 'IQ80' },
      { optionId: '2', text: 'IQ120' },
      { optionId: '3', text: 'IQ140' },
      { optionId: '4', text: 'IQ200' },
    ],
  },
  {
    quizId: '361',
    question:
      '第4部より問題です。\nアンジェロが12歳の時、初めて施設送りになった罪状は？',
    options: [
      { optionId: '0', text: '強盗と強姦罪' },
      { optionId: '1', text: '傷害致死' },
      { optionId: '2', text: '強盗殺人' },
      { optionId: '3', text: '放火' },
      { optionId: '4', text: '恐喝と殺人未遂' },
    ],
  },
  {
    quizId: '362',
    question:
      '第4部より問題です。\nアンジェロは34歳までの何年間を刑務所で過ごした？',
    options: [
      { optionId: '0', text: '20年' },
      { optionId: '1', text: '10年' },
      { optionId: '2', text: '12年' },
      { optionId: '3', text: '15年' },
      { optionId: '4', text: '18年' },
    ],
  },
  {
    quizId: '363',
    question:
      '第4部より問題です。\nアンジェロがスタンド使いになる以前、最後にした犯罪で殺害した人数は？',
    options: [
      { optionId: '0', text: '4人' },
      { optionId: '1', text: '2人' },
      { optionId: '2', text: '3人' },
      { optionId: '3', text: '5人' },
      { optionId: '4', text: '6人' },
    ],
  },
  {
    quizId: '364',
    question:
      '第4部より問題です。\nアンジェロのスタンド、アクア・ネックレスに操られた人間が強盗事件を起こしたコンビニは？',
    options: [
      { optionId: '0', text: 'SUN MART' },
      { optionId: '1', text: 'オーソン' },
      { optionId: '2', text: 'Pamily Mart' },
      { optionId: '3', text: 'エイト-イレブン' },
      { optionId: '4', text: 'オートストップ' },
    ],
  },
  {
    quizId: '365',
    question: '第4部より問題です。\n東方仗助の血液型は？',
    options: [
      { optionId: '0', text: 'B型' },
      { optionId: '1', text: 'A型' },
      { optionId: '2', text: 'O型' },
      { optionId: '3', text: 'AB型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '366',
    question: '第4部より問題です。\n東方仗助の祖父の名前は？',
    options: [
      { optionId: '0', text: '東方良平' },
      { optionId: '1', text: 'ジョセフ・ジョースター' },
      { optionId: '2', text: '東方真守' },
      { optionId: '3', text: '東方裕貴' },
      { optionId: '4', text: '東方渉' },
    ],
  },
  {
    quizId: '367',
    question: '第4部より問題です。\n東方仗助の趣味は何のCDをきくこと？',
    options: [
      { optionId: '0', text: 'プリンス' },
      { optionId: '1', text: 'ブロンディ' },
      { optionId: '2', text: 'フィル・コリンズ' },
      { optionId: '3', text: '(エイジア' },
      { optionId: '4', text: 'エア・サプライ' },
    ],
  },
  {
    quizId: '368',
    question: '第4部より問題です。\n東方家に牛乳配達している牛乳屋は？',
    options: [
      { optionId: '0', text: 'LACKY LAND MILK' },
      { optionId: '1', text: 'MILK COMMUNITY' },
      { optionId: '2', text: 'DAIRY NETWORKS' },
      { optionId: '3', text: 'HAPPY YOGHURET' },
      { optionId: '4', text: 'DAIRY DAILY' },
    ],
  },
  {
    quizId: '369',
    question: '第4部より問題です。\nアクア・ネックレスの化けたブランデーは？',
    options: [
      { optionId: '0', text: 'COGNAC KAMUS NAPOLEON' },
      { optionId: '1', text: 'Chabot XO Armagnac' },
      { optionId: '2', text: 'Marc de Bourgogne' },
      { optionId: '3', text: 'Marc de Corton Grancey' },
      { optionId: '4', text: 'VIEUX MARC DE VOSNE LOMANEE' },
    ],
  },
  {
    quizId: '370',
    question:
      '第4部より問題です。\nアクアネックレスがゴム手袋に捕らえられた際の叫び声は？',
    options: [
      { optionId: '0', text: 'ブギャ――ッ' },
      { optionId: '1', text: 'ピギャ――ッ' },
      { optionId: '2', text: 'プギャ――ッ' },
      { optionId: '3', text: 'ドギャ――ッ' },
      { optionId: '4', text: 'ギャ――ッ' },
    ],
  },
  {
    quizId: '371',
    question:
      '第4部より問題です。\n杜王町名所その①『アンジェロ岩』への行き方は？',
    options: [
      { optionId: '0', text: '杜王町定禅寺通りバス停下車③番バス徒歩1分' },
      { optionId: '1', text: '杜王町定禅寺通りバス停下車③番バス徒歩5分' },
      { optionId: '2', text: '杜王町定禅寺通りバス停下車②番バス徒歩1分' },
      { optionId: '3', text: '杜王町定禅寺通りバス停下車②番バス徒歩5分' },
      { optionId: '4', text: '杜王町で変わった石について尋ねると教えてくれる' },
    ],
  },
  {
    quizId: '372',
    question:
      '第4部より問題です。\n仗助のスタンド、クレイジー・ダイヤモンドの名づけ親は？',
    options: [
      { optionId: '0', text: '空条承太郎' },
      { optionId: '1', text: '東方仗助' },
      { optionId: '2', text: '東方朋子' },
      { optionId: '3', text: '虹村形兆' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '373',
    question:
      '第4部より問題です。\n杜王町はどこのベッドタウンとして発展した町？',
    options: [
      { optionId: '0', text: 'S市' },
      { optionId: '1', text: '立美台市' },
      { optionId: '2', text: '六道市' },
      { optionId: '3', text: '岩沼市' },
      { optionId: '4', text: '琳道市' },
    ],
  },
  {
    quizId: '374',
    question: '第4部より問題です。\n杜王町、町の花は？',
    options: [
      { optionId: '0', text: 'フクジュソウ' },
      { optionId: '1', text: 'ハマギク' },
      { optionId: '2', text: 'ハナモモ' },
      { optionId: '3', text: 'ツツジ' },
      { optionId: '4', text: 'キキョウ' },
    ],
  },
  {
    quizId: '375',
    question: '第4部より問題です。\n杜王町の特産品は？',
    options: [
      { optionId: '0', text: '牛たんのみそづけ' },
      { optionId: '1', text: '笹かまぼこ' },
      { optionId: '2', text: 'ずんだ餅' },
      { optionId: '3', text: '八丁味噌' },
      { optionId: '4', text: '赤べこ' },
    ],
  },
  {
    quizId: '376',
    question: '第4部より問題です。\n1994年の国勢調査による杜王町の人口は？',
    options: [
      { optionId: '0', text: '5万8713人' },
      { optionId: '1', text: '7万2172人' },
      { optionId: '2', text: '6万7209人' },
      { optionId: '3', text: '11万1637人' },
      { optionId: '4', text: '13万2577人' },
    ],
  },
  {
    quizId: '377',
    question: '第4部より問題です。\n杜王町で承太郎が泊まっているホテルは？',
    options: [
      { optionId: '0', text: '杜王グランドホテル' },
      { optionId: '1', text: '杜王ロイヤルパークホテル' },
      { optionId: '2', text: 'ホテルメトロ杜王' },
      { optionId: '3', text: 'プリンスホテル杜王' },
      { optionId: '4', text: 'クラウンパレス杜王' },
    ],
  },
  {
    quizId: '378',
    question: '第4部より問題です。\n仗助の祖父の死因は一般にはどうなっている？',
    options: [
      { optionId: '0', text: '脳いっ血' },
      { optionId: '1', text: '脳卒中' },
      { optionId: '2', text: '脳梗塞' },
      { optionId: '3', text: '心筋梗塞' },
      { optionId: '4', text: '原因不明' },
    ],
  },
  {
    quizId: '379',
    question:
      '第4部より問題です。\n作中で虹村形兆のスタンド、バッド・カンパニーの歩兵に射たれていないものは？',
    options: [
      { optionId: '0', text: '広瀬康一' },
      { optionId: '1', text: '虹村億泰' },
      { optionId: '2', text: '東方仗助' },
      { optionId: '3', text: '壺' },
      { optionId: '4', text: '釘' },
    ],
  },
  {
    quizId: '380',
    question:
      '第4部より問題です。\n虹村形兆のスタンド、バッド・カンパニーの歩兵が使う武器は？',
    options: [
      { optionId: '0', text: 'M16' },
      { optionId: '1', text: 'M1793' },
      { optionId: '2', text: 'M1894' },
      { optionId: '3', text: 'StG44' },
      { optionId: '4', text: 'M4' },
    ],
  },
  {
    quizId: '381',
    question:
      '第4部より問題です。\n次の内、虹村形兆のスタンド、バッド・カンパニーは？',
    options: [
      { optionId: '0', text: '極悪中隊' },
      { optionId: '1', text: '一個中隊' },
      { optionId: '2', text: '悪逆中隊' },
      { optionId: '3', text: '無敵中隊' },
      { optionId: '4', text: '幻立中隊' },
    ],
  },
  {
    quizId: '382',
    question:
      '第4部より問題です。\n虹村形兆のスタンド、バッド・カンパニーのアメリカ陸軍攻撃用ヘリは？',
    options: [
      { optionId: '0', text: 'アパッチ' },
      { optionId: '1', text: 'シャイアン' },
      { optionId: '2', text: 'コブラ' },
      { optionId: '3', text: 'マングスタ' },
      { optionId: '4', text: 'シーナイト' },
    ],
  },
  {
    quizId: '383',
    question:
      '第4部より問題です。\n虹村形兆のスタンド、バッド・カンパニーの部隊構成は？',
    options: [
      { optionId: '0', text: '戦車7台、戦闘用ヘリ4機、歩兵60名' },
      { optionId: '1', text: '戦車4台、戦闘用ヘリ4機、歩兵50名' },
      { optionId: '2', text: '戦車10台、戦闘用ヘリ6機、歩兵60名' },
      { optionId: '3', text: '戦車10台、戦闘用ヘリ4機、騎兵15名、歩兵40名' },
      { optionId: '4', text: '戦車7台、戦闘用ヘリ6機、騎兵10名歩兵35名' },
    ],
  },
  {
    quizId: '384',
    question:
      '第4部より問題です。\n杜王町のホテル、音石明から電話が掛かってきたときに承太郎が泊まっていた部屋番号は？',
    options: [
      { optionId: '0', text: '324号室' },
      { optionId: '1', text: '213号室' },
      { optionId: '2', text: '912号室' },
      { optionId: '3', text: '1212号室' },
      { optionId: '4', text: '3245号室' },
    ],
  },
  {
    quizId: '385',
    question: '第4部より問題です。\n虹村形兆が埋葬された場所は？',
    options: [
      { optionId: '0', text: '国見峠霊園' },
      { optionId: '1', text: '虹村家之墓' },
      { optionId: '2', text: '勾当台公園墓地' },
      { optionId: '3', text: '安らぎの墓' },
      { optionId: '4', text: '埋葬していない' },
    ],
  },
  {
    quizId: '386',
    question: '第4部より問題です。\n康一が入学祝いに買ってもらったものは？',
    options: [
      { optionId: '0', text: 'マウンテン・バイク' },
      { optionId: '1', text: 'ギター' },
      { optionId: '2', text: 'ゲーム機' },
      { optionId: '3', text: '腕時計' },
      { optionId: '4', text: 'パソコン' },
    ],
  },
  {
    quizId: '387',
    question:
      '第4部より問題です。\n康一が猫のぬいぐるみの入った袋を轢いてしまったときの擬音は？',
    options: [
      { optionId: '0', text: 'ボムギ！' },
      { optionId: '1', text: 'ドッゴォ' },
      { optionId: '2', text: 'キヤットォ' },
      { optionId: '3', text: 'グッバァァ！' },
      { optionId: '4', text: 'ビギュン！' },
    ],
  },
  {
    quizId: '388',
    question: '第4部より問題です。\n小林玉美の年齢は？',
    options: [
      { optionId: '0', text: '20歳' },
      { optionId: '1', text: '22歳' },
      { optionId: '2', text: '25歳' },
      { optionId: '3', text: '28歳' },
      { optionId: '4', text: '30歳' },
    ],
  },
  {
    quizId: '389',
    question:
      '第4部より問題です。\n康一が小林玉美に初めて会ったとき、スニーカーを買うために持っていたお金は？',
    options: [
      { optionId: '0', text: '7000円' },
      { optionId: '1', text: '3000円' },
      { optionId: '2', text: '5000円' },
      { optionId: '3', text: '10000円' },
      { optionId: '4', text: '15000円' },
    ],
  },
  {
    quizId: '390',
    question: '第4部より問題です。\n康一の家で飼っている犬は？',
    options: [
      { optionId: '0', text: 'ポリス' },
      { optionId: '1', text: 'ポッキー' },
      { optionId: '2', text: 'ダニー' },
      { optionId: '3', text: 'コメット' },
      { optionId: '4', text: 'フランツ' },
    ],
  },
  {
    quizId: '391',
    question: '第4部より問題です。\n康一の母がよく行く美容室は？',
    options: [
      { optionId: '0', text: 'サロンまなざし' },
      { optionId: '1', text: 'サロン桜川' },
      { optionId: '2', text: '美容室キクララ' },
      { optionId: '3', text: 'アトリエ ルル' },
      { optionId: '4', text: 'ハッピーみき' },
    ],
  },
  {
    quizId: '392',
    question:
      "第4部より問題です。\n康一の財布に入っていたレシート、小林玉美はJONNY'Sで何を注文していた？",
    options: [
      { optionId: '0', text: 'ハンバーグ・セットとオニオングラタンスープ' },
      { optionId: '1', text: 'ドリアとクリームチャウダー' },
      { optionId: '2', text: 'ステーキ・セットとメロンソーダ' },
      { optionId: '3', text: 'ふわとろデミグラスソースオムライス' },
      { optionId: '4', text: 'カレーライスとコンソメスープ' },
    ],
  },
  {
    quizId: '393',
    question:
      '第4部、小林玉美の台詞より問題です。\n「あんたの息子さん……… いっちゃあなんですが……… でき心とはいえ悪どいですねェ～～～\nこんな息子さんを育てて…… 親として　『○○』はないんですかい？」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '罪悪感' },
      { optionId: '1', text: 'お詫び' },
      { optionId: '2', text: '責任' },
      { optionId: '3', text: '良心の呵責' },
      { optionId: '4', text: '後ろめたさ' },
    ],
  },
  {
    quizId: '394',
    question:
      '第4部より問題です。\n康一のスタンド、エコーズACT1で小林玉美に付けた音でないものは？',
    options: [
      { optionId: '0', text: 'ドーン' },
      { optionId: '1', text: 'バギ！' },
      { optionId: '2', text: 'ビシ！' },
      { optionId: '3', text: 'ドヒュン' },
      { optionId: '4', text: 'ボ！' },
    ],
  },
  {
    quizId: '395',
    question:
      '第4部より問題です。\n康一のスタンド、エコーズACT1で初めて付けた音は？',
    options: [
      { optionId: '0', text: 'バギ！' },
      { optionId: '1', text: 'ドーン' },
      { optionId: '2', text: 'ビシ！' },
      { optionId: '3', text: 'ドヒュン' },
      { optionId: '4', text: 'ボ！' },
    ],
  },
  {
    quizId: '396',
    question: '第4部より問題です。\n間田敏和のクラスは？',
    options: [
      { optionId: '0', text: '3年C組' },
      { optionId: '1', text: '3年B組' },
      { optionId: '2', text: '3年D組' },
      { optionId: '3', text: '3年1組' },
      { optionId: '4', text: '3年2組' },
    ],
  },
  {
    quizId: '397',
    question:
      '第4部より問題です。\n間田敏和のロッカーに入っていなかったものは？',
    options: [
      { optionId: '0', text: '体操服' },
      { optionId: '1', text: 'テニスラケット' },
      { optionId: '2', text: 'テニスボール' },
      { optionId: '3', text: '外ばき' },
      { optionId: '4', text: '漫画' },
    ],
  },
  {
    quizId: '398',
    question: '第4部より問題です。\n間田敏和のスタンドは？',
    options: [
      { optionId: '0', text: 'サーフィス' },
      { optionId: '1', text: 'ボーイ・Ⅱ・マン' },
      { optionId: '2', text: 'スーパーフライ' },
      { optionId: '3', text: 'チープ・トリック' },
      { optionId: '4', text: 'エニグマ' },
    ],
  },
  {
    quizId: '399',
    question:
      '第4部より問題です。\n杜王町のホテル、間田敏和編の時に承太郎が泊まっていた部屋番号は？',
    options: [
      { optionId: '0', text: '3245号室' },
      { optionId: '1', text: '324号室' },
      { optionId: '2', text: '213号室' },
      { optionId: '3', text: '912号室' },
      { optionId: '4', text: '1212号室' },
    ],
  },
  {
    quizId: '400',
    question:
      '第4部より問題です。\n東方仗助のスタンド、クレイジーダイヤモンドでなおせないものとして間違っているのは？',
    options: [
      { optionId: '0', text: 'スタンドの傷' },
      { optionId: '1', text: '死人' },
      { optionId: '2', text: '自分の傷' },
      { optionId: '3', text: '病気' },
      { optionId: '4', text: '部品のないもの' },
    ],
  },
  {
    quizId: '401',
    question: '第4部より問題です。\n仗助たちの通っている高校は？',
    options: [
      { optionId: '0', text: 'ぶどうヶ丘高校' },
      { optionId: '1', text: '杜王高校' },
      { optionId: '2', text: '中央高校' },
      { optionId: '3', text: 'KI高校' },
      { optionId: '4', text: '盛浄高校' },
    ],
  },
  {
    quizId: '402',
    question: '第4部より問題です。\n間田敏和が片思いしていた娘は？',
    options: [
      { optionId: '0', text: '順子' },
      { optionId: '1', text: '美代子' },
      { optionId: '2', text: '梨央' },
      { optionId: '3', text: '綾那' },
      { optionId: '4', text: '美那子' },
    ],
  },
  {
    quizId: '403',
    question:
      '作者コメントより問題です。\n荒木飛呂彦のこいつはビビったぜ映画ベスト10(もうやめてくれといいながらそれでもみたベスト10)第1位は？',
    options: [
      { optionId: '0', text: 'ナイト・オブ・ザ・リビング・デッド' },
      { optionId: '1', text: 'ジョーズ' },
      { optionId: '2', text: 'ジョニーは戦場へ行った' },
      { optionId: '3', text: 'ミシシッピー・バーニング' },
      { optionId: '4', text: 'プラトゥーン' },
    ],
  },
  {
    quizId: '404',
    question:
      '第4部より問題です。\n『スタンド使い同士ってのは……どういう理由か……\n正体を知らなくても…知らず知らずのうちに引き合うんだ…』\nこれは誰の台詞？',
    options: [
      { optionId: '0', text: '間田敏和' },
      { optionId: '1', text: '空条承太郎' },
      { optionId: '2', text: '東方仗助' },
      { optionId: '3', text: '虹村形兆' },
      { optionId: '4', text: '広瀬康一' },
    ],
  },
  {
    quizId: '405',
    question: '第4部より問題です。\n康一が山岸由花子に告白された場所は？',
    options: [
      { optionId: '0', text: 'CAFE れんが亭' },
      { optionId: '1', text: 'CAFE DEUX MAGOTS' },
      { optionId: '2', text: 'MAXIM' },
      { optionId: '3', text: '喫茶 GREEN' },
      { optionId: '4', text: 'LIG BUTT' },
    ],
  },
  {
    quizId: '406',
    question:
      '第4部より問題です。\n康一が山岸由花子から告白された翌日、昼休憩に康一が掃除していた部屋は？',
    options: [
      { optionId: '0', text: '実験室' },
      { optionId: '1', text: '教室' },
      { optionId: '2', text: '体育館' },
      { optionId: '3', text: '廊下' },
      { optionId: '4', text: '家庭科室' },
    ],
  },
  {
    quizId: '407',
    question:
      '第4部より問題です。\n“康一・仗助・億泰が知っている『山岸由花子に関するデータ』”\nとして書かれていないものは？',
    options: [
      {
        optionId: '0',
        text: '山岸由花子は信念を持っており感情の起伏が激しい女である',
      },
      { optionId: '1', text: '山岸由花子はスタンド使いである。' },
      {
        optionId: '2',
        text: 'そのスタンドは『ラブ・デラックス』と名づけ\n能力は「自分の髪の毛をあやつれる」…パワーは不明\n射程距離は数10メートルのようである',
      },
      {
        optionId: '3',
        text: '山岸由花子は康一のことを愛している\n敵意や攻撃しようとして近づいているのではない',
      },
      {
        optionId: '4',
        text: '山岸由花子はおそろしく思い込みのはげしい異常な女である',
      },
    ],
  },
  {
    quizId: '408',
    question:
      '第4部より問題です。\n康一が山岸由花子に嫌われるための方策、『不潔な男』を演じるために億泰が提案した行動に含まれないものは？',
    options: [
      { optionId: '0', text: '頭に蛾の卵を育てる' },
      { optionId: '1', text: '風呂に入らない' },
      { optionId: '2', text: '歯を磨かない' },
      { optionId: '3', text: 'パンツをとり替えない' },
      { optionId: '4', text: 'ところかまわずへをたれる' },
    ],
  },
  {
    quizId: '409',
    question:
      '第4部より問題です。\n山岸由花子に軟禁される前に行われた英文法試験、康一の点数は？',
    options: [
      { optionId: '0', text: '16点' },
      { optionId: '1', text: '32点' },
      { optionId: '2', text: '5点' },
      { optionId: '3', text: '10点' },
      { optionId: '4', text: '26点' },
    ],
  },
  {
    quizId: '410',
    question:
      '第4部より問題です。\n康一が山岸由花子に軟禁される前に行われた英文法試験、億泰の点数は？',
    options: [
      { optionId: '0', text: '32点' },
      { optionId: '1', text: '16点' },
      { optionId: '2', text: '5点' },
      { optionId: '3', text: '10点' },
      { optionId: '4', text: '26点' },
    ],
  },
  {
    quizId: '411',
    question:
      '第4部より問題です。\nプリンスがよく「FUNKY・MUSIC」と歌っているけど、FUNKY MUSICの日本語訳は？',
    options: [
      { optionId: '0', text: '\n原始の音楽' },
      { optionId: '1', text: '熱狂の音楽' },
      { optionId: '2', text: '幻想の音楽' },
      { optionId: '3', text: '臆病な音楽' },
      { optionId: '4', text: '魅惑の音楽' },
    ],
  },
  {
    quizId: '412',
    question: '第4部より問題です。\n『CONTRAST』の日本語訳は？',
    options: [
      { optionId: '0', text: '対照' },
      { optionId: '1', text: '対象' },
      { optionId: '2', text: '対称' },
      { optionId: '3', text: '対償' },
      { optionId: '4', text: '対症' },
    ],
  },
  {
    quizId: '413',
    question:
      '第4部より問題です。\n山岸由花子のの用意した料理、英単語カードのコーンフレークに入っていなかったのは？',
    options: [
      { optionId: '0', text: 'funny' },
      { optionId: '1', text: 'light' },
      { optionId: '2', text: 'press' },
      { optionId: '3', text: '事情・状況' },
      { optionId: '4', text: '命令・さしず' },
    ],
  },
  {
    quizId: '414',
    question:
      '第4部より問題です。\n康一が山岸由花子に軟禁されたときの食事で用意された不正解の箱の中身に含まれないものは？',
    options: [
      { optionId: '0', text: '修正液' },
      { optionId: '1', text: '石鹸' },
      { optionId: '2', text: 'けしゴム' },
      { optionId: '3', text: '英単語カードのコーンフレーク' },
      { optionId: '4', text: 'アスパラガスに英語辞書をまいたもの' },
    ],
  },
  {
    quizId: '415',
    question:
      '第4部より問題です。\n康一が山岸由花子に軟禁されている屋敷で、トイレの鍵とされていた問題は？',
    options: [
      { optionId: '0', text: 'コロンブスが新大陸を発見した年は西暦何年？' },
      { optionId: '1', text: '桶狭間の戦いがあったのは西暦何年？' },
      { optionId: '2', text: '人類が初めて有人飛行に成功したのは西暦何年' },
      { optionId: '3', text: '鎌倉幕府が滅亡したのは西暦何年？' },
      { optionId: '4', text: '山岸由花子の誕生日は何月何日？' },
    ],
  },
  {
    quizId: '416',
    question: '第4部より問題です。\nエコーズACT2で初めて使った擬音は？',
    options: [
      { optionId: '0', text: 'ドヒュウウウ' },
      { optionId: '1', text: 'ドジュウウ' },
      { optionId: '2', text: 'ドッグオンン' },
      { optionId: '3', text: 'ボヨヨオン' },
      { optionId: '4', text: 'ドッドドドー' },
    ],
  },
  {
    quizId: '417',
    question:
      '第4部より問題です。\n山岸由花子は子供の頃から興奮するとどうなる？',
    options: [
      { optionId: '0', text: '「眼輪筋」がピグピグいって暴力的な気分になる' },
      { optionId: '1', text: '「眼輪筋」がピグピグいって情緒不安定になる' },
      { optionId: '2', text: '「眼輪筋」がピグピグいって情緒不安定になる' },
      { optionId: '3', text: '髪の毛が逆立って破壊衝動に襲われる' },
      { optionId: '4', text: '髪の毛が逆立ってテンションがハイになる' },
    ],
  },
  {
    quizId: '418',
    question:
      '第4部より問題です。\nボヨヨン岬のことを地元の漁師は何と呼んでいる？',
    options: [
      { optionId: '0', text: '神の岬' },
      { optionId: '1', text: '自殺岬' },
      { optionId: '2', text: '跳ね上げ岬' },
      { optionId: '3', text: '幻想岬' },
      { optionId: '4', text: '天女岬' },
    ],
  },
  {
    quizId: '419',
    question: '第4部より問題です。\n山岸由花子の身長は？',
    options: [
      { optionId: '0', text: '167cm' },
      { optionId: '1', text: '153cm' },
      { optionId: '2', text: '157cm' },
      { optionId: '3', text: '165cm' },
      { optionId: '4', text: '172cm' },
    ],
  },
  {
    quizId: '420',
    question: '第4部より問題です。\n東方仗助の身長は？',
    options: [
      { optionId: '0', text: '180cm' },
      { optionId: '1', text: '175cm' },
      { optionId: '2', text: '185cm' },
      { optionId: '3', text: '190cm' },
      { optionId: '4', text: '195cm' },
    ],
  },
  {
    quizId: '421',
    question: '第4部より問題です。\n虹村億泰の身長は？',
    options: [
      { optionId: '0', text: '178cm' },
      { optionId: '1', text: '173cm' },
      { optionId: '2', text: '183cm' },
      { optionId: '3', text: '188cm' },
      { optionId: '4', text: '195cm' },
    ],
  },
  {
    quizId: '422',
    question: '第4部より問題です。\n広瀬康一の身長は？',
    options: [
      { optionId: '0', text: '157cm' },
      { optionId: '1', text: '147cm' },
      { optionId: '2', text: '153cm' },
      { optionId: '3', text: '165cm' },
      { optionId: '4', text: '167cm' },
    ],
  },
  {
    quizId: '423',
    question: '第4部より問題です。\n小林玉美の身長は？',
    options: [
      { optionId: '0', text: '165cm' },
      { optionId: '1', text: '147cm' },
      { optionId: '2', text: '153cm' },
      { optionId: '3', text: '157cm' },
      { optionId: '4', text: '167cm' },
    ],
  },
  {
    quizId: '424',
    question: '第4部より問題です。\nトニオの経営している店は？',
    options: [
      { optionId: '0', text: 'トラサルディー' },
      { optionId: '1', text: 'タリエント' },
      { optionId: '2', text: 'トラファルガー' },
      { optionId: '3', text: 'フィルランド' },
      { optionId: '4', text: 'ティルエント' },
    ],
  },
  {
    quizId: '425',
    question:
      '第4部より問題です。\nトニオの店で億泰が解消してもらった症状として間違っているものは？',
    options: [
      { optionId: '0', text: '頭痛' },
      { optionId: '1', text: '睡眠不足' },
      { optionId: '2', text: '肩こり' },
      { optionId: '3', text: '虫歯' },
      { optionId: '4', text: '水虫' },
    ],
  },
  {
    quizId: '426',
    question:
      '第4部より問題です。\nトニオの店で使われるミネラル・ウォーターはどこの雪解け水？',
    options: [
      { optionId: '0', text: 'キリマンジャロの雪解け水' },
      { optionId: '1', text: 'アルプスの雪解け水' },
      { optionId: '2', text: '富士山の雪解け水' },
      { optionId: '3', text: 'ヘルモン山の雪解け水' },
      { optionId: '4', text: 'エベレストの雪解け水' },
    ],
  },
  {
    quizId: '427',
    question:
      '第4部より問題です。\nトニオの店で億泰は「モッチァレッラチーズとトマトのサラダ」の味の調和をどのように例えた？',
    options: [
      { optionId: '0', text: 'サイモンとガーファンクルのデュエット' },
      { optionId: '1', text: '浜ちゃんに対する松ちゃん' },
      { optionId: '2', text: '悟空に対するベジータ' },
      { optionId: '3', text: 'ダリル・ホールとジョン・オーツのデュエット' },
      { optionId: '4', text: '星飛雄馬に対する花形満' },
    ],
  },
  {
    quizId: '428',
    question:
      '第4部より問題です。\nトニオの店で億泰の食べた、虫歯を治す料理は？',
    options: [
      { optionId: '0', text: '娼婦風スパゲティー' },
      { optionId: '1', text: 'ミネラル・ウォーター' },
      { optionId: '2', text: 'モッチァレッラチーズとトマトのサラダ' },
      { optionId: '3', text: '子羊背肉のリンゴソースかけ' },
      { optionId: '4', text: 'プリン' },
    ],
  },
  {
    quizId: '429',
    question:
      '「ちょっとお二人さん！ クールすぎやしないッ!?」\nこれは誰の台詞？',
    options: [
      { optionId: '0', text: '広瀬康一' },
      { optionId: '1', text: '東方仗助' },
      { optionId: '2', text: 'ジョセフ・ジョースター' },
      { optionId: '3', text: 'スピードワゴン' },
      { optionId: '4', text: 'グイード・ミスタ' },
    ],
  },
  {
    quizId: '430',
    question:
      '第4部より問題です。\n音石明がジョセフの船にスタンドを飛ばすために使ったラジコンは？',
    options: [
      { optionId: '0', text: 'スピットファイヤー' },
      { optionId: '1', text: 'スカイファイター' },
      { optionId: '2', text: 'エクストラ200' },
      { optionId: '3', text: 'スカイレイダー' },
      { optionId: '4', text: 'ヘルキャット' },
    ],
  },
  {
    quizId: '431',
    question: '第4部より問題です。\n音石明の年齢は？',
    options: [
      { optionId: '0', text: '19歳' },
      { optionId: '1', text: '16歳' },
      { optionId: '2', text: '17歳' },
      { optionId: '3', text: '18歳' },
      { optionId: '4', text: '20歳' },
    ],
  },
  {
    quizId: '432',
    question:
      '第4部、話の間ページの説明より問題です。\n『スピードワゴン財団』は誰が設立したと説明されている？',
    options: [
      { optionId: '0', text: 'レオ・スピードワゴン' },
      { optionId: '1', text: 'ロバート・E・O・スピードワゴン' },
      { optionId: '2', text: 'ジョナサン・ジョースター' },
      { optionId: '3', text: 'ロバート・スピードワゴン' },
      { optionId: '4', text: 'ウィルソン・スピードワゴン' },
    ],
  },
  {
    quizId: '433',
    question:
      '第4部より問題です。\nジョセフが日本に来るために乗っていた船の名前は？',
    options: [
      { optionId: '0', text: 'トラフィック号' },
      { optionId: '1', text: 'オリエンタル号' },
      { optionId: '2', text: 'スピードワゴン' },
      { optionId: '3', text: '\nクイーンオリーブ' },
      { optionId: '4', text: 'ラグーン号' },
    ],
  },
  {
    quizId: '434',
    question:
      '第4部より問題です。\nジョセフは億泰の「スタンド使い」という言葉をなんと聞き間違えた？',
    options: [
      { optionId: '0', text: 'イかんぞ歯科医' },
      { optionId: '1', text: '死人ノうがい' },
      { optionId: '2', text: 'ふらっと子飼い' },
      { optionId: '3', text: 'スタンド被害' },
      { optionId: '4', text: 'グレンのクライ' },
    ],
  },
  {
    quizId: '435',
    question:
      '第4部より問題です。\nジョセフが間違えて乗った札幌行きのバスの名前は？',
    options: [
      { optionId: '0', text: 'ホワイトディアー長距離バス' },
      { optionId: '1', text: 'イーグルライナー長距離バス' },
      { optionId: '2', text: 'スターライト長距離バス' },
      { optionId: '3', text: 'ポテトライフ長距離バス' },
      { optionId: '4', text: 'ドリーミング長距離バス' },
    ],
  },
  {
    quizId: '436',
    question: '第4部より問題です。\nジョセフが赤ちゃん用品を買った店は？',
    options: [
      { optionId: '0', text: 'FAMILY CLUB' },
      { optionId: '1', text: 'BIRTHDAY' },
      { optionId: '2', text: 'accessories store' },
      { optionId: '3', text: 'BABY SHOP' },
      { optionId: '4', text: '荒川屋' },
    ],
  },
  {
    quizId: '437',
    question: '第4部より問題です。\n仗助のクレジットカード番号は？',
    options: [
      { optionId: '0', text: '111010-6295-2250' },
      { optionId: '1', text: '127698-6543-2834' },
      { optionId: '2', text: '358201-0156-3545' },
      { optionId: '3', text: '454130-3915-7020' },
      { optionId: '4', text: '800196-1234-9876' },
    ],
  },
  {
    quizId: '438',
    question:
      '第4部より問題です。\nジョセフが赤ちゃん用品を買いに行った際、店員が説明したおむつのメーカーに含まれないものは？',
    options: [
      { optionId: '0', text: 'マミーポコ' },
      { optionId: '1', text: 'ムーニー' },
      { optionId: '2', text: 'ぴぴ' },
      { optionId: '3', text: 'パンパース' },
      { optionId: '4', text: 'ドレミ' },
    ],
  },
  {
    quizId: '439',
    question: '第4部より問題です。\nジョセフが買った赤ちゃん用品の総額は？',
    options: [
      { optionId: '0', text: '136,870円' },
      { optionId: '1', text: '45,800円' },
      { optionId: '2', text: '65,200円' },
      { optionId: '3', text: '94,820円' },
      { optionId: '4', text: '15,080円' },
    ],
  },
  {
    quizId: '440',
    question: '第4部より問題です。\n岸辺露伴が描いている漫画は？',
    options: [
      { optionId: '0', text: 'ピンクダークの少年' },
      { optionId: '1', text: 'レッドダークの少年' },
      { optionId: '2', text: 'ブルーダークの少年' },
      { optionId: '3', text: 'ホワイトライトの少年' },
      { optionId: '4', text: 'ブラックライトの少年' },
    ],
  },
  {
    quizId: '441',
    question: '第4部より問題です。\n岸辺露伴のデビューした時の年齢は？',
    options: [
      { optionId: '0', text: '16歳' },
      { optionId: '1', text: '10歳' },
      { optionId: '2', text: '12歳' },
      { optionId: '3', text: '14歳' },
      { optionId: '4', text: '18歳' },
    ],
  },
  {
    quizId: '442',
    question: '第4部より問題です。\n岸辺露伴の年齢は？',
    options: [
      { optionId: '0', text: '20歳' },
      { optionId: '1', text: '22歳' },
      { optionId: '2', text: '24歳' },
      { optionId: '3', text: '26歳' },
      { optionId: '4', text: '28歳' },
    ],
  },
  {
    quizId: '443',
    question:
      '第4部より問題です。\n岸辺露伴の家に訪れた際、間田敏和の肩に乗っていた蜘蛛は？',
    options: [
      { optionId: '0', text: 'オニグモ' },
      { optionId: '1', text: 'モリグモ' },
      { optionId: '2', text: 'ツチグモ' },
      { optionId: '3', text: 'アシダカグモ' },
      { optionId: '4', text: 'ゴケグモ' },
    ],
  },
  {
    quizId: '444',
    question: '第4部より問題です。\n康一の誕生日は？',
    options: [
      { optionId: '0', text: '44648' },
      { optionId: '1', text: '44685' },
      { optionId: '2', text: '44589' },
      { optionId: '3', text: '44617' },
      { optionId: '4', text: '44679' },
    ],
  },
  {
    quizId: '445',
    question: '第4部より問題です。\n康一の出生時の体重は？',
    options: [
      { optionId: '0', text: '2325g' },
      { optionId: '1', text: '2052g' },
      { optionId: '2', text: '2540g' },
      { optionId: '3', text: '2863g' },
      { optionId: '4', text: '3086g' },
    ],
  },
  {
    quizId: '446',
    question: '第4部より問題です。\n康一の姉の名前は？',
    options: [
      { optionId: '0', text: '綾那' },
      { optionId: '1', text: '美代子' },
      { optionId: '2', text: '梨央' },
      { optionId: '3', text: '順子' },
      { optionId: '4', text: '美那子' },
    ],
  },
  {
    quizId: '447',
    question: '第4部より問題です。\n岸辺露伴にページを取られた康一の体重は？',
    options: [
      { optionId: '0', text: '19.5kg' },
      { optionId: '1', text: '5kg' },
      { optionId: '2', text: '10.5kg' },
      { optionId: '3', text: '13kg' },
      { optionId: '4', text: '16.7kg' },
    ],
  },
  {
    quizId: '448',
    question: '第4部より問題です。\n岸辺露伴の血液型は？',
    options: [
      { optionId: '0', text: 'B型' },
      { optionId: '1', text: 'A型' },
      { optionId: '2', text: 'AB型' },
      { optionId: '3', text: 'O型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '449',
    question:
      '第4部より問題です。\n岸辺露伴はインタビューで「尊敬している人は誰ですか？」と尋ねられた際、どのような回答をしている？',
    options: [
      { optionId: '0', text: 'こせきこうじ' },
      { optionId: '1', text: '手塚治虫' },
      { optionId: '2', text: '鳥山明' },
      { optionId: '3', text: 'ちばてつや' },
      { optionId: '4', text: '秋元治' },
    ],
  },
  {
    quizId: '450',
    question:
      '第4部より問題です。\n杜王町名所その③『岸辺露伴の家』敷地面積は？',
    options: [
      { optionId: '0', text: '103坪' },
      { optionId: '1', text: '48坪' },
      { optionId: '2', text: '86坪' },
      { optionId: '3', text: '152坪' },
      { optionId: '4', text: '208坪' },
    ],
  },
  {
    quizId: '451',
    question:
      '第4部より問題です。\n仗助によって休載する羽目になった岸辺露伴、休載期間は？',
    options: [
      { optionId: '0', text: '1ヶ月あまり' },
      { optionId: '1', text: '1週間' },
      { optionId: '2', text: '2週間' },
      { optionId: '3', text: '3週間' },
      { optionId: '4', text: '2ヶ月あまり' },
    ],
  },
  {
    quizId: '452',
    question:
      '第4部より問題です。\nネズミ対策のベアリング、デモンストレーションで承太郎が撃った缶は？',
    options: [
      { optionId: '0', text: 'ACREY Lemon' },
      { optionId: '1', text: 'Caca-Cola' },
      { optionId: '2', text: 'Apple Cider' },
      { optionId: '3', text: '100% ORANGE' },
      { optionId: '4', text: 'POCARI SWEET' },
    ],
  },
  {
    quizId: '453',
    question: '第4部より問題です。\nスタンド使いになったネズミの種類は？',
    options: [
      { optionId: '0', text: 'ドブネズミ' },
      { optionId: '1', text: 'ハツカネズミ' },
      { optionId: '2', text: 'クマネズミ' },
      { optionId: '3', text: 'カヤネズミ' },
      { optionId: '4', text: 'ヒメネズミ' },
    ],
  },
  {
    quizId: '454',
    question: '第4部より問題です。\nネズミの罠に使用した餌は？',
    options: [
      { optionId: '0', text: 'テンプラ' },
      { optionId: '1', text: 'チーズ' },
      { optionId: '2', text: 'サラミ' },
      { optionId: '3', text: 'パン' },
      { optionId: '4', text: '麦' },
    ],
  },
  {
    quizId: '455',
    question:
      '第4部より問題です。\nスタンド使いのネズミを承太郎は何と名付けた？',
    options: [
      { optionId: '0', text: '虫喰い' },
      { optionId: '1', text: 'ラット' },
      { optionId: '2', text: 'かっこう' },
      { optionId: '3', text: '耳欠け' },
      { optionId: '4', text: 'スノーフライ' },
    ],
  },
  {
    quizId: '456',
    question:
      '第4部より問題です。\nネズミを追跡している歳、仗助が水たまりに落としてしまったクツは？',
    options: [
      { optionId: '0', text: 'バリー' },
      { optionId: '1', text: 'アルマーニ' },
      { optionId: '2', text: 'ハリソン' },
      { optionId: '3', text: 'フェラガモ' },
      { optionId: '4', text: 'ミスタージュンコ' },
    ],
  },
  {
    quizId: '457',
    question:
      '第4部より問題です。\nネズミを追跡している歳、仗助が水たまりに落としてしまったクツ下は？',
    options: [
      { optionId: '0', text: 'ミスタージュンコ' },
      { optionId: '1', text: 'アルマーニ' },
      { optionId: '2', text: 'ハリソン' },
      { optionId: '3', text: 'フェラガモ' },
      { optionId: '4', text: 'バリー' },
    ],
  },
  {
    quizId: '458',
    question:
      '第4部より問題です。\nそば屋「有す川」とコンビニ「オーソン」の間にある店は？',
    options: [
      { optionId: '0', text: '薬屋「ドラッグ・キサラ」' },
      { optionId: '1', text: 'テーラー「タナカ」' },
      { optionId: '2', text: 'サンハイツ「カトー」' },
      { optionId: '3', text: '山田歯科' },
      { optionId: '4', text: 'ブックストア「ヨシダ書店」' },
    ],
  },
  {
    quizId: '459',
    question:
      '第4部より問題です。\n「振り向いてはいけない小道」の先の住宅街にない家は？',
    options: [
      { optionId: '0', text: '寺崎家' },
      { optionId: '1', text: '小野寺家' },
      { optionId: '2', text: '米森家' },
      { optionId: '3', text: '本間家' },
      { optionId: '4', text: '沼倉家' },
    ],
  },
  {
    quizId: '460',
    question: '第4部より問題です。\n杉本鈴美が殺害されたのは何歳の時？',
    options: [
      { optionId: '0', text: '16歳' },
      { optionId: '1', text: '10歳' },
      { optionId: '2', text: '13歳' },
      { optionId: '3', text: '19歳' },
      { optionId: '4', text: '22歳' },
    ],
  },
  {
    quizId: '461',
    question: '第4部より問題です。\n杉本鈴美の住所は？',
    options: [
      { optionId: '0', text: '杜王町勾当台3の12' },
      { optionId: '1', text: '杜王町定禅寺2の4' },
      { optionId: '2', text: '杜王町勾当台5の3' },
      { optionId: '3', text: '杜王町勾当台4の7' },
      { optionId: '4', text: '杜王町定禅寺1の10' },
    ],
  },
  {
    quizId: '462',
    question:
      '第4部より問題です。\n杉本鈴美にポッキー占いをされた岸辺露伴、逆に披露した心理テストで「うすいピンクのマニキュアの女の子」は？',
    options: [
      { optionId: '0', text: '恋に臆病' },
      { optionId: '1', text: '自己中心的' },
      { optionId: '2', text: '優柔不断' },
      { optionId: '3', text: 'まじめで親切' },
      { optionId: '4', text: 'ロマンチスト' },
    ],
  },
  {
    quizId: '463',
    question:
      '第4部、杉本鈴美の台詞より問題です。\n「あなたたち生きてる人間が町の『○○』と『○○』を取り戻さなければ\nいったい誰がとり戻すっていうのよッ！」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '『誇り』と『平和』' },
      { optionId: '1', text: '『希望』と『平和』' },
      { optionId: '2', text: '『希望』と『未来』' },
      { optionId: '3', text: '『運命』と『安全』' },
      { optionId: '4', text: '『運命』と『未来』' },
    ],
  },
  {
    quizId: '464',
    question: '第4部より問題です。\n杜王町新名所その④は？',
    options: [
      { optionId: '0', text: '少女の幽霊に会える小道' },
      { optionId: '1', text: 'アンジェロ岩' },
      { optionId: '2', text: 'ボヨヨン岬' },
      { optionId: '3', text: '岸辺露伴の家' },
      { optionId: '4', text: '送電鉄塔に住む男' },
    ],
  },
  {
    quizId: '465',
    question: '第4部より問題です。\n杉本鈴美が殺害された事件が起こった日は？',
    options: [
      { optionId: '0', text: '30541' },
      { optionId: '1', text: '29744' },
      { optionId: '2', text: '29880' },
      { optionId: '3', text: '29685' },
      { optionId: '4', text: '30438' },
    ],
  },
  {
    quizId: '466',
    question:
      '第4部、岸辺露伴の台詞より問題です。\n「ぼくの「スタンド」『ヘブンズ・ドアー』………\n自分の『遠い記憶』と……　『「○○」は読めない』………………か」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '運命' },
      { optionId: '1', text: '未来' },
      { optionId: '2', text: '無意識' },
      { optionId: '3', text: '感情' },
      { optionId: '4', text: '癖' },
    ],
  },
  {
    quizId: '467',
    question:
      '第4部より問題です。\n重ちーに初めて会う時、仗助の財布に入っていたのは何円？',
    options: [
      { optionId: '0', text: '12円' },
      { optionId: '1', text: '0円' },
      { optionId: '2', text: '55円' },
      { optionId: '3', text: '128円' },
      { optionId: '4', text: '201円' },
    ],
  },
  {
    quizId: '468',
    question: '第4部より問題です。\n重ちーの本名は？',
    options: [
      { optionId: '0', text: '矢安宮重清' },
      { optionId: '1', text: '平安名重清' },
      { optionId: '2', text: '倉永重清' },
      { optionId: '3', text: '保村重清' },
      { optionId: '4', text: '金田一重清' },
    ],
  },
  {
    quizId: '469',
    question: '第4部より問題です。\n重ちーの体重は？',
    options: [
      { optionId: '0', text: '110kg' },
      { optionId: '1', text: '70kg' },
      { optionId: '2', text: '80kg' },
      { optionId: '3', text: '90kg' },
      { optionId: '4', text: '100kg' },
    ],
  },
  {
    quizId: '470',
    question: '第4部より問題です。\n重ちーが家で飼っているカメの名前は？',
    options: [
      { optionId: '0', text: 'ゴン太' },
      { optionId: '1', text: '重吾' },
      { optionId: '2', text: '清彦' },
      { optionId: '3', text: 'ポン助' },
      { optionId: '4', text: 'ハースト' },
    ],
  },
  {
    quizId: '471',
    question:
      '第4部より問題です。\n杜王町駅前にもあるチェーンデパート「カメユー」で買い物をすると100円につき1枚もらえるシールは？',
    options: [
      { optionId: '0', text: 'ブルースタンプ' },
      { optionId: '1', text: 'レッドスタンプ' },
      { optionId: '2', text: 'グリーンスタンプ' },
      { optionId: '3', text: 'パープルスタンプ' },
      { optionId: '4', text: 'イエロースタンプ' },
    ],
  },
  {
    quizId: '472',
    question:
      '第4部より問題です。\nハーヴェストで拾ってきた3等の当たり宝くじ、宝くじの種類は？',
    options: [
      { optionId: '0', text: '年末グレート宝くじ' },
      { optionId: '1', text: 'グリーンジャンボ宝くじ' },
      { optionId: '2', text: 'サマージャンボ宝くじ' },
      { optionId: '3', text: 'ドリーム宝くじ' },
      { optionId: '4', text: '7周年記念宝くじ' },
    ],
  },
  {
    quizId: '473',
    question:
      '第4部より問題です。\nハーヴェストで拾ってきた3等の当たり宝くじ、当選番号は？',
    options: [
      { optionId: '0', text: 'SG組 121314' },
      { optionId: '1', text: 'HJ組 315425' },
      { optionId: '2', text: 'ＯＢ組171737' },
      { optionId: '3', text: 'ＢＴ組094258' },
      { optionId: '4', text: 'CD組185285' },
    ],
  },
  {
    quizId: '474',
    question:
      '第4部より問題です。\nハーヴェストで拾ってきた3等の当たり宝くじ、本来の持ち主は？',
    options: [
      { optionId: '0', text: '森下一郎' },
      { optionId: '1', text: '山本兼平' },
      { optionId: '2', text: '木本太郎' },
      { optionId: '3', text: '井口祐一' },
      { optionId: '4', text: '増田俊樹' },
    ],
  },
  {
    quizId: '475',
    question: '第4部より問題です。\n吉良吉影の年齢は？',
    options: [
      { optionId: '0', text: '33歳' },
      { optionId: '1', text: '28歳' },
      { optionId: '2', text: '38歳' },
      { optionId: '3', text: '43歳' },
      { optionId: '4', text: '48歳' },
    ],
  },
  {
    quizId: '476',
    question:
      '第4部より問題です。\n重ちーも利用していた、サンドイッチが評判のパン屋の名前は？',
    options: [
      { optionId: '0', text: 'サンジェルマン' },
      { optionId: '1', text: 'ひふみベーカリー' },
      { optionId: '2', text: 'エスプレイズ' },
      { optionId: '3', text: 'ラブリーホーム' },
      { optionId: '4', text: 'ミスターハリッツ' },
    ],
  },
  {
    quizId: '477',
    question: '第4部より問題です。\n重ちーが吉良吉影に殺害されたのはいつ？',
    options: [
      { optionId: '0', text: '44736' },
      { optionId: '1', text: '44711' },
      { optionId: '2', text: '44725' },
      { optionId: '3', text: '44745' },
      { optionId: '4', text: '44761' },
    ],
  },
  {
    quizId: '478',
    question:
      '第4部より問題です。\n重ちーが吉良吉影に殺される原因となったサンドイッチ、重ちーが買っていたサンドイッチは？',
    options: [
      { optionId: '0', text: 'テリヤキチキンサンド' },
      { optionId: '1', text: 'BOXサンド' },
      { optionId: '2', text: 'パリジャンスペシャルDX' },
      { optionId: '3', text: 'ハムカツサンド' },
      { optionId: '4', text: 'BLTサンド' },
    ],
  },
  {
    quizId: '479',
    question: '第4部より問題です。\n吉良吉影の勤務先は？',
    options: [
      { optionId: '0', text: 'カメユーチェーン店' },
      { optionId: '1', text: '(株)オトワ企画' },
      { optionId: '2', text: '商英社' },
      { optionId: '3', text: 'S社' },
      { optionId: '4', text: '杜王電機' },
    ],
  },
  {
    quizId: '480',
    question:
      '第4部より問題です。\n吉良吉影が重ちーを殺害するときに爆弾にしたものは？',
    options: [
      { optionId: '0', text: '100円玉' },
      { optionId: '1', text: '1円玉' },
      { optionId: '2', text: '5円玉' },
      { optionId: '3', text: '10円玉' },
      { optionId: '4', text: '50円玉' },
    ],
  },
  {
    quizId: '481',
    question:
      '第4部より問題です。\n各国のエステティシャンコンクールで優勝している辻彩ですが、説明の際に挙げられなかった国は？',
    options: [
      { optionId: '0', text: 'ローマ' },
      { optionId: '1', text: 'パリ' },
      { optionId: '2', text: 'ロンドン' },
      { optionId: '3', text: 'ニューヨーク' },
      { optionId: '4', text: 'ミラノ' },
    ],
  },
  {
    quizId: '482',
    question:
      '第4部より問題です。\nエステ「シンデレラ」の料金表に載っていないメイクは？',
    options: [
      { optionId: '0', text: '理想を掴むメイク' },
      { optionId: '1', text: '愛と出逢うメイク' },
      { optionId: '2', text: 'プロポーズさせるメイク' },
      { optionId: '3', text: '男を服従させるメイク' },
      { optionId: '4', text: '玉の輿にのるメイク' },
    ],
  },
  {
    quizId: '483',
    question:
      '第4部より問題です。\nエステ「シンデレラ」の料金表、「愛を捉えるメイク」は何円？',
    options: [
      { optionId: '0', text: '1500円' },
      { optionId: '1', text: '1000円' },
      { optionId: '2', text: '2000円' },
      { optionId: '3', text: '3000円' },
      { optionId: '4', text: '5000円' },
    ],
  },
  {
    quizId: '484',
    question:
      '第4部より問題です。\nエステ「シンデレラ」で山岸由花子がしてもらった「愛を捉える体」のエステは何円？',
    options: [
      { optionId: '0', text: '72000円' },
      { optionId: '1', text: '3600円' },
      { optionId: '2', text: '7200円' },
      { optionId: '3', text: '36000円' },
      { optionId: '4', text: '360000円' },
    ],
  },
  {
    quizId: '485',
    question:
      '第4部より問題です。\n康一が山岸由花子に恋してしまったことを仗助に報告した際の仗助の台詞\n「スタンドも○○までブッ飛ぶこの衝撃…」',
    options: [
      { optionId: '0', text: '月' },
      { optionId: '1', text: '彼方' },
      { optionId: '2', text: '遠く' },
      { optionId: '3', text: '天国' },
      { optionId: '4', text: '宇宙' },
    ],
  },
  {
    quizId: '486',
    question: '第4部より問題です。\nエステ「シンデレラ」の定休日は？',
    options: [
      { optionId: '0', text: '火曜日' },
      { optionId: '1', text: '月曜日' },
      { optionId: '2', text: '水曜日' },
      { optionId: '3', text: '木曜日' },
      { optionId: '4', text: '日曜日' },
    ],
  },
  {
    quizId: '487',
    question:
      '第4部、「旅行するなら日本のここベスト100」より問題です。\n30歳以上の杜王町の住民は危機一髪で助かった時、何と呟く？',
    options: [
      { optionId: '0', text: 'イワシの頭も信心ね' },
      { optionId: '1', text: '日ごろの行いがよかったから、わたし' },
      { optionId: '2', text: '鼻糞も尊みがらね' },
      { optionId: '3', text: '神はやはり私を見てくださっているのね' },
      { optionId: '4', text: '幸運を使ってしまったわ' },
    ],
  },
  {
    quizId: '488',
    question:
      '第4部、「旅行するなら日本のここベスト100」より問題です。\n旅行者に対して不親切そのものな杜王町の店、どのような態度？',
    options: [
      { optionId: '0', text: '買いたけりゃ売ってやる' },
      { optionId: '1', text: 'ヨソ者が生意気だな' },
      { optionId: '2', text: '金さえ出せば売ってやる' },
      { optionId: '3', text: 'ヨソ者が、観光とはいい身分だな' },
      { optionId: '4', text: '面倒起こさなけりゃ売ってやる' },
    ],
  },
  {
    quizId: '489',
    question:
      '第4部より問題です。\n承太郎と康一が靴のムカデ屋を訪れた際、店主が食べていたお菓子は？',
    options: [
      { optionId: '0', text: 'たべっ子どうぶつ' },
      { optionId: '1', text: 'たべっ子ドーナツ' },
      { optionId: '2', text: 'ヘンシンビスケット' },
      { optionId: '3', text: 'ダイスキクッキー' },
      { optionId: '4', text: 'どうぶつの故郷' },
    ],
  },
  {
    quizId: '490',
    question:
      '第4部より問題です。\n承太郎と康一がシアーハートアタックに攻撃されているとき、康一は敵は近距離パワー型だから何メートル以内に潜んでいるといると推測した？',
    options: [
      { optionId: '0', text: '10メートル' },
      { optionId: '1', text: '2メートル' },
      { optionId: '2', text: '5メートル' },
      { optionId: '3', text: '15メートル' },
      { optionId: '4', text: '20メートル' },
    ],
  },
  {
    quizId: '491',
    question:
      '第4部、シアーハートアタックに攻撃されている際の康一の台詞より問題です。\n「何故殺人鬼のために僕がビクビク後悔して『お願い神様助けて』って感じに逃げ回らなくっちゃあならないんだ？\n『逆』じゃあないか？\nどうしてここから無事で帰れるのなら『○○』って願わなくっちゃあならないんだ……………？」\n○○に入る文章は？',
    options: [
      {
        optionId: '0',
        text: '下痢腹かかえて公衆トイレ捜しているほうがズッと幸せ',
      },
      { optionId: '1', text: 'これから学校でいじめられ続けるほうがズッとマシ' },
      { optionId: '2', text: '50万円タカられるほうがズッと幸せ' },
      { optionId: '3', text: 'スタンド能力を身に着けなかったほうがズッと幸せ' },
      { optionId: '4', text: '敵にズッと逃げられるほうが幸せ' },
    ],
  },
  {
    quizId: '492',
    question: '第4部より問題です。\nエコーズACT3に初めてした命令は？',
    options: [
      { optionId: '0', text: '僕らの身を守れ' },
      { optionId: '1', text: '敵を止めろ' },
      { optionId: '2', text: 'なんとかしろ' },
      { optionId: '3', text: '僕を助けろ' },
      { optionId: '4', text: '承太郎さんを助けろ' },
    ],
  },
  {
    quizId: '493',
    question:
      '第4部より問題です。\n吉良吉影がボタンの縫い付けのために靴のムカデ屋に出していたスーツは？',
    options: [
      { optionId: '0', text: 'ヴァレンチノ' },
      { optionId: '1', text: 'ポール・スミス' },
      { optionId: '2', text: 'ドルチェ＆ガッバーナ' },
      { optionId: '3', text: 'ヴェルサーチ' },
      { optionId: '4', text: 'ジャンフランコ・フェレ' },
    ],
  },
  {
    quizId: '494',
    question: '第4部より問題です。\n吉良吉影の実家の住所は？',
    options: [
      { optionId: '0', text: '杜王町浄禅寺1の28' },
      { optionId: '1', text: '杜王町浄禅寺2の4' },
      { optionId: '2', text: '杜王町浄禅寺4の1280' },
      { optionId: '3', text: '杜王町浄禅寺3の16' },
      { optionId: '4', text: '杜王町浄禅寺1の6' },
    ],
  },
  {
    quizId: '495',
    question: '第4部より問題です。\n吉良吉影の生年月日は？',
    options: [
      { optionId: '0', text: '24137' },
      { optionId: '1', text: '22349' },
      { optionId: '2', text: '22606' },
      { optionId: '3', text: '24256' },
      { optionId: '4', text: '26153' },
    ],
  },
  {
    quizId: '496',
    question: '第4部より問題です。\n吉良吉影が高校生の時に受賞したものは？',
    options: [
      { optionId: '0', text: 'ヴァイオリン演奏 第3位' },
      { optionId: '1', text: '200mハードル 第3位' },
      { optionId: '2', text: '書道コンクール 銅賞' },
      { optionId: '3', text: '作文コンクール 第3位' },
      { optionId: '4', text: '棒高跳び 第3位' },
    ],
  },
  {
    quizId: '497',
    question: '第4部より問題です。\n次の内、吉良吉影の実家に無かった本は？',
    options: [
      { optionId: '0', text: '快適な睡眠時間' },
      { optionId: '1', text: 'ストレッチ' },
      { optionId: '2', text: '人体健康辞典' },
      { optionId: '3', text: 'ダイエット栄養学' },
      { optionId: '4', text: '健康と食品' },
    ],
  },
  {
    quizId: '498',
    question: '第4部より問題です。\n吉良吉影の父親の名前は？',
    options: [
      { optionId: '0', text: '吉良吉廣' },
      { optionId: '1', text: '吉良吉和' },
      { optionId: '2', text: '吉良宗影' },
      { optionId: '3', text: '吉良徳吉' },
      { optionId: '4', text: '吉良影義' },
    ],
  },
  {
    quizId: '499',
    question: '第4部より問題です。\n吉良吉影の父親の死因は？',
    options: [
      { optionId: '0', text: 'ガン' },
      { optionId: '1', text: '脳いっ血' },
      { optionId: '2', text: '脳卒中' },
      { optionId: '3', text: '脳梗塞' },
      { optionId: '4', text: '心筋梗塞' },
    ],
  },
  {
    quizId: '500',
    question: '第4部より問題です。\n吉良吉影の最終学歴は？',
    options: [
      { optionId: '0', text: 'D学院文学部卒' },
      { optionId: '1', text: 'ぶどうヶ丘高校卒' },
      { optionId: '2', text: '杜王高校卒' },
      { optionId: '3', text: '盛浄高校卒' },
      { optionId: '4', text: '中央大学法学部卒' },
    ],
  },
  {
    quizId: '501',
    question:
      '第4部より問題です。\n1983年、吉良吉影の右手親指の爪は何センチ伸びた？',
    options: [
      { optionId: '0', text: '31.5センチ' },
      { optionId: '1', text: '8.5センチ' },
      { optionId: '2', text: '9.2センチ' },
      { optionId: '3', text: '29.8センチ' },
      { optionId: '4', text: '30.4センチ' },
    ],
  },
  {
    quizId: '502',
    question:
      '第4部より問題です。\n吉良吉影が川尻浩作として初めて自宅へ行ったときに夕食に用意されていたカップ麺は？',
    options: [
      { optionId: '0', text: 'ラーメンランド' },
      { optionId: '1', text: 'チキンラーメン' },
      { optionId: '2', text: 'とん兵衛' },
      { optionId: '3', text: 'カップヌードル' },
      { optionId: '4', text: '美味しいラーメン' },
    ],
  },
  {
    quizId: '503',
    question:
      '第4部より問題です。\n岸辺露伴が書店で買おうとしていた、植物「イラスト図鑑」のタイトルは？',
    options: [
      { optionId: '0', text: 'THE PLANT COMPENDIUM' },
      { optionId: '1', text: '野外観察図鑑' },
      { optionId: '2', text: '植物生態観察記' },
      { optionId: '3', text: '多肉植物大図鑑' },
      { optionId: '4', text: '日本帰化植物写真図鑑' },
    ],
  },
  {
    quizId: '504',
    question: '第4部より問題です。\n大柳賢のスタンドは？',
    options: [
      { optionId: '0', text: 'ボーイ・Ⅱ・マン' },
      { optionId: '1', text: 'チープ・トリック' },
      { optionId: '2', text: 'エニグマ' },
      { optionId: '3', text: 'スーパーフライ' },
      { optionId: '4', text: 'サーフィス' },
    ],
  },
  {
    quizId: '505',
    question: '第4部より問題です。\n大柳賢の年齢は？',
    options: [
      { optionId: '0', text: '11歳' },
      { optionId: '1', text: '9歳' },
      { optionId: '2', text: '10歳' },
      { optionId: '3', text: '12歳' },
      { optionId: '4', text: '13歳' },
    ],
  },
  {
    quizId: '506',
    question: '第4部より問題です。\n大柳賢の好きなスポーツは？',
    options: [
      { optionId: '0', text: 'サッカー' },
      { optionId: '1', text: 'テニス' },
      { optionId: '2', text: '野球' },
      { optionId: '3', text: '水泳' },
      { optionId: '4', text: 'ホッケー' },
    ],
  },
  {
    quizId: '507',
    question: '第4部より問題です。\n大柳賢の好きな食べ物は？',
    options: [
      { optionId: '0', text: '肉のあぶら身' },
      { optionId: '1', text: 'アンパン' },
      { optionId: '2', text: '梅干し' },
      { optionId: '3', text: 'ラムネ' },
      { optionId: '4', text: 'ハヤシライス' },
    ],
  },
  {
    quizId: '508',
    question:
      '第4部より問題です。\n大柳賢の嫌いな食べ物、ピーマンとあと一つは？',
    options: [
      { optionId: '0', text: 'アンパン' },
      { optionId: '1', text: '肉のあぶら身' },
      { optionId: '2', text: '梅干し' },
      { optionId: '3', text: 'ラムネ' },
      { optionId: '4', text: 'ハヤシライス' },
    ],
  },
  {
    quizId: '509',
    question: '第4部より問題です。\n大柳賢のこわいものは？',
    options: [
      { optionId: '0', text: '歯医者となまはげ' },
      { optionId: '1', text: '注射' },
      { optionId: '2', text: '怪談と父親' },
      { optionId: '3', text: '蛇' },
      { optionId: '4', text: '特になし' },
    ],
  },
  {
    quizId: '510',
    question:
      '第4部、岸辺露伴の台詞より問題です。\n「いいねえ～～っ！　気に入ったぞ小僧\nぼくはそういう『○○』っていうような根性を持ってるヤツにグッとくるんだ」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'まるで劇画' },
      { optionId: '1', text: 'まるで映画' },
      { optionId: '2', text: 'まるでフィクション' },
      { optionId: '3', text: 'まるでドラマ' },
      { optionId: '4', text: 'まるで漫画' },
    ],
  },
  {
    quizId: '511',
    question:
      '第4部より問題です。\nヌ・ミキタカゾ・ンシは、自分の故郷の星はどこにある言っている？',
    options: [
      { optionId: '0', text: 'マゼラン星雲' },
      { optionId: '1', text: 'ハレー' },
      { optionId: '2', text: 'トーチタス' },
      { optionId: '3', text: 'M78星雲' },
      { optionId: '4', text: 'ドナティ' },
    ],
  },
  {
    quizId: '512',
    question:
      '第4部より問題です。\n億泰の嫌いな月曜の朝、唯一の心のなぐさめは？',
    options: [
      {
        optionId: '0',
        text: 'ストロベリー＆チョコチップアイスをなめながら登校すること',
      },
      { optionId: '1', text: '夜にトニオさんの店で食事をするのを想像すること' },
      { optionId: '2', text: '好きな音楽を聴いてからゆっくり登校すること' },
      { optionId: '3', text: '目覚ましをセットせずに、気の向くままに寝ること' },
      { optionId: '4', text: '朝食をお腹一杯食べること' },
    ],
  },
  {
    quizId: '513',
    question:
      '第4部より問題です。\nヌ・ミキタカゾ・ンシは、自分の年齢を何歳と言っている？',
    options: [
      { optionId: '0', text: '216歳' },
      { optionId: '1', text: '18歳' },
      { optionId: '2', text: '400歳' },
      { optionId: '3', text: '816歳' },
      { optionId: '4', text: '1022歳' },
    ],
  },
  {
    quizId: '514',
    question:
      '第4部より問題です。\nヌ・ミキタカゾ・ンシは、自分の職業を何と言っている？',
    options: [
      { optionId: '0', text: '宇宙船のパイロット' },
      { optionId: '1', text: '探検家' },
      { optionId: '2', text: '学生' },
      { optionId: '3', text: '惑星評論家' },
      { optionId: '4', text: '防衛機関隊員' },
    ],
  },
  {
    quizId: '515',
    question:
      '第4部より問題です。\nヌ・ミキタカゾ・ンシは、自分の趣味を何と言っている？',
    options: [
      { optionId: '0', text: '動物を飼うこと' },
      { optionId: '1', text: '旅行' },
      { optionId: '2', text: '人の役に立つこと' },
      { optionId: '3', text: '寝ること' },
      { optionId: '4', text: '読書' },
    ],
  },
  {
    quizId: '516',
    question:
      '第4部より問題です。\nヌ・ミキタカゾ・ンシが初登場時にカバンに連れていた動物は？',
    options: [
      { optionId: '0', text: 'ハツカネズミ' },
      { optionId: '1', text: 'ドブネズミ' },
      { optionId: '2', text: 'クマネズミ' },
      { optionId: '3', text: 'カヤネズミ' },
      { optionId: '4', text: 'ヒメネズミ' },
    ],
  },
  {
    quizId: '517',
    question:
      '第4部より問題です。\n仗助と露伴のチンチロリン勝負、その最中に露伴が自ら傷つけた部位は？',
    options: [
      { optionId: '0', text: '左手の小指' },
      { optionId: '1', text: '右手の小指' },
      { optionId: '2', text: '左手の親指' },
      { optionId: '3', text: '右手の親指' },
      { optionId: '4', text: '左手の薬指' },
    ],
  },
  {
    quizId: '518',
    question:
      '第4部より問題です。\n小林玉美に取立人を依頼した場合の手数料は何%？',
    options: [
      { optionId: '0', text: '0.2' },
      { optionId: '1', text: '0.05' },
      { optionId: '2', text: '0.1' },
      { optionId: '3', text: '0.15' },
      { optionId: '4', text: '0.25' },
    ],
  },
  {
    quizId: '519',
    question:
      '第4部より問題です。\n仗助と露伴のチンチロリン勝負、その最中に自宅が火事で半焼した露伴の損害は？',
    options: [
      { optionId: '0', text: '700万円' },
      { optionId: '1', text: '0円' },
      { optionId: '2', text: '200万円' },
      { optionId: '3', text: '500万円' },
      { optionId: '4', text: '1000万円' },
    ],
  },
  {
    quizId: '520',
    question: '第4部より問題です。\nヌ・ミキタカゾ・ンシの地球での仮の名は？',
    options: [
      { optionId: '0', text: '支倉未起隆' },
      { optionId: '1', text: '荻山未起隆' },
      { optionId: '2', text: '萩原幹隆' },
      { optionId: '3', text: '小野寺幹隆' },
      { optionId: '4', text: '六串未起隆' },
    ],
  },
  {
    quizId: '521',
    question:
      '第4部より問題です。\n露伴の自宅で起きた火事で焼けてしまった『プリティ・ウーマン』の中に出ていたものと同じ家具、どこのメーカーのもの？',
    options: [
      { optionId: '0', text: 'ドルクセル・ヘリテイジ' },
      { optionId: '1', text: 'アクタス' },
      { optionId: '2', text: 'クラスティーナ' },
      { optionId: '3', text: 'カッシーナ' },
      { optionId: '4', text: 'アルフレックス' },
    ],
  },
  {
    quizId: '522',
    question:
      '第4部より問題です。\n露伴がハイウェイ・スターに襲われたトンネルの名前は？',
    options: [
      { optionId: '0', text: '二つ杜トンネル' },
      { optionId: '1', text: '北山トンネル' },
      { optionId: '2', text: '嶋の越トンネル' },
      { optionId: '3', text: '鳩の杜トンネル' },
      { optionId: '4', text: '勇玄トンネル' },
    ],
  },
  {
    quizId: '523',
    question:
      '第4部より問題です。\nハイウェイ・スター編で使用した岸辺露伴のバイクのナンバーは？',
    options: [
      { optionId: '0', text: '58-29' },
      { optionId: '1', text: '36-34' },
      { optionId: '2', text: '29-43' },
      { optionId: '3', text: '67-51' },
      { optionId: '4', text: '88-88' },
    ],
  },
  {
    quizId: '524',
    question:
      '第4部、岸辺露伴の台詞より問題です。\n「だが断る\nこの岸辺露伴が最も好きな事のひとつは自分で強いと思ってるやつに『○○』と断ってやる事だ…」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'NO' },
      { optionId: '1', text: '断る' },
      { optionId: '2', text: 'YES' },
      { optionId: '3', text: 'バカめ' },
      { optionId: '4', text: 'まぬけ' },
    ],
  },
  {
    quizId: '525',
    question: '第4部より問題です。\n噴上裕也の入院していた病室は？',
    options: [
      { optionId: '0', text: '525号室' },
      { optionId: '1', text: '302号室' },
      { optionId: '2', text: '415号室' },
      { optionId: '3', text: '430号室' },
      { optionId: '4', text: '517号室' },
    ],
  },
  {
    quizId: '526',
    question:
      '第4部より問題です。\n噴上裕也の病室で果物をむいていた女の名前は？',
    options: [
      { optionId: '0', text: 'アケミ' },
      { optionId: '1', text: 'ヨシエ' },
      { optionId: '2', text: 'レイコ' },
      { optionId: '3', text: 'アヤナ' },
      { optionId: '4', text: 'トモコ' },
    ],
  },
  {
    quizId: '527',
    question: '第4部より問題です。\nストレイ・キャットが猫の時の猫種は？',
    options: [
      { optionId: '0', text: 'ブリティッシュ・ブルー' },
      { optionId: '1', text: 'アメリカンショートヘア' },
      { optionId: '2', text: 'オリエンタル' },
      { optionId: '3', text: 'ターキッシュバン' },
      { optionId: '4', text: 'ラグドール' },
    ],
  },
  {
    quizId: '528',
    question:
      '第4部より問題です。\nストレイ・キャットににおいを嗅がせた、吉良吉影の持っていたタバコは？',
    options: [
      { optionId: '0', text: 'KENTA' },
      { optionId: '1', text: 'Marlboro' },
      { optionId: '2', text: 'HOPE' },
      { optionId: '3', text: 'LUCKY STRIKE' },
      { optionId: '4', text: 'PASSIMO' },
    ],
  },
  {
    quizId: '529',
    question: '第4部より問題です。\n川尻浩作の妻の名前は？',
    options: [
      { optionId: '0', text: '川尻しのぶ' },
      { optionId: '1', text: '川尻わかな' },
      { optionId: '2', text: '川尻エリカ' },
      { optionId: '3', text: '川尻しおり' },
      { optionId: '4', text: '川尻レイナ' },
    ],
  },
  {
    quizId: '530',
    question:
      '第4部より問題です。\nストレイ・キャットはどの部位で空気を操作する？',
    options: [
      { optionId: '0', text: 'ヒゲ' },
      { optionId: '1', text: '口' },
      { optionId: '2', text: '葉' },
      { optionId: '3', text: '根' },
      { optionId: '4', text: '耳' },
    ],
  },
  {
    quizId: '531',
    question:
      '第4部より問題です。\n次の内、ストレイ・キャットの好物でないものは？',
    options: [
      { optionId: '0', text: 'イワシ' },
      { optionId: '1', text: 'ほめられる事' },
      { optionId: '2', text: '甘エビ' },
      { optionId: '3', text: 'TVをみる事' },
      { optionId: '4', text: '紙袋に頭を入れる事' },
    ],
  },
  {
    quizId: '532',
    question:
      '第4部より問題です。\n次の内、ストレイ・キャットの嫌いなものでないものは？',
    options: [
      { optionId: '0', text: 'トロ' },
      { optionId: '1', text: 'タバコ' },
      { optionId: '2', text: 'わさび' },
      { optionId: '3', text: 'ミカン' },
      { optionId: '4', text: '寒いところ' },
    ],
  },
  {
    quizId: '533',
    question:
      '第4部より問題です。\n次の内、スーパーフライの鉄塔下に生えている野草として間違っているものは？',
    options: [
      { optionId: '0', text: 'ユキザサ' },
      { optionId: '1', text: 'ヤマウド' },
      { optionId: '2', text: 'オランダガラシ' },
      { optionId: '3', text: 'ヒメジョオン' },
      { optionId: '4', text: 'ツユクサ' },
    ],
  },
  {
    quizId: '534',
    question: '第4部より問題です。\n鋼田一豊大のスタンドは？',
    options: [
      { optionId: '0', text: 'スーパーフライ' },
      { optionId: '1', text: 'チープ・トリック' },
      { optionId: '2', text: 'エニグマ' },
      { optionId: '3', text: 'ボーイ・Ⅱ・マン' },
      { optionId: '4', text: 'サーフィス' },
    ],
  },
  {
    quizId: '535',
    question:
      '第4部より問題です。\n噴上裕也のお見舞いに行く前のパチンコで勝ち、チョコをお土産に持ってきたのは？',
    options: [
      { optionId: '0', text: 'アケミ' },
      { optionId: '1', text: 'ヨシエ' },
      { optionId: '2', text: 'レイコ' },
      { optionId: '3', text: 'アヤナ' },
      { optionId: '4', text: 'トモコ' },
    ],
  },
  {
    quizId: '536',
    question: '第4部より問題です。\n東方朋子の恐怖のサインは？',
    options: [
      { optionId: '0', text: 'ツバを飲み込む' },
      { optionId: '1', text: '目ばたきを二度する' },
      { optionId: '2', text: '下唇を歯でかむ' },
      { optionId: '3', text: 'アゴを指でいじる' },
      { optionId: '4', text: '目をつぶる' },
    ],
  },
  {
    quizId: '537',
    question: '第4部より問題です。\n康一の恐怖のサインは？',
    options: [
      { optionId: '0', text: '目ばたきを二度する' },
      { optionId: '1', text: '目ばたきを二度する' },
      { optionId: '2', text: '下唇を歯でかむ' },
      { optionId: '3', text: 'アゴを指でいじる' },
      { optionId: '4', text: '目をつぶる' },
    ],
  },
  {
    quizId: '538',
    question:
      '第4部より問題です。\nエニグマの能力で紙にされていた、東方朋子の好物であるお菓子は？',
    options: [
      { optionId: '0', text: '鎌倉カスター' },
      { optionId: '1', text: '杜王シュー' },
      { optionId: '2', text: '牛久エクレア' },
      { optionId: '3', text: '道内ドウナツ' },
      { optionId: '4', text: 'まるぷくタイヤキ' },
    ],
  },
  {
    quizId: '539',
    question: '第4部より問題です。\nエニグマの能力で紙にされなかったものは？',
    options: [
      { optionId: '0', text: '椅子' },
      { optionId: '1', text: 'タクシー' },
      { optionId: '2', text: 'ジュース' },
      { optionId: '3', text: 'トンコツラーメン' },
      { optionId: '4', text: '炎' },
    ],
  },
  {
    quizId: '540',
    question:
      '第4部より問題です。\n仗助に本にされたエニグマのスタンド使い、その後どうなった？',
    options: [
      { optionId: '0', text: '杜王町立図書館に寄付された' },
      { optionId: '1', text: '古本屋に売却された' },
      { optionId: '2', text: '仗助の部屋に置かれた' },
      { optionId: '3', text: 'スピードワゴン財団で管理された' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '541',
    question:
      '第4部より問題です。\n川尻浩作となった吉良吉影に殺された、質問を質問で返した女性の名前は？',
    options: [
      { optionId: '0', text: '美那子' },
      { optionId: '1', text: '美代子' },
      { optionId: '2', text: '綾那' },
      { optionId: '3', text: '順子' },
      { optionId: '4', text: '梨央' },
    ],
  },
  {
    quizId: '542',
    question: '第4部より問題です。\n吉良吉影の血液型は？',
    options: [
      { optionId: '0', text: 'A型' },
      { optionId: '1', text: 'B型' },
      { optionId: '2', text: 'O型' },
      { optionId: '3', text: 'AB型' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '543',
    question:
      '第4部より問題です。\n吉良吉影が自分の切った爪を集め、長さを測るようになったのはいつから？',
    options: [
      { optionId: '0', text: '1975年' },
      { optionId: '1', text: '1972年' },
      { optionId: '2', text: '1978年' },
      { optionId: '3', text: '1980年' },
      { optionId: '4', text: '1983年' },
    ],
  },
  {
    quizId: '544',
    question: '第4部より問題です。\n吉良吉影の好きな映画は？',
    options: [
      { optionId: '0', text: '日の名残り' },
      { optionId: '1', text: '氷の微笑' },
      { optionId: '2', text: 'スピード' },
      { optionId: '3', text: '仮面の男' },
      { optionId: '4', text: 'パーフェクトワールド' },
    ],
  },
  {
    quizId: '545',
    question: '第4部より問題です。\n吉良吉影の好きなファッションは？',
    options: [
      { optionId: '0', text: 'ジャンフランコ・フェレ' },
      { optionId: '1', text: 'ポール・スミス' },
      { optionId: '2', text: 'ドルチェ＆ガッバーナ' },
      { optionId: '3', text: 'ヴェルサーチ' },
      { optionId: '4', text: 'ヴァレンチノ' },
    ],
  },
  {
    quizId: '546',
    question: '第4部より問題です。\nトニオ・トラサルディーのスタンドは？',
    options: [
      { optionId: '0', text: 'パール・ジャム' },
      { optionId: '1', text: 'チープ・トリック' },
      { optionId: '2', text: 'スーパーフライ' },
      { optionId: '3', text: 'エニグマ' },
      { optionId: '4', text: 'サーフィス' },
    ],
  },
  {
    quizId: '547',
    question: '第4部より問題です。\n川尻浩作の勤務している会社は？',
    options: [
      { optionId: '0', text: 'S社' },
      { optionId: '1', text: '(株)オトワ企画' },
      { optionId: '2', text: '商英社' },
      { optionId: '3', text: 'カメユーチェーン店' },
      { optionId: '4', text: '杜王電機' },
    ],
  },
  {
    quizId: '548',
    question: '第4部より問題です。\n乙雅三は何年生まれ？',
    options: [
      { optionId: '0', text: '\n1970年生' },
      { optionId: '1', text: '1953年生' },
      { optionId: '2', text: '1957年生' },
      { optionId: '3', text: '1962年生' },
      { optionId: '4', text: '1965年生' },
    ],
  },
  {
    quizId: '549',
    question: '第4部より問題です。\n乙雅三のスタンドは？',
    options: [
      { optionId: '0', text: 'チープ・トリック' },
      { optionId: '1', text: 'スーパーフライ' },
      { optionId: '2', text: 'エニグマ' },
      { optionId: '3', text: 'ボーイ・Ⅱ・マン' },
      { optionId: '4', text: 'サーフィス' },
    ],
  },
  {
    quizId: '550',
    question:
      '第4部より問題です。\n杜王町のホテル、岸辺露伴がチープ・トリックに攻撃されていた時に承太郎が泊まっていた部屋番号は？',
    options: [
      { optionId: '0', text: '325号室' },
      { optionId: '1', text: '213号室' },
      { optionId: '2', text: '912号室' },
      { optionId: '3', text: '1212号室' },
      { optionId: '4', text: '3245号室' },
    ],
  },
  {
    quizId: '551',
    question: '第4部より問題です。\n虹村億泰の住所は？',
    options: [
      { optionId: '0', text: '杜王町浄禅寺4の1280' },
      { optionId: '1', text: '杜王町浄禅寺2の4' },
      { optionId: '2', text: '杜王町浄禅寺1の28' },
      { optionId: '3', text: '杜王町浄禅寺3の16' },
      { optionId: '4', text: '杜王町浄禅寺1の6' },
    ],
  },
  {
    quizId: '552',
    question:
      '第4部より問題です。\nチープ・トリックに呼ばれて岸辺露伴の家に訪れたものとして間違っているのは？',
    options: [
      { optionId: '0', text: 'バーガーキング' },
      { optionId: '1', text: '鮨幸' },
      { optionId: '2', text: '中華の王王軒' },
      { optionId: '3', text: '米屋' },
      { optionId: '4', text: '消防' },
    ],
  },
  {
    quizId: '553',
    question:
      '第4部より問題です。\nバイツァ・ダストの繰り返す時の中で割れてしまった川尻家の食器は？',
    options: [
      { optionId: '0', text: 'ウェッジウッドのハンティングシーン' },
      { optionId: '1', text: 'バカラのグラス' },
      { optionId: '2', text: 'ナハトマンのダンシングスター' },
      { optionId: '3', text: 'マイセンマーク　コーヒーカップ＆ソーサー' },
      { optionId: '4', text: 'アウガルテンのコーヒーカップ' },
    ],
  },
  {
    quizId: '554',
    question:
      '第4部より問題です。\nバイツァ・ダストの繰り返す時の中でペプシの上に雷が落ちたのはいつ？',
    options: [
      { optionId: '0', text: '0.352083333333333' },
      { optionId: '1', text: '0.35' },
      { optionId: '2', text: '0.353472222222222' },
      { optionId: '3', text: '0.354166666666667' },
      { optionId: '4', text: '0.358333333333333' },
    ],
  },
  {
    quizId: '555',
    question:
      '第4部より問題です。\nバイツァ・ダストの繰り返す時の中で、岸辺露伴が読んだ川尻早人の警告に記されてなかったのは？',
    options: [
      { optionId: '0', text: '女の人が走っていった。' },
      { optionId: '1', text: 'ズボンのチャックを開けたオヤジが通った。' },
      { optionId: '2', text: 'クシャミをした。ちくしょーと言った。' },
      { optionId: '3', text: '雨が降った。' },
      { optionId: '4', text: '岸辺ロハンも殺された。' },
    ],
  },
  {
    quizId: '556',
    question:
      '第4部より問題です。\nキラークイーン『第3の爆弾』BITE THE DUST(バイツァダスト)の意味は？',
    options: [
      { optionId: '0', text: '負けて死ね' },
      { optionId: '1', text: '塵となれ' },
      { optionId: '2', text: '地獄へ道づれ' },
      { optionId: '3', text: '恥を知れ' },
      { optionId: '4', text: '世界よ壊れろ' },
    ],
  },
  {
    quizId: '557',
    question:
      '第4部より問題です。\n岸辺露伴がバイツァ・ダストによって爆死したのはいつ？',
    options: [
      { optionId: '0', text: '0.353472222222222' },
      { optionId: '1', text: '0.35' },
      { optionId: '2', text: '0.352083333333333' },
      { optionId: '3', text: '0.354166666666667' },
      { optionId: '4', text: '0.358333333333333' },
    ],
  },
  {
    quizId: '558',
    question:
      '第4部より問題です。\n川尻早人がストレイキャットを試す際に盾にした本は？',
    options: [
      { optionId: '0', text: "Imidas'99" },
      { optionId: '1', text: "タウンページ'99" },
      { optionId: '2', text: '週刊少年ジャンプ 29号' },
      { optionId: '3', text: '月刊少年ジャンプ 5月号' },
      { optionId: '4', text: '広辞苑 第五版' },
    ],
  },
  {
    quizId: '559',
    question:
      '第4部より問題です。\nバイツァ・ダストの繰り返す時の中で川尻家にかかった間違い電話、本来は誰宛の電話だった？',
    options: [
      { optionId: '0', text: '桜井' },
      { optionId: '1', text: '太野' },
      { optionId: '2', text: '松下' },
      { optionId: '3', text: '一宮' },
      { optionId: '4', text: '相庭' },
    ],
  },
  {
    quizId: '560',
    question: '第4部より問題です。\n吉良吉影の腕の長さは？',
    options: [
      { optionId: '0', text: '65センチ' },
      { optionId: '1', text: '58センチ' },
      { optionId: '2', text: '62センチ' },
      { optionId: '3', text: '68センチ' },
      { optionId: '4', text: '72センチ' },
    ],
  },
  {
    quizId: '561',
    question:
      '第4部、仗助の台詞より問題です。\n「億泰とは気が合うんだ…………\nおめーにはわかんねーだろうが、こいつはオレの○○なんだ…………」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '友達' },
      { optionId: '1', text: '親友' },
      { optionId: '2', text: '仲間' },
      { optionId: '3', text: '好敵手' },
      { optionId: '4', text: 'ダチ' },
    ],
  },
  {
    quizId: '562',
    question:
      '第4部より問題です。\n吉良吉影との戦いで、仗助と川尻早人が逃げ込んだ辺りの家に住んでいる、よく下着を盗まれるの？',
    options: [
      { optionId: '0', text: '梨央' },
      { optionId: '1', text: '美代子' },
      { optionId: '2', text: '綾那' },
      { optionId: '3', text: '順子' },
      { optionId: '4', text: '美那子' },
    ],
  },
  {
    quizId: '563',
    question:
      '第4部より問題です。\n吉良吉影との戦いで、仗助と川尻早人が逃げ込んだ家に置かれていたタバコは？',
    options: [
      { optionId: '0', text: 'HOPE' },
      { optionId: '1', text: 'Marlboro' },
      { optionId: '2', text: 'KENTA' },
      { optionId: '3', text: 'LUCKY STRIKE' },
      { optionId: '4', text: 'PASSIMO' },
    ],
  },
  {
    quizId: '564',
    question:
      '第4部、死の淵から蘇った億泰の台詞より問題です。\n「そしたら兄貴は…『おまえが決めろ』って言うんだよ……\n『億泰…行き先を決めるのはおまえだ』ってな…\nオレはちょっと考えてよォー\n『○○に行く』って答えたら目が醒めたんだ………\nとてもさびしい夢だったよ」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '杜王町' },
      { optionId: '1', text: '仗助んとこ' },
      { optionId: '2', text: '皆んとこ' },
      { optionId: '3', text: '仲間んとこ' },
      { optionId: '4', text: 'あっち' },
    ],
  },
  {
    quizId: '565',
    question:
      '第4部より問題です。\n承太郎に吹っ飛ばされた吉良吉影を轢き、死に至らしめた車は？',
    options: [
      { optionId: '0', text: '救急車' },
      { optionId: '1', text: '消防車' },
      { optionId: '2', text: 'パトカー' },
      { optionId: '3', text: 'タクシー' },
      { optionId: '4', text: '梯子車' },
    ],
  },
  {
    quizId: '566',
    question:
      '第4部の最終話のタイトル\n『さよなら杜王町 ―○○』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '黄金の心' },
      { optionId: '1', text: '黄金の精神' },
      { optionId: '2', text: '黄金の魂' },
      { optionId: '3', text: '黄金の体験' },
      { optionId: '4', text: '黄金の期間' },
    ],
  },
  {
    quizId: '567',
    question:
      '第4部、ジョセフの台詞より問題です。\n「かつてわしらもエジプトに向かう時に見た………\n「○○」の輝きの中にあるという『黄金の精神』を………\nわしは仗助たちの中に見たよ………\nそれがあるかぎり大丈夫じゃ………」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '正義' },
      { optionId: '1', text: '魂' },
      { optionId: '2', text: '心' },
      { optionId: '3', text: 'スタンド' },
      { optionId: '4', text: '精神' },
    ],
  },
  {
    quizId: '568',
    question:
      '第4部より問題です。\n杜王町に滞在中に執筆した論文で博士号をとった承太郎、何の研究で博士号をとった？',
    options: [
      { optionId: '0', text: 'ヒトデ' },
      { optionId: '1', text: 'クジラ' },
      { optionId: '2', text: 'イソギンチャク' },
      { optionId: '3', text: 'ウミガメ' },
      { optionId: '4', text: 'ハリサザエ' },
    ],
  },
  {
    quizId: '569',
    question: '第5部より問題です。\nジョルノ・ジョバァーナの本名は？',
    options: [
      { optionId: '0', text: '汐華初流乃' },
      { optionId: '1', text: '潮華初瑠乃' },
      { optionId: '2', text: '汐花祥流乃' },
      { optionId: '3', text: '塩華初琉乃' },
      { optionId: '4', text: '潮華春埜' },
    ],
  },
  {
    quizId: '570',
    question:
      '第5部より問題です。\nジョルノ・ジョバァーナのスタンド、ゴールド・エクスペリエンスで康一のカバンは何にされた？',
    options: [
      { optionId: '0', text: 'カエル' },
      { optionId: '1', text: 'ヘビ' },
      { optionId: '2', text: 'ネズミ' },
      { optionId: '3', text: 'ハエ' },
      { optionId: '4', text: 'トカゲ' },
    ],
  },
  {
    quizId: '571',
    question:
      '第5部より問題です。\n涙目のルカの持っていたスコップに書かれていた文字は？',
    options: [
      { optionId: '0', text: 'S・P・Q・R' },
      { optionId: '1', text: 'R・U・K・A' },
      { optionId: '2', text: 'E・Y・E・S' },
      { optionId: '3', text: 'K・I・L・L' },
      { optionId: '4', text: 'B・A・C・K' },
    ],
  },
  {
    quizId: '572',
    question:
      '第5部より問題です。\n涙目のルカの語った「いい友情関係」に必要な3つの『U』、1つ目は？',
    options: [
      { optionId: '0', text: 'うそをつかない' },
      { optionId: '1', text: 'うらまない' },
      { optionId: '2', text: '敬う' },
      { optionId: '3', text: '裏切らない' },
      { optionId: '4', text: '後ろめたくならない' },
    ],
  },
  {
    quizId: '573',
    question:
      '第5部より問題です。\nジョルノがゴールド・エクスペリエンスで直接攻撃した初めての人間は？',
    options: [
      { optionId: '0', text: 'ブチャラティ' },
      { optionId: '1', text: 'ルカ' },
      { optionId: '2', text: '康一' },
      { optionId: '3', text: '父親' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '574',
    question: '第5部より問題です。\nゴールド・エクスペリエンスの持続力は？',
    options: [
      { optionId: '0', text: 'D' },
      { optionId: '1', text: 'A' },
      { optionId: '2', text: 'B' },
      { optionId: '3', text: 'C' },
      { optionId: '4', text: 'E' },
    ],
  },
  {
    quizId: '575',
    question:
      '第5部、ブチャラティの台詞より問題です。\n「「ウソ｣は言ってない皮膚と汗だ………\nやると言ったらやる………『○○』があるッ！」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'スゴ味' },
      { optionId: '1', text: '勇気' },
      { optionId: '2', text: '根性' },
      { optionId: '3', text: '覚悟' },
      { optionId: '4', text: '精神力' },
    ],
  },
  {
    quizId: '576',
    question:
      '第5部より問題です。\nブチャラティvsジョルノ戦で、スティッキィ・フィンガーズの能力でブチャラティが身体に入った人間の年齢は？',
    options: [
      { optionId: '0', text: '13歳' },
      { optionId: '1', text: '15歳' },
      { optionId: '2', text: '17歳' },
      { optionId: '3', text: '19歳' },
      { optionId: '4', text: '21歳' },
    ],
  },
  {
    quizId: '577',
    question:
      '第5部より問題です。\n「いいや あんたはもうぼくを殺したりはしませんね\nなぜならあんたはぼくの○○になるからだ」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '仲間' },
      { optionId: '1', text: '上司' },
      { optionId: '2', text: '部下' },
      { optionId: '3', text: '友人' },
      { optionId: '4', text: '同志' },
    ],
  },
  {
    quizId: '578',
    question: '第5部より問題です。\nスティッキィ・フィンガーズの精密動作性は？',
    options: [
      { optionId: '0', text: 'C' },
      { optionId: '1', text: 'A' },
      { optionId: '2', text: 'B' },
      { optionId: '3', text: 'D' },
      { optionId: '4', text: 'E' },
    ],
  },
  {
    quizId: '579',
    question: '第5部より問題です。\nブチャラティたちのいる組織の名は？',
    options: [
      { optionId: '0', text: 'パッショーネ' },
      { optionId: '1', text: 'マンマ・ファミリア' },
      { optionId: '2', text: 'ストラーツェ' },
      { optionId: '3', text: 'コンフィアンサ' },
      { optionId: '4', text: 'コンフィード' },
    ],
  },
  {
    quizId: '580',
    question:
      '第5部より問題です。\nジョルノが初めてポルポに会いに行った際、荷物を預けたボックスの番号は？',
    options: [
      { optionId: '0', text: '1A-68-2' },
      { optionId: '1', text: '1A-20-1' },
      { optionId: '2', text: '1B-5-2' },
      { optionId: '3', text: '1B-40-1' },
      { optionId: '4', text: '1C-37-1' },
    ],
  },
  {
    quizId: '581',
    question: '第5部より問題です。\nポルポの囚人番号は？',
    options: [
      { optionId: '0', text: 'N-28' },
      { optionId: '1', text: 'D-8' },
      { optionId: '2', text: 'F-15' },
      { optionId: '3', text: 'J-35' },
      { optionId: '4', text: 'P-9' },
    ],
  },
  {
    quizId: '582',
    question:
      '第5部より問題です。\nポルポの引用した\n『見えないところで友人の事をよく言ってる人こそ信頼できる』\nと言った17世紀の神学者は？',
    options: [
      { optionId: '0', text: 'フラー' },
      { optionId: '1', text: 'ロジャー' },
      { optionId: '2', text: 'ヨハン' },
      { optionId: '3', text: 'フルドリッヒ' },
      { optionId: '4', text: 'ジェルソン' },
    ],
  },
  {
    quizId: '583',
    question: '第5部より問題です。\nブラック・サバスのスピードは？',
    options: [
      { optionId: '0', text: 'A' },
      { optionId: '1', text: 'B' },
      { optionId: '2', text: 'C' },
      { optionId: '3', text: 'D' },
      { optionId: '4', text: 'E' },
    ],
  },
  {
    quizId: '584',
    question: '第5部より問題です。\nエコーズACT3の精密動作性は？',
    options: [
      { optionId: '0', text: 'C' },
      { optionId: '1', text: 'A' },
      { optionId: '2', text: 'B' },
      { optionId: '3', text: 'D' },
      { optionId: '4', text: 'E' },
    ],
  },
  {
    quizId: '585',
    question:
      '第5部、ポルポの台詞より問題です。\n「この世で最も大切な事は『信頼』であるのなら 最も忌むべき事は『○○』する事と考えている」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '侮辱' },
      { optionId: '1', text: '背信' },
      { optionId: '2', text: '嘲笑' },
      { optionId: '3', text: '反逆' },
      { optionId: '4', text: '無視' },
    ],
  },
  {
    quizId: '586',
    question:
      '第5部より問題です。\nポルポが拳銃で死んだのは、ジョルノと面会したどのくらい後のこと？',
    options: [
      { optionId: '0', text: '翌日の9時25分' },
      { optionId: '1', text: '1時間後' },
      { optionId: '2', text: '10時間後' },
      { optionId: '3', text: '2日後の10時' },
      { optionId: '4', text: '1週間後の夜' },
    ],
  },
  {
    quizId: '587',
    question:
      '第5部より問題です。\n『組織』の頂点にはボスがいる。\nその下に何人かの幹部たちがいる。\nボスと幹部の間にいる役職は？',
    options: [
      { optionId: '0', text: '参謀' },
      { optionId: '1', text: '幹部長' },
      { optionId: '2', text: '監察' },
      { optionId: '3', text: '総監' },
      { optionId: '4', text: '副ボス' },
    ],
  },
  {
    quizId: '588',
    question: '第5部より問題です。\n次の内、組織にないチームは？',
    options: [
      { optionId: '0', text: '観察' },
      { optionId: '1', text: '麻薬' },
      { optionId: '2', text: '暗殺' },
      { optionId: '3', text: '情報管理' },
      { optionId: '4', text: '護衛' },
    ],
  },
  {
    quizId: '589',
    question: '第5部より問題です。\n『16×55』\nナランチャの導き出した答えは？',
    options: [
      { optionId: '0', text: '28' },
      { optionId: '1', text: '880' },
      { optionId: '2', text: '16' },
      { optionId: '3', text: '83' },
      { optionId: '4', text: '680' },
    ],
  },
  {
    quizId: '590',
    question: '第5部より問題です。\n次の内、最も身長が高いのは？',
    options: [
      { optionId: '0', text: 'レオーネ・アバッキオ' },
      { optionId: '1', text: 'グイード・ミスタ' },
      { optionId: '2', text: 'ブローノ・ブチャラティ' },
      { optionId: '3', text: 'パンナコッタ・フーゴ' },
      { optionId: '4', text: 'ジョルノ・ジョバァーナ' },
    ],
  },
  {
    quizId: '591',
    question: '第5部より問題です。\n「ド低能がァ――ッ」\nこれは誰の台詞？',
    options: [
      { optionId: '0', text: 'パンナコッタ・フーゴ' },
      { optionId: '1', text: 'レオーネ・アバッキオ' },
      { optionId: '2', text: 'グイード・ミスタ' },
      { optionId: '3', text: 'ブローノ・ブチャラティ' },
      { optionId: '4', text: 'ナランチャ・ギルガ' },
    ],
  },
  {
    quizId: '592',
    question: '第5部より問題です。\n次の内、最年長は？',
    options: [
      { optionId: '0', text: 'レオーネ・アバッキオ' },
      { optionId: '1', text: 'グイード・ミスタ' },
      { optionId: '2', text: 'ナランチャ・ギルガ' },
      { optionId: '3', text: 'パンナコッタ・フーゴ' },
      { optionId: '4', text: 'ジョルノ・ジョバァーナ' },
    ],
  },
  {
    quizId: '593',
    question: '第5部より問題です。\n次の内、最年少は？',
    options: [
      { optionId: '0', text: 'ジョルノ・ジョバァーナ' },
      { optionId: '1', text: 'グイード・ミスタ' },
      { optionId: '2', text: 'ブローノ・ブチャラティ' },
      { optionId: '3', text: 'パンナコッタ・フーゴ' },
      { optionId: '4', text: 'レオーネ・アバッキオ' },
    ],
  },
];
